import { Ar as MinusIcon, El as AlertTriangleIcon, Gc as BoldIcon, Jr as ListBulletIcon, Kn as PlusIcon, M as XCircleIcon, Mi as ItalicIcon, Pi as InfoIcon, Qs as ChevronUpIcon, R as XIcon, S as DocumentsIcon, Yi as ImageIcon, Yr as ListNumbersIcon, Yt as SendIcon, Z as VideoIcon, ac as CheckIcon, ao as EyeIcon, cc as CheckCircleIcon, dl as ArrowRightIcon, go as DotsHorizontalIcon, hn as SearchIcon, ic as ChevronDownIcon, mt as UnderlineIcon, nc as ChevronRightIcon, oo as EyeHiddenIcon, ri as LinkIcon, sr as PencilIcon, tc as ChevronLeftIcon, wa as FolderIcon, yc as CalendarIcon } from "./icons-BxyjaHfi.mjs";
import React, { Children, createContext, forwardRef, isValidElement, useCallback, useContext, useEffect, useImperativeHandle, useMemo, useRef, useState } from "react";
import { DateFormatter, getLocalTimeZone, isToday } from "@internationalized/date";
import { defaultConfig, tv } from "tailwind-variants";
import { Fragment as Fragment$1, jsx, jsxs } from "react/jsx-runtime";
import { Breadcrumb, Breadcrumbs, Button, Calendar, CalendarCell, CalendarGrid, CalendarGridBody, CalendarGridHeader, CalendarHeaderCell, CalendarStateContext, Cell, Checkbox, CheckboxGroup, Collection, ColorArea, ColorField, ColorPicker, ColorSlider, ColorSwatch, ColorSwatchPicker, ColorSwatchPickerItem, ColorThumb, Column, ComboBox, ComboBoxStateContext, DEFAULT_SLOT, DateInput, DatePicker, DateRangePicker, DateSegment, Dialog, DialogTrigger, Disclosure, DisclosureGroup, DisclosurePanel, DropZone, FieldError, FieldErrorContext, FileTrigger, GridList, GridListItem, Group, Header, Heading, HeadingContext, Input, Label, Link, ListBox, ListBoxItem, ListBoxSection, Menu, MenuItem, MenuTrigger, Modal, ModalOverlay, NumberField, OverlayArrow, Popover, ProgressBar, Provider, Radio, RadioGroup, RangeCalendar, ResizableTableContainer, RouterProvider, Row, Select, SelectValue, SliderOutput, SliderTrack, Switch, Tab, TabList, TabListStateContext, TabPanel, Table, TableBody, TableHeader, TableLayout, Tabs, Tag, TagGroup, TagGroupContext, TagList, Text, TextArea, TextField, TimeField, ToggleButton, ToggleButtonContext, Tooltip, TooltipTrigger, Virtualizer, parseColor, useContextProps, useTableOptions } from "react-aria-components";
import { extendTailwindMerge, twJoin } from "tailwind-merge";
import { useDateFormatter, useId, useNumberFormatter, useToast, useToastRegion } from "react-aria";
import { isFragment } from "react-is";
import { debounce } from "lodash";
import { useResizeObserver, useWindowSize } from "usehooks-ts";
import InputMask from "react-input-mask";
import lottie from "lottie-web/build/player/lottie_light";
import { AnimatePresence, motion, useDragControls, useReducedMotion } from "framer-motion";
import { createPortal } from "react-dom";
import { isValidPhoneNumber } from "libphonenumber-js/max";
import { FlagImage, defaultCountries, parseCountry, usePhoneInput } from "react-international-phone";
import { AutoFocusPlugin } from "@lexical/react/LexicalAutoFocusPlugin";
import { ClearEditorPlugin } from "@lexical/react/LexicalClearEditorPlugin";
import { LexicalComposer } from "@lexical/react/LexicalComposer";
import { ContentEditable } from "@lexical/react/LexicalContentEditable";
import { LexicalErrorBoundary } from "@lexical/react/LexicalErrorBoundary";
import { HistoryPlugin } from "@lexical/react/LexicalHistoryPlugin";
import { LinkPlugin } from "@lexical/react/LexicalLinkPlugin";
import { ListPlugin } from "@lexical/react/LexicalListPlugin";
import { MarkdownShortcutPlugin } from "@lexical/react/LexicalMarkdownShortcutPlugin";
import { RichTextPlugin } from "@lexical/react/LexicalRichTextPlugin";
import { $isLinkNode, AutoLinkNode, LinkNode, TOGGLE_LINK_COMMAND } from "@lexical/link";
import { $getNearestNodeOfType, $restoreEditorState, mergeRegister } from "@lexical/utils";
import { $getRoot, $getSelection, $insertNodes, $isRangeSelection, CLEAR_EDITOR_COMMAND, FORMAT_TEXT_COMMAND, RootNode, SELECTION_CHANGE_COMMAND } from "lexical";
import { CodeHighlightNode, CodeNode } from "@lexical/code";
import { createHeadlessEditor } from "@lexical/headless";
import { $generateHtmlFromNodes, $generateNodesFromDOM } from "@lexical/html";
import { $isListNode, INSERT_ORDERED_LIST_COMMAND, INSERT_UNORDERED_LIST_COMMAND, ListItemNode, ListNode, REMOVE_LIST_COMMAND } from "@lexical/list";
import { $convertFromMarkdownString, $convertToMarkdownString, BOLD_ITALIC_STAR, BOLD_STAR, ITALIC_STAR, ORDERED_LIST, TEXT_MATCH_TRANSFORMERS, UNORDERED_LIST } from "@lexical/markdown";
import { $isHeadingNode, HeadingNode, QuoteNode } from "@lexical/rich-text";
import { $isAtNodeEnd, trimTextContentFromAnchor } from "@lexical/selection";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { OnChangePlugin } from "@lexical/react/LexicalOnChangePlugin";
import { ToastQueue, useToastQueue } from "react-stately";
import { Transition } from "@headlessui/react";
//#region src/negroni/Logo/Assist/AssistLogo.tsx
function AssistLogo() {
	return /* @__PURE__ */ jsxs("svg", {
		viewBox: "0 0 75 20",
		fill: "none",
		children: [
			/* @__PURE__ */ jsx("rect", {
				width: "74.4975",
				height: "20",
				rx: "4",
				fill: "currentColor"
			}),
			/* @__PURE__ */ jsx("g", {
				clipPath: "url(#clip0_4107_28005)",
				children: /* @__PURE__ */ jsx("path", {
					fillRule: "evenodd",
					clipRule: "evenodd",
					d: "M10.8183 15.1835C11.1288 15.4206 11.4845 15.6917 11.9419 15.6917H11.9362C12.3935 15.6917 12.7493 15.4206 13.0598 15.1835C13.0831 15.1664 13.1064 15.1491 13.1296 15.1319C13.2751 15.0238 13.4172 14.9184 13.5341 14.8843C13.6809 14.8391 13.9067 14.8447 14.1213 14.856C14.5108 14.873 14.9456 14.8899 15.3069 14.6358C15.6739 14.3818 15.8094 13.9583 15.928 13.5857C15.9901 13.3824 16.0579 13.1735 16.1482 13.0549C16.2332 12.9434 16.3983 12.8318 16.5633 12.7202C16.5736 12.7132 16.584 12.7062 16.5943 12.6992C16.9217 12.4847 17.2944 12.2363 17.4412 11.8072C17.5789 11.3996 17.4425 10.9974 17.3205 10.6372C17.3174 10.6282 17.3144 10.6192 17.3113 10.6102C17.2323 10.3957 17.1645 10.1924 17.1645 10.0343C17.1645 9.88613 17.229 9.69828 17.2975 9.49864C17.3021 9.48528 17.3067 9.47187 17.3113 9.45841C17.4412 9.09706 17.5823 8.67925 17.4412 8.26144C17.2944 7.83234 16.9217 7.58391 16.5943 7.36936C16.584 7.36239 16.5736 7.35542 16.5633 7.34844C16.3983 7.23685 16.2332 7.12526 16.1482 7.01366C16.0579 6.8951 15.9901 6.68619 15.928 6.48293C15.8094 6.11029 15.6739 5.69248 15.3069 5.43277C14.9456 5.17869 14.5052 5.19563 14.1213 5.21257C13.9067 5.22386 13.6809 5.22951 13.5341 5.18434C13.4042 5.13917 13.2292 5.00931 13.0654 4.8851C12.7549 4.64796 12.3992 4.37695 11.9419 4.37695C11.4845 4.37695 11.1288 4.64796 10.8183 4.8851C10.8035 4.89635 10.7886 4.90769 10.7737 4.91905C10.6241 5.03307 10.4729 5.1484 10.3497 5.18434C10.216 5.22547 10.0168 5.21978 9.82023 5.21418C9.80092 5.21362 9.78165 5.21307 9.76246 5.21257C9.37288 5.19563 8.93813 5.17869 8.57677 5.43277C8.20978 5.68684 8.07427 6.11029 7.9557 6.48293C7.89359 6.68619 7.82584 6.8951 7.7355 7.01366C7.65048 7.12526 7.48543 7.23685 7.32039 7.34844C7.31007 7.35542 7.29976 7.36239 7.28946 7.36936C6.96199 7.58391 6.58934 7.83234 6.44254 8.26144C6.30485 8.66902 6.44117 9.07123 6.56325 9.43137C6.56631 9.44041 6.56936 9.44942 6.5724 9.45841C6.65145 9.67296 6.7192 9.87621 6.7192 10.0343C6.7192 10.1825 6.65473 10.3703 6.5862 10.57C6.58162 10.5833 6.57701 10.5967 6.5724 10.6102C6.44254 10.9715 6.30139 11.3894 6.44254 11.8072C6.58934 12.2363 6.96199 12.4847 7.28946 12.6992C7.29976 12.7062 7.31008 12.7132 7.32039 12.7202C7.48544 12.8318 7.65048 12.9434 7.7355 13.0549C7.82584 13.1735 7.89359 13.3824 7.9557 13.5857C8.07427 13.9583 8.20978 14.3761 8.57677 14.6358C8.93813 14.8899 9.37852 14.873 9.76246 14.856C9.97701 14.8447 10.2029 14.8391 10.3497 14.8843C10.4795 14.9294 10.6545 15.0593 10.8183 15.1835ZM13.5571 7.9023C13.5571 7.01378 12.8313 6.288 11.9428 6.288C11.0543 6.288 10.3285 7.01378 10.3285 7.9023C10.3285 8.79081 11.0543 9.51659 11.9428 9.51659C12.8313 9.51659 13.5571 8.79081 13.5571 7.9023ZM11.9363 14.1674C13.1682 14.1674 14.2682 13.606 14.994 12.7175C15.1177 12.5743 15.1584 12.3888 15.1177 12.2049L14.9875 11.65C14.7743 10.7257 13.933 10.1789 12.9485 10.1789H10.9241C9.95908 10.1789 9.09659 10.7192 8.88504 11.65L8.75486 12.2049C8.72068 12.3823 8.75486 12.5743 8.87853 12.7175C9.60432 13.5995 10.7044 14.1674 11.9363 14.1674Z",
					fill: "#252424"
				})
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M26.3076 6.15527H25.5551C25.3051 6.15527 25.0776 6.30527 24.9801 6.53527L22.0301 13.4678C21.9251 13.7153 22.1076 13.9903 22.3751 13.9903H23.1326C23.3876 13.9903 23.6151 13.8353 23.7101 13.6003L25.7926 8.49527C25.8351 8.39277 25.9826 8.39027 26.0251 8.49527L26.8726 10.5628C26.9051 10.6453 26.8451 10.7353 26.7576 10.7353H25.8551C25.6526 10.7353 25.4701 10.8578 25.3926 11.0453L25.1126 11.7278C25.0126 11.9753 25.1926 12.2453 25.4601 12.2453H27.3876C27.4901 12.2453 27.5801 12.3078 27.6201 12.4003L28.1101 13.6003C28.2051 13.8353 28.4351 13.9903 28.6901 13.9903H29.4926C29.7626 13.9903 29.9426 13.7153 29.8376 13.4678L26.8826 6.53527C26.7851 6.30527 26.5576 6.15527 26.3076 6.15527Z",
				fill: "#252424"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M35.4184 9.2325C34.0734 8.8875 33.7409 8.7225 33.7409 8.21V8.1875C33.7409 7.81 34.0859 7.51 34.7409 7.51C35.3009 7.51 35.8784 7.7225 36.4659 8.0825C36.6359 8.1875 36.8584 8.14 36.9709 7.9775L37.4459 7.29C37.5634 7.1175 37.5209 6.8825 37.3484 6.765C36.6184 6.2725 35.7559 6 34.7634 6C33.1734 6 32.0409 6.9325 32.0409 8.345V8.3675C32.0409 9.9125 33.0509 10.345 34.6184 10.745C35.9184 11.0775 36.1859 11.3 36.1859 11.735V11.7575C36.1859 12.2125 35.7634 12.49 35.0634 12.49C34.2909 12.49 33.6334 12.2125 33.0159 11.76C32.8584 11.645 32.6359 11.6725 32.5109 11.8225L31.9734 12.465C31.8359 12.63 31.8634 12.8775 32.0334 13.005C32.9134 13.67 33.9759 14 35.0284 14C36.7059 14 37.8834 13.1325 37.8834 11.5875V11.565C37.8834 10.21 36.9934 9.6425 35.4159 9.2325H35.4184Z",
				fill: "#252424"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M43.8686 9.2325C42.5236 8.8875 42.1911 8.7225 42.1911 8.21V8.1875C42.1911 7.81 42.5361 7.51 43.1911 7.51C43.7511 7.51 44.3286 7.7225 44.9161 8.0825C45.0861 8.1875 45.3086 8.14 45.4211 7.9775L45.8961 7.29C46.0136 7.1175 45.9711 6.8825 45.7986 6.765C45.0686 6.2725 44.2061 6 43.2136 6C41.6236 6 40.4911 6.9325 40.4911 8.345V8.3675C40.4911 9.9125 41.5011 10.345 43.0686 10.745C44.3686 11.0775 44.6361 11.3 44.6361 11.735V11.7575C44.6361 12.2125 44.2136 12.49 43.5136 12.49C42.7411 12.49 42.0836 12.2125 41.4661 11.76C41.3086 11.645 41.0861 11.6725 40.9611 11.8225L40.4236 12.465C40.2861 12.63 40.3136 12.8775 40.4836 13.005C41.3636 13.67 42.4261 14 43.4786 14C45.1561 14 46.3336 13.1325 46.3336 11.5875V11.565C46.3336 10.21 45.4436 9.6425 43.8661 9.2325H43.8686Z",
				fill: "#252424"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M57.39 9.2325C56.0451 8.8875 55.7126 8.7225 55.7126 8.21V8.1875C55.7126 7.81 56.0576 7.51 56.7126 7.51C57.2726 7.51 57.85 7.7225 58.4375 8.0825C58.6075 8.1875 58.83 8.14 58.9425 7.9775L59.4175 7.29C59.535 7.1175 59.4925 6.8825 59.32 6.765C58.59 6.2725 57.7275 6 56.7351 6C55.1451 6 54.0126 6.9325 54.0126 8.345V8.3675C54.0126 9.9125 55.0226 10.345 56.5901 10.745C57.89 11.0775 58.1575 11.3 58.1575 11.735V11.7575C58.1575 12.2125 57.735 12.49 57.0351 12.49C56.2626 12.49 55.6051 12.2125 54.9876 11.76C54.8301 11.645 54.6076 11.6725 54.4826 11.8225L53.9451 12.465C53.8076 12.63 53.8351 12.8775 54.0051 13.005C54.8851 13.67 55.9476 14 57.0001 14C58.6775 14 59.855 13.1325 59.855 11.5875V11.565C59.855 10.21 58.965 9.6425 57.3876 9.2325H57.39Z",
				fill: "#252424"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M62.4248 7.68297C62.2173 7.68297 62.0498 7.51547 62.0498 7.30797L62.0523 6.48047C62.0523 6.27297 62.2198 6.10547 62.4273 6.10547H68.1223C68.3298 6.10547 68.4973 6.27297 68.4973 6.48047V7.30797C68.4973 7.51547 68.3298 7.68297 68.1223 7.68297H66.3173C66.2148 7.68297 66.1298 7.76797 66.1298 7.87047V13.5105C66.1298 13.718 65.9623 13.8855 65.7548 13.8855H64.7923C64.5848 13.8855 64.4173 13.718 64.4173 13.5105V7.87047C64.4173 7.76797 64.3323 7.68297 64.2298 7.68297H62.4248Z",
				fill: "#252424"
			}),
			/* @__PURE__ */ jsx("path", {
				d: "M49.6016 6.10547H50.5591C50.7666 6.10547 50.9341 6.27297 50.9341 6.48047V13.5155C50.9341 13.723 50.7666 13.8905 50.5591 13.8905H49.6016C49.3941 13.8905 49.2266 13.723 49.2266 13.5155V6.48047C49.2266 6.27297 49.3941 6.10547 49.6016 6.10547Z",
				fill: "#252424"
			}),
			/* @__PURE__ */ jsx("defs", { children: /* @__PURE__ */ jsx("clipPath", {
				id: "clip0_4107_28005",
				children: /* @__PURE__ */ jsx("rect", {
					width: "12",
					height: "12",
					fill: "white",
					transform: "translate(6 4)"
				})
			}) })
		]
	});
}
//#endregion
//#region src/negroni/Logo/LegalZoom/Books.tsx
/**
* Books logo and this is NOT to be accessed directly.
* Please use the Logo component for any of the logo requirements.
* @returns Books SVG logo
*/
function Books() {
	return /* @__PURE__ */ jsx("svg", {
		viewBox: "0 0 64 24",
		children: /* @__PURE__ */ jsx("path", { d: "M7.17 12.378V4.642A.643.643 0 0 0 6.525 4h-1.88A.643.643 0 0 0 4 4.642V14.74c0 .355.288.642.645.642H9.76c.307 0 .6-.13.804-.36l1.598-1.788a.321.321 0 0 0-.24-.535H7.494a.322.322 0 0 1-.325-.321Zm24.754-.383v-.02c0-1.893 1.5-3.443 3.566-3.443 2.064 0 3.546 1.533 3.546 3.424v.02c0 1.891-1.5 3.442-3.566 3.442-2.064 0-3.546-1.532-3.546-3.423Zm5.572 0v-.02c0-1.14-.84-2.092-2.026-2.092-1.185 0-2.006.933-2.006 2.073v.02c0 1.14.84 2.092 2.026 2.092 1.185 0 2.006-.933 2.006-2.073Zm-12.085-3.35h3.108c.766 0 1.368.21 1.748.591.306.304.459.677.459 1.132v.02c0 .75-.402 1.17-.88 1.435.774.296 1.252.743 1.252 1.637v.02c0 1.217-.994 1.825-2.506 1.825H25.41v-6.66h.002Zm2.792 2.693c.65 0 1.06-.21 1.06-.704v-.02c0-.436-.344-.684-.966-.684h-1.454v1.408h1.36Zm.391 2.681c.65 0 1.041-.229 1.041-.723v-.02c0-.447-.335-.723-1.09-.723h-1.702v1.464h1.751v.002Zm11.348-2.044v.02c0 1.891 1.482 3.424 3.546 3.424 2.065 0 3.566-1.552 3.566-3.444v-.019c0-1.891-1.482-3.424-3.546-3.424-2.065 0-3.566 1.55-3.566 3.443Zm5.575 0v.02c0 1.14-.824 2.073-2.007 2.073-1.185 0-2.026-.952-2.026-2.093v-.019c0-1.14.822-2.073 2.007-2.073s2.026.952 2.026 2.092Zm2.785-3.33h1.473v2.911l2.715-2.91h1.778l-2.725 2.824 2.85 3.833h-1.768l-2.075-2.835-.775.798V15.3h-1.473V8.646Zm7.272 4.653-.87 1.036a4.287 4.287 0 0 0 2.84 1.067c1.443 0 2.456-.742 2.456-2.065v-.019c0-1.16-.766-1.646-2.123-1.996-1.157-.296-1.443-.44-1.443-.876v-.019c0-.323.297-.58.86-.58.564 0 1.147.248 1.74.657L59.8 9.4c-.68-.544-1.512-.847-2.486-.847-1.368 0-2.343.798-2.343 2.007v.02c0 1.321.87 1.692 2.218 2.034 1.118.287 1.349.477 1.349.848v.019c0 .39-.364.627-.966.627-.766 0-1.396-.315-1.998-.81ZM12.74 8.618h6.872c.354 0 .645.289.645.644v1.243c0 .261-.097.514-.271.71L14.84 16.98a.214.214 0 0 0 .161.355h4.71c.358 0 .646.287.646.642v1.382a.643.643 0 0 1-.645.642h-8.924a.643.643 0 0 1-.645-.642v-1.243c0-.261.096-.514.27-.71l5.147-5.763a.214.214 0 0 0-.16-.356h-4.806a.321.321 0 0 1-.24-.535l1.582-1.774c.205-.229.497-.36.805-.36Z" })
	});
}
//#endregion
//#region src/negroni/Logo/LegalZoom/Default.tsx
/**
* LegalZoom logo and this is NOT to be accessed directly.
* Please use the Logo component for any of the logo requirements.
* @returns LegalZoom SVG logo
*/
function Default() {
	return /* @__PURE__ */ jsxs("svg", {
		viewBox: "0 0 108 24",
		children: [
			/* @__PURE__ */ jsx("path", { d: "M23.838 9.754v.031c0 3.352 2.643 5.723 6.183 5.723a7.828 7.828 0 0 0 4.479-1.37c.284-.196.453-.514.453-.854V9.447a.632.632 0 0 0-.64-.624h-3.944a.632.632 0 0 0-.64.624v.997c0 .345.286.624.64.624h1.279c.177 0 .32.14.32.312v.66c0 .24-.14.467-.367.565-.4.175-.873.264-1.45.264-1.802 0-3.082-1.279-3.082-3.066v-.031c0-1.691 1.265-3.035 2.903-3.035.903 0 1.603.245 2.267.688a.659.659 0 0 0 .867-.106l1.035-1.213a.614.614 0 0 0-.11-.903C32.943 4.441 31.662 4 29.954 4c-3.52 0-6.116 2.53-6.116 5.754ZM4.714 4.223H6.58a.63.63 0 0 1 .64.62v7.524c0 .173.144.312.32.312h4.377c.355 0 .64.28.64.624v1.361a.632.632 0 0 1-.64.624H4.714a.632.632 0 0 1-.64-.624V4.847c0-.345.286-.624.64-.624ZM14.45 4.223h7.465c.354 0 .64.279.64.624v1.36a.632.632 0 0 1-.64.625h-4.671c-.177 0-.32.139-.32.312v1.052c0 .173.143.312.32.312h4.103c.354 0 .64.28.64.624v1.172a.632.632 0 0 1-.64.624h-4.103c-.177 0-.32.14-.32.312v1.131c0 .173.143.313.32.313h4.752c.355 0 .64.278.64.624v1.36a.632.632 0 0 1-.64.624H14.45a.632.632 0 0 1-.64-.624V4.847c0-.345.286-.624.64-.624Z" }),
			/* @__PURE__ */ jsx("path", { d: "M40.717 4.143h1.618c.43 0 .816.25.984.635l4.182 9.642c.18.412-.132.868-.589.868h-1.69a1.07 1.07 0 0 1-.989-.647l-.448-1.07a.428.428 0 0 0-.395-.258h-3.805a.43.43 0 0 0-.397.262l-.435 1.062a1.067 1.067 0 0 1-.99.653h-1.621c-.46 0-.769-.456-.59-.868l4.183-9.642c.166-.387.553-.637.982-.637Zm1.936 6.497L41.7 8.27c-.07-.175-.327-.177-.397 0l-.965 2.371a.208.208 0 0 0 .198.285h1.92a.208.208 0 0 0 .198-.285Z" }),
			/* @__PURE__ */ jsx("path", { d: "M51.673 4.847v7.52c0 .173.143.312.322.312h4.394c.275 0 .423.319.24.52l-1.587 1.74a1.08 1.08 0 0 1-.799.35h-5.076a.632.632 0 0 1-.64-.625V4.847c0-.345.285-.624.64-.624h1.866c.354 0 .64.279.64.624Z" }),
			/* @__PURE__ */ jsx("path", { d: "M65.001 14.277v-.031c0-3.177 2.628-5.754 6.131-5.754 3.504 0 6.1 2.544 6.1 5.723v.03c0 3.178-2.628 5.755-6.132 5.755-3.505 0-6.099-2.544-6.099-5.723Zm9.02 0v-.031c0-1.596-1.185-2.988-2.92-2.988-1.72 0-2.872 1.361-2.872 2.957v.03c0 1.596 1.185 2.988 2.903 2.988 1.736 0 2.889-1.358 2.889-2.956ZM78.378 14.246v.031c0 3.179 2.596 5.723 6.1 5.723 3.503 0 6.13-2.578 6.13-5.754v-.031c0-3.18-2.595-5.723-6.098-5.723-3.504 0-6.132 2.577-6.132 5.754Zm9.02 0v.031c0 1.598-1.15 2.956-2.888 2.956-1.719 0-2.904-1.392-2.904-2.987v-.031c0-1.596 1.153-2.957 2.872-2.957 1.735 0 2.92 1.392 2.92 2.988Z" }),
			/* @__PURE__ */ jsx("path", { d: "M95.331 14.04c-.115-.173-.393-.094-.393.114v5.001a.632.632 0 0 1-.64.624h-1.802a.632.632 0 0 1-.64-.624v-9.82c0-.344.286-.623.64-.623h2.09c.371 0 .715.187.91.495l2.213 3.501c.084.131.28.131.363 0l2.214-3.501c.194-.308.538-.495.91-.495h2.09c.354 0 .64.279.64.624v9.817a.631.631 0 0 1-.64.624h-1.851a.632.632 0 0 1-.641-.624V14.12c0-.206-.275-.287-.393-.115l-2.275 3.395a.324.324 0 0 1-.536 0L95.33 14.04ZM57.203 8.712h6.82c.353 0 .64.28.64.626v1.209c0 .253-.095.499-.268.69l-5.109 5.603c-.122.133-.023.345.16.345h4.676c.354 0 .64.279.64.624v1.344a.632.632 0 0 1-.64.624h-8.858a.632.632 0 0 1-.64-.624v-1.209c0-.253.096-.499.268-.69l5.11-5.603c.121-.133.023-.345-.16-.345h-4.77c-.276 0-.423-.318-.24-.52l1.572-1.725a1.08 1.08 0 0 1 .798-.35Z" })
		]
	});
}
//#endregion
//#region src/negroni/Logo/LegalZoom/LegalServices.tsx
/**
* Legal services logo and this is NOT to be accessed directly.
* Please use the Logo component for any of the logo requirements.
* @returns Legal services SVG logo
*/
function LegalServices() {
	return /* @__PURE__ */ jsxs("svg", {
		viewBox: "0 0 112 24",
		children: [
			/* @__PURE__ */ jsx("path", { d: "M7.232 12.379V4.642A.641.641 0 0 0 6.59 4H4.72a.641.641 0 0 0-.642.642v10.097c0 .355.287.642.642.642h5.088c.306 0 .597-.13.8-.36l1.59-1.789a.322.322 0 0 0-.24-.534H7.555a.318.318 0 0 1-.323-.32ZM37.067 11.974v.02c0 1.968 1.427 3.423 3.498 3.42a4.321 4.321 0 0 0 2.843-1.054v-2.89h-2.89v1.266h1.474v.95c-.37.268-.845.4-1.378.4-1.179 0-2.015-.894-2.015-2.112v-.019c0-1.132.845-2.073 1.91-2.073.77 0 1.226.248 1.74.676l.922-1.113c-.693-.59-1.416-.913-2.615-.913-2.015 0-3.49 1.549-3.49 3.442ZM25.376 8.645h1.465v5.325h3.319v1.331h-4.784V8.645ZM31.101 8.645h5.022v1.303h-3.567v1.35h3.14v1.303h-3.14v1.397h3.614v1.303h-5.069V8.645Z" }),
			/* @__PURE__ */ jsx("path", { d: "M46.913 8.598h1.35l2.852 6.706h-1.532l-.607-1.494H46.16l-.608 1.494H44.06l2.854-6.706Zm1.54 3.918-.883-2.16-.884 2.16h1.768Z" }),
			/* @__PURE__ */ jsx("path", { d: "M53.492 8.645h-1.465v6.656h4.784v-1.33h-3.319V8.645ZM60.31 14.332l.864-1.035c.599.494 1.226.808 1.987.808.6 0 .96-.237.96-.627v-.019c0-.37-.228-.56-1.34-.847-1.342-.342-2.206-.713-2.206-2.035v-.02c0-1.208.969-2.006 2.33-2.006.969 0 1.797.304 2.473.847l-.762 1.104c-.59-.408-1.17-.657-1.73-.657-.561 0-.857.257-.857.58v.02c0 .436.285.58 1.436.875 1.35.35 2.112.836 2.112 1.996v.02c0 1.321-1.008 2.064-2.444 2.064a4.24 4.24 0 0 1-2.824-1.068ZM71.842 8.645H66.82v6.656h5.069v-1.303h-3.614v-1.397h3.139v-1.303h-3.14v-1.35h3.568V8.645Z" }),
			/* @__PURE__ */ jsx("path", { d: "M76.277 8.645c.847 0 1.502.238 1.94.676.37.37.572.895.572 1.521v.02c0 1.074-.58 1.75-1.427 2.064l1.626 2.377h-1.712l-1.427-2.13h-1.151v2.13h-1.466V8.645h3.045Zm-.094 3.233c.712 0 1.123-.38 1.123-.941v-.02c0-.627-.436-.95-1.15-.95H74.7v1.911h1.483Z" }),
			/* @__PURE__ */ jsx("path", { d: "M80.86 8.645h-1.617l2.691 6.706h1.293l2.691-6.706H84.34l-1.74 4.688-1.739-4.688ZM86.86 8.645h1.463v6.656H86.86V8.645ZM89.592 11.974v.02c0 1.91 1.455 3.423 3.412 3.425 1.284 0 2.046-.458 2.73-1.19l-.932-.94c-.524.474-.989.778-1.75.778-1.14 0-1.93-.952-1.93-2.093v-.019c0-1.14.806-2.073 1.93-2.073.667 0 1.19.284 1.703.75l.933-1.073c-.619-.608-1.37-1.027-2.626-1.027-2.043 0-3.47 1.549-3.47 3.442ZM96.764 8.645h5.021v1.303h-3.566v1.35h3.139v1.303h-3.14v1.397h3.615v1.303h-5.07V8.645ZM103.519 13.297l-.865 1.035a4.242 4.242 0 0 0 2.824 1.068c1.436 0 2.444-.743 2.444-2.065v-.02c0-1.159-.762-1.644-2.112-1.995-1.151-.296-1.436-.439-1.436-.876v-.019c0-.323.296-.58.856-.58.561 0 1.141.249 1.731.657l.762-1.104c-.676-.543-1.504-.847-2.474-.847-1.36 0-2.33.798-2.33 2.007v.02c0 1.321.865 1.692 2.206 2.034 1.113.287 1.342.477 1.342.847v.02c0 .389-.362.626-.961.626-.761 0-1.388-.314-1.987-.808ZM12.774 8.62h6.833c.356 0 .642.286.644.643v1.244c0 .26-.096.513-.27.71l-5.12 5.762a.214.214 0 0 0 .161.355h4.686c.355 0 .642.287.642.642v1.382a.641.641 0 0 1-.642.642h-8.877a.641.641 0 0 1-.642-.642v-1.243c0-.261.096-.513.27-.71l5.12-5.762a.214.214 0 0 0-.161-.355h-4.78a.322.322 0 0 1-.24-.535l1.575-1.774a1.07 1.07 0 0 1 .8-.36Z" })
		]
	});
}
//#endregion
//#region src/negroni/Logo/LegalZoom/Mark.tsx
/**
* Mark logo and this is NOT to be accessed directly.
* Please use the Logo component for any of the logo requirements.
* @returns Mark SVG logo
*/
function Mark() {
	return /* @__PURE__ */ jsx("svg", {
		viewBox: "0 0 24 24",
		children: /* @__PURE__ */ jsx("path", { d: "M7.101 4.642v7.737l.002-.002c0 .177.141.32.316.32h4.33c.271 0 .416.328.235.535l-1.563 1.79c-.2.228-.486.358-.787.358H4.631A.636.636 0 0 1 4 14.74V4.642C4 4.287 4.282 4 4.631 4H6.47c.35 0 .631.287.631.642Zm5.45 3.978h6.721v.002c.35 0 .631.286.631.642v1.243c0 .26-.094.513-.265.71l-5.034 5.762c-.12.137-.023.355.157.355h4.608c.35 0 .631.287.631.642v1.382a.636.636 0 0 1-.631.642H10.64a.636.636 0 0 1-.631-.642v-1.243c0-.26.095-.513.265-.71l5.035-5.762c.12-.137.023-.355-.158-.355h-4.7c-.272 0-.417-.328-.236-.535l1.548-1.774c.2-.229.486-.36.787-.36Z" })
	});
}
//#endregion
//#region src/negroni/Logo/LegalZoom/Tax.tsx
/**
* Tax logo and this is NOT to be accessed directly.
* Please use the Logo component for any of the logo requirements.
* @returns Tax SVG logo
*/
function Tax() {
	return /* @__PURE__ */ jsx("svg", {
		viewBox: "0 0 48 24",
		children: /* @__PURE__ */ jsx("path", { d: "M7.557 12.379V4.642A.641.641 0 0 0 6.915 4h-1.87a.641.641 0 0 0-.642.642v10.097c0 .355.287.642.642.642h5.088c.306 0 .597-.13.8-.36l1.59-1.789a.322.322 0 0 0-.24-.534H7.88a.318.318 0 0 1-.323-.32Zm19.725-2.422H25.23V8.59h5.589v1.367h-2.052v5.434h-1.485V9.957Zm5.854-1.359h1.367l2.794 6.565 2.196-3.225L37.238 8.6h1.735l1.406 2.202L41.814 8.6H43.5l-2.255 3.319 2.352 3.473h-1.733l-1.513-2.328-1.524 2.328h-2.984l-.617-1.513h-2.852l-.616 1.513h-1.512l2.89-6.794Zm1.562 3.97-.896-2.188-.897 2.187h1.793Zm-21.6-3.948h6.835c.355 0 .642.286.644.644v1.243c0 .26-.097.513-.27.71l-5.12 5.762a.214.214 0 0 0 .16.355h4.686c.355 0 .642.287.642.642v1.382a.641.641 0 0 1-.642.642h-8.877a.641.641 0 0 1-.642-.642v-1.243c0-.26.096-.513.27-.71l5.12-5.762a.214.214 0 0 0-.16-.355h-4.78a.322.322 0 0 1-.24-.535l1.575-1.774a1.07 1.07 0 0 1 .8-.36Z" })
	});
}
//#endregion
//#region src/negroni/Logo/LegalZoom/VirtualMail.tsx
/**
* Virtual mail logo and this is NOT to be accessed directly.
* Please use the Logo component for any of the logo requirements.
* @returns Virtual mail SVG logo
*/
function VirtualMail() {
	return /* @__PURE__ */ jsxs("svg", {
		viewBox: "0 0 98 24",
		children: [
			/* @__PURE__ */ jsx("path", { d: "M7.3 12.379V4.642A.641.641 0 0 0 6.656 4h-1.87a.641.641 0 0 0-.641.642v10.097c0 .355.286.641.641.641h5.088c.306 0 .597-.13.8-.359l1.59-1.789a.322.322 0 0 0-.24-.535H7.623a.318.318 0 0 1-.323-.318Z" }),
			/* @__PURE__ */ jsx("path", { d: "M80.762 8.617h1.395l2.884 6.772h-1.553l-.618-1.515h-2.857l-.618 1.515H77.88l2.882-6.772Zm1.577 3.943-.896-2.19-.897 2.19h1.793Z" }),
			/* @__PURE__ */ jsx("path", { d: "M24.874 8.622h1.641l1.765 4.758 1.765-4.758h1.603l-2.73 6.803h-1.312l-2.732-6.803ZM32.497 8.622h1.487v6.754h-1.487V8.622Z" }),
			/* @__PURE__ */ jsx("path", { d: "M38.856 8.622H35.77v6.756h1.483v-2.16h1.168l1.448 2.16h1.738l-1.65-2.413c.86-.319 1.448-1.004 1.448-2.095v-.019c0-.638-.203-1.168-.58-1.545-.442-.443-1.11-.684-1.968-.684Zm1.044 2.325c0 .572-.415.957-1.138.957h-1.506V9.963h1.476c.723 0 1.168.327 1.168.965v.02Z" }),
			/* @__PURE__ */ jsx("path", { d: "M43.961 9.993h-2.054v-1.37h5.597v1.37h-2.056v5.385h-1.487V9.993ZM48.18 8.622v3.861c0 1.988 1.111 3 2.925 3 1.815 0 2.964-1.003 2.964-3.049V8.622h-1.487v3.868c0 1.072-.55 1.622-1.457 1.622-.908 0-1.458-.57-1.458-1.67v-3.82h-1.486ZM62.283 8.622h1.487v5.404h3.367v1.35h-4.854V8.622ZM72.041 8.622H70.44v6.756h1.457v-4.382l1.883 2.857h.038l1.902-2.886v4.41h1.477V8.621h-1.603l-1.776 2.856-1.776-2.856Z" }),
			/* @__PURE__ */ jsx("path", { d: "M58.72 8.617h-1.395l-2.882 6.772h1.515l.618-1.515h2.857l.618 1.515h1.553L58.72 8.617Zm-.717 1.752.897 2.191h-1.793l.896-2.19Z" }),
			/* @__PURE__ */ jsx("path", { d: "M85.728 8.622h1.487v6.754h-1.487V8.622ZM90.487 8.622H89v6.754h4.854v-1.35h-3.367V8.622ZM12.84 8.62h6.835c.355 0 .642.286.644.643v1.244c0 .26-.096.513-.27.71l-5.12 5.762a.214.214 0 0 0 .16.355h4.686c.356 0 .642.287.642.642v1.382a.641.641 0 0 1-.642.642h-8.877a.641.641 0 0 1-.642-.642v-1.243c0-.261.096-.514.27-.71l5.12-5.762a.214.214 0 0 0-.16-.356h-4.78a.322.322 0 0 1-.24-.535L12.04 8.98a1.07 1.07 0 0 1 .8-.36Z" })
		]
	});
}
//#endregion
//#region src/negroni/Logo/logoStyles.ts
const logoStyles = tv({
	variants: {
		variant: {
			mark: "",
			legalZoom: "",
			virtualMail: "",
			legal: "",
			tax: "",
			books: "",
			assist: ""
		},
		fill: {
			dark: "fill-neutral-800",
			light: "fill-neutral-0"
		},
		size: {
			xs: "",
			sm: "",
			md: "",
			lg: "",
			xl: ""
		}
	},
	compoundVariants: [
		{
			variant: ["mark"],
			size: "xs",
			class: "h-3 w-3"
		},
		{
			variant: ["mark"],
			size: "sm",
			class: "h-6 w-6"
		},
		{
			variant: ["mark"],
			size: "md",
			class: "h-10 w-10"
		},
		{
			variant: ["mark"],
			size: "lg",
			class: "h-[60px] w-[60px]"
		},
		{
			variant: ["legalZoom"],
			size: "sm",
			class: "h-6 w-[108px]"
		},
		{
			variant: ["legalZoom"],
			size: "md",
			class: "h-10 w-[166px]"
		},
		{
			variant: ["legalZoom"],
			size: "lg",
			class: "h-[60px] w-[291px]"
		},
		{
			variant: ["legalZoom"],
			size: "xl",
			class: "h-20 w-[388px]"
		},
		{
			variant: ["virtualMail"],
			size: "sm",
			class: "h-6 w-[98px]"
		},
		{
			variant: ["virtualMail"],
			size: "md",
			class: "h-10 w-[151px]"
		},
		{
			variant: ["virtualMail"],
			size: "lg",
			class: "h-[60px] w-[263px]"
		},
		{
			variant: ["legal"],
			size: "sm",
			class: "h-6 w-[112px]"
		},
		{
			variant: ["legal"],
			size: "md",
			class: "h-10 w-[172px]"
		},
		{
			variant: ["legal"],
			size: "lg",
			class: "h-[60px] w-[302px]"
		},
		{
			variant: ["tax"],
			size: "sm",
			class: "h-6 w-12"
		},
		{
			variant: ["tax"],
			size: "md",
			class: "h-10 w-[75px]"
		},
		{
			variant: ["tax"],
			size: "lg",
			class: "h-[60px] w-[124px]"
		},
		{
			variant: ["books"],
			size: "sm",
			class: "h-6 w-16"
		},
		{
			variant: ["books"],
			size: "md",
			class: "h-10 w-[99px]"
		},
		{
			variant: ["books"],
			size: "lg",
			class: "h-[60px] w-[169px]"
		},
		{
			variant: ["assist"],
			size: "sm",
			class: "h-5 w-[75px]"
		},
		{
			variant: ["assist"],
			size: "md",
			class: "h-8 w-[116px]"
		},
		{
			variant: ["assist"],
			size: "lg",
			class: "h-10 w-[143px]"
		},
		{
			variant: ["assist"],
			fill: "dark",
			class: "text-neutral-50"
		},
		{
			variant: ["assist"],
			fill: "light",
			class: "text-neutral-0"
		}
	]
});
//#endregion
//#region src/negroni/Logo/Logo.tsx
const variants = {
	mark: /* @__PURE__ */ jsx(Mark, {}),
	legalZoom: /* @__PURE__ */ jsx(Default, {}),
	virtualMail: /* @__PURE__ */ jsx(VirtualMail, {}),
	legal: /* @__PURE__ */ jsx(LegalServices, {}),
	tax: /* @__PURE__ */ jsx(Tax, {}),
	books: /* @__PURE__ */ jsx(Books, {}),
	assist: /* @__PURE__ */ jsx(AssistLogo, {})
};
/**
* Logo component which will render appropriate logo based on the variant and size.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3589-45885&t=IJFAVYV2KpQPxnc6-0)
*/
function Logo({ variant, size = "md", fill = "dark" }) {
	return /* @__PURE__ */ jsx("svg", {
		className: logoStyles({
			fill,
			variant,
			size
		}),
		children: variants[variant]
	});
}
//#endregion
//#region src/negroni/Badge/Badge.tsx
const badgeStyles = tv({
	base: "flex w-fit items-center gap-1 border text-xs font-medium uppercase",
	variants: {
		variant: {
			subtle: "",
			bold: ""
		},
		color: {
			warning: "border-accent1-100 bg-accent1-100 text-accent1-900",
			info: "border-accent3-25 bg-accent3-25 text-accent3-700",
			neutral: "border-neutral-50 bg-neutral-25 text-neutral-600",
			success: "border-success-25 bg-success-25 text-success-700",
			error: "border-error-25 bg-error-25 text-error-700"
		},
		size: {
			sm: "h-5 rounded px-2",
			lg: "h-8 rounded-lg px-4"
		}
	},
	defaultVariants: {
		variant: "subtle",
		color: "neutral",
		size: "sm"
	},
	compoundVariants: [
		{
			variant: "bold",
			color: "warning",
			class: "border-accent1-500"
		},
		{
			variant: "bold",
			color: "info",
			class: "border-accent2-100"
		},
		{
			variant: "bold",
			color: "neutral",
			class: "border-neutral-100"
		},
		{
			variant: "bold",
			color: "success",
			class: "border-success-500"
		},
		{
			variant: "bold",
			color: "error",
			class: "border-error-500"
		}
	]
});
/**
* Badge component
*
* A badge component meant to be an indicator of the status of an element.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=1989-19163&t=QhUiKOxxjUortyxG-4)
*/
function Badge({ className, id, "data-testid": dataTestId, label, size, color, variant, icon: Icon, iconProps, "aria-label": ariaLabel }) {
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: badgeStyles({
			className,
			size,
			color,
			variant
		}),
		"aria-label": ariaLabel,
		children: [!!Icon && /* @__PURE__ */ jsx(Icon, {
			...iconProps,
			size: size === "lg" ? "sm" : "xs"
		}), label]
	});
}
//#endregion
//#region src/negroni/Accordion/useAccordionContext.ts
const AccordionContext = createContext({ variant: "list" });
const useAccordionContext = () => {
	return useContext(AccordionContext);
};
//#endregion
//#region src/negroni/Accordion/AccordionItem.tsx
const styles$5 = tv({
	slots: {
		wrapper: "group relative w-full border-l border-r border-neutral-50 bg-neutral-0 outline-none hover:bg-neutral-25 data-[expanded]:bg-neutral-25",
		button: "flex w-full flex-col items-start gap-2 p-4 text-left outline-none data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf",
		title: "font-semibold",
		icon: "transition-transform duration-300 group-data-[expanded]:rotate-180",
		content: "px-4 pb-4"
	},
	variants: { variant: {
		list: { wrapper: "border-t first:rounded-t-lg last:rounded-b-lg last:border-b" },
		cards: {
			wrapper: "rounded-lg border",
			icon: ""
		}
	} },
	defaultVariants: { variant: "list" }
});
/**
* A collapsible section of content. It is composed of a header with a heading and trigger button, and a panel that contains the content.
*
* [RAC Disclosure](https://react-spectrum.adobe.com/react-aria/Disclosure.html)
*/
function AccordionItem({ children, id, "data-testid": dataTestId, header, className, icon: Icon, badgeProps, centeredHeader = false, ...props }) {
	const { variant } = useAccordionContext();
	const { wrapper, button, title, icon, content } = styles$5({ variant });
	return /* @__PURE__ */ jsxs(Disclosure, {
		...props,
		id,
		"data-testid": dataTestId,
		className: wrapper({ className }),
		children: [/* @__PURE__ */ jsx(Button, {
			slot: "trigger",
			className: button(),
			children: typeof header === "string" ? /* @__PURE__ */ jsxs(Fragment$1, { children: [badgeProps && /* @__PURE__ */ jsx(Badge, { ...badgeProps }), /* @__PURE__ */ jsxs("div", {
				className: `flex w-full items-center ${centeredHeader ? "justify-center" : "justify-between"} gap-3`,
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex gap-2",
					children: [Icon && /* @__PURE__ */ jsx(Icon, {
						className: "self-center",
						size: "sm"
					}), /* @__PURE__ */ jsx("div", {
						className: title(),
						children: header
					})]
				}), /* @__PURE__ */ jsx("div", {
					className: icon(),
					children: /* @__PURE__ */ jsx(ChevronDownIcon, {})
				})]
			})] }) : header
		}), /* @__PURE__ */ jsx(DisclosurePanel, {
			className: content({ className: Icon && "ml-7" }),
			children
		})]
	});
}
//#endregion
//#region src/negroni/Accordion/Accordion.tsx
const styles$4 = tv({
	base: "",
	variants: { variant: {
		list: "",
		cards: "flex flex-col gap-4"
	} },
	defaultVariants: { variant: "list" }
});
/**
* Grouping of related AccordionItems. It supports both single and multiple expanded items.
*
* [Figma Specs](https://www.figma.com/design/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?m=auto&node-id=3909-76408&t=EWNux1k9EdzbgcVF-1)
*
* [RAC DisclosureGroup](https://react-spectrum.adobe.com/react-aria/DisclosureGroup.html)
*/
function Accordion({ className, children, header, variant, ...rest }) {
	return /* @__PURE__ */ jsx(AccordionContext.Provider, {
		value: { variant: variant ?? "list" },
		children: /* @__PURE__ */ jsxs(DisclosureGroup, {
			...rest,
			children: [Boolean(header) && /* @__PURE__ */ jsx("div", {
				className: "mb-4",
				children: /* @__PURE__ */ jsx("span", {
					className: "font-semibold",
					children: header
				})
			}), /* @__PURE__ */ jsx("div", {
				className: styles$4({
					className,
					variant
				}),
				children
			})]
		})
	});
}
//#endregion
//#region src/negroni/LoadingAnimations/Spinner/Spinner.tsx
const styles$3 = tv({
	base: "mr-2 inline h-8 w-8 animate-spin fill-brand-600 text-neutral-200",
	variants: { size: {
		xs: "h-4 w-4",
		sm: "h-6 w-6",
		md: "h-8 w-8",
		lg: "h-16 w-16"
	} },
	defaultVariants: { size: "lg" }
});
/**
* A loading spinner animation.
*/
function Spinner({ className, size }) {
	return /* @__PURE__ */ jsxs("svg", {
		"aria-hidden": "true",
		className: styles$3({
			size,
			className
		}),
		viewBox: "0 0 100 101",
		fill: "none",
		xmlns: "http://www.w3.org/2000/svg",
		children: [/* @__PURE__ */ jsx("path", {
			d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
			fill: "currentColor"
		}), /* @__PURE__ */ jsx("path", {
			d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
			fill: "currentFill"
		})]
	});
}
//#endregion
//#region src/negroni/utils/table.ts
const getPageNumbers = ({ currentPage, pageSize, total, pageNumbersToShow = 5 }) => {
	const lastPageNumber = Math.ceil(total / pageSize);
	const currentPageNumber = currentPage <= lastPageNumber ? currentPage : lastPageNumber;
	const maxPagesBeforeCurrentPage = Math.floor(pageNumbersToShow / 2);
	const maxPagesAfterCurrentPage = Math.ceil(pageNumbersToShow / 2) - 1;
	let startPage = 1;
	let endPage = lastPageNumber;
	if (lastPageNumber <= 1) return [1];
	if (currentPageNumber <= maxPagesBeforeCurrentPage) {
		startPage = 1;
		endPage = pageNumbersToShow;
	} else if (currentPageNumber + maxPagesAfterCurrentPage >= lastPageNumber) startPage = lastPageNumber - pageNumbersToShow + 1;
	else {
		startPage = currentPageNumber - maxPagesBeforeCurrentPage;
		endPage = currentPageNumber + maxPagesAfterCurrentPage;
	}
	let pageNumbers = Array.from(Array(endPage + 1 - startPage).keys()).map((pageNumber) => startPage + pageNumber).filter((pageNumber) => pageNumber <= lastPageNumber && pageNumber > 0);
	if (+pageNumbers[0] > 1) if (+pageNumbers[0] <= 2) pageNumbers = [1, ...pageNumbers];
	else pageNumbers = [
		1,
		+pageNumbers[0] > 3 ? "..." : 2,
		...pageNumbers
	];
	if (pageNumbers[pageNumbers.length - 1] !== lastPageNumber) if (pageNumbers[pageNumbers.length - 1] === lastPageNumber - 1) pageNumbers = [...pageNumbers, lastPageNumber];
	else {
		const ellipsis = +pageNumbers[pageNumbers.length - 1] < lastPageNumber - 2 ? "..." : lastPageNumber - 1;
		pageNumbers = [
			...pageNumbers,
			ellipsis,
			lastPageNumber
		];
	}
	return pageNumbers;
};
//#endregion
//#region src/negroni/utils/misc.ts
const tailwindMergeConfig = { extend: { classGroups: { "font-size": [{ text: [
	"headline-1",
	"headline-2",
	"headline-3",
	"headline-4",
	"headline-5",
	"headline-6",
	"body-1",
	"body-2",
	"title-1",
	"title-2",
	"title-3",
	"label",
	"link",
	"footnote",
	"serif-headline-1",
	"serif-headline-2",
	"serif-headline-3",
	"serif-headline-4",
	"serif-headline-5",
	"serif-headline-6",
	"serif-title-1",
	"serif-title-2"
] }] } } };
defaultConfig.twMergeConfig = tailwindMergeConfig;
//#endregion
//#region src/negroni/utils/cx.ts
/**
* `cn` is a re-export of the `twJoin` function from `tailwind-merge`.
*
*/
const cn = twJoin;
/**
* `cx` is a re-export of the `twMerge` function from `tailwind-merge`.
*
* Prefer using `cn` (twJoin) over `cx` (twMerge) because it's more performant. Use only if you really [need](https://github.com/dcastil/tailwind-merge/blob/v2.2.1/docs/when-and-how-to-use-it.md) twMerge.
*/
const cx = extendTailwindMerge(tailwindMergeConfig);
//#endregion
//#region src/negroni/utils/PopoverWrapper.tsx
/**
* Lightweight wrapper for RAC Popover to address scrolling issues [NDS-238](https://legalzoom.atlassian.net/browse/NDS-238).
*
* Todo: this is a temporary solution, revaluate after RAC RC.1 release
*   - change popover portal target when inside full page takeover
*   - remove effect (combobox should close on scroll)
*/
const PopoverWrapper = (props) => {
	const [popoverRef, setPopoverRef] = useState(null);
	useEffect(() => {
		const popoverInBody = popoverRef?.parentElement === document.body;
		if (!props.isNonModal && popoverInBody) {
			const underlay = popoverRef.previousElementSibling;
			if (underlay?.tagName === "DIV") underlay.classList.add("z-[100]");
			else if (underlay?.tagName === "SPAN" && underlay.hasAttribute("data-focus-scope-start")) underlay.className = "z-[100] fixed inset-0";
		}
	}, [popoverRef]);
	return /* @__PURE__ */ jsx(Popover, {
		...props,
		ref: setPopoverRef
	});
};
/**
* Animation classes for the popover, based on RAC enter/exit states
*
* @remarks
* These are for custom popover implementations based on RAC's Popover component and are
* built in to all Negroni popover components out of the box.
*/
const popoverAnimationClasses = "motion-safe:data-[entering]:data-[placement=bottom]:animate-subtle-slide-in-top motion-safe:data-[exiting]:data-[placement=bottom]:animate-subtle-slide-out-top motion-safe:data-[entering]:data-[placement=top]:animate-subtle-slide-in-bottom motion-safe:data-[exiting]:data-[placement=top]:animate-subtle-slide-out-bottom  motion-reduce:data-[entering]:animate-fade-in motion-reduce:data-[exiting]:animate-fade-out";
//#endregion
//#region src/negroni/Tooltip/Tooltip.tsx
/**
*
* A tooltip displays a description of an element on hover or focus.
* 
* _Example:_ 
*
* ```
<Tooltip.Trigger>
<Button>Tooltip</Button>
<Tooltip>Content</Tooltip>
</Tooltip.Trigger>
* ```
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=31882%3A78613&mode=design&t=jdu8BITHXjTb7oAk-1)
*
* [RAC Tooltip](https://react-spectrum.adobe.com/react-aria/Tooltip.html)
*
* @see {@link https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/negroni-tooltip--docs | Storybook} for more detailed usage and examples.
* 
*/
const Tooltip$1 = ({ children, className, ...props }) => {
	return /* @__PURE__ */ jsx(Tooltip, {
		offset: 4,
		className: cx("flex items-center justify-center rounded-lg bg-neutral-700 px-2 py-1 text-footnote text-white", popoverAnimationClasses, className),
		...props,
		children
	});
};
Tooltip$1.Trigger = TooltipTrigger;
//#endregion
//#region src/negroni/Button/Button.tsx
const buttonStyles = tv({
	base: "inline-block rounded-lg border font-base font-semibold outline-none transition-all data-[disabled]:pointer-events-none data-[disabled]:text-neutral-400 data-[disabled]:shadow-level-0 data-[pressed]:shadow-level-0 data-[focus-visible]:outline-kbf",
	variants: {
		variant: {
			solid: "data-[disabled]:border-neutral-25 data-[disabled]:bg-neutral-25 data-[hovered]:shadow-level-3",
			outline: "data-[disabled]:border-neutral-300 data-[disabled]:bg-neutral-0 data-[hovered]:shadow-level-3",
			ghost: "border-none"
		},
		color: {
			brand: "",
			neutral: "",
			error: ""
		},
		size: {
			xs: "h-6 p-1.5 text-sm",
			sm: "h-8 px-3",
			md: "h-12 px-5",
			lg: "h-14 px-6"
		},
		icon: {
			true: "flex items-center justify-center",
			false: ""
		}
	},
	compoundVariants: [
		{
			variant: "solid",
			color: "brand",
			class: "border-brand bg-brand text-white data-[hovered]:border-brand-600 data-[pressed]:border-brand-700 data-[hovered]:bg-brand-600 data-[pressed]:bg-brand-700"
		},
		{
			variant: "solid",
			color: "neutral",
			class: "border-neutral-100 bg-neutral-25 text-neutral-800 data-[disabled]:border-neutral-0 data-[hovered]:border-neutral-200 data-[hovered]:bg-neutral-100 data-[pressed]:bg-neutral-200 data-[hovered]:shadow-level-3"
		},
		{
			variant: "solid",
			color: "error",
			class: "border-error-500 bg-error-500 text-neutral-0 data-[hovered]:border-error-600 data-[pressed]:border-error-700 data-[hovered]:bg-error-600 data-[pressed]:bg-error-700"
		},
		{
			variant: "outline",
			color: "brand",
			class: "border-brand text-brand data-[hovered]:border-brand-600 data-[pressed]:border-brand-700 data-[hovered]:text-brand-600 data-[pressed]:text-brand-700"
		},
		{
			variant: "outline",
			color: "neutral",
			class: "bg-neutral-0 text-neutral-800 data-[pressed]:border-neutral-900 data-[hovered]:text-neutral-800 data-[pressed]:text-neutral-900"
		},
		{
			variant: "outline",
			color: "error",
			class: "border-error-500 text-error-500 data-[pressed]:border-error-700 data-[hovered]:text-error-600 data-[pressed]:text-error-700"
		},
		{
			variant: "ghost",
			color: "brand",
			class: "text-brand underline underline-offset-2 data-[disabled]:border-neutral-0 data-[hovered]:text-brand-600 data-[pressed]:text-brand-700"
		},
		{
			variant: "ghost",
			color: "neutral",
			class: "text-neutral-800 underline underline-offset-2 data-[hovered]:text-neutral-900 data-[pressed]:text-neutral-900"
		},
		{
			variant: "ghost",
			color: "error",
			class: "text-error-500 underline underline-offset-2 data-[hovered]:text-error-600 data-[pressed]:text-error-700"
		},
		{
			variant: "ghost",
			color: [
				"brand",
				"neutral",
				"error"
			],
			icon: true,
			class: "bg-none transition-colors data-[hovered]:bg-neutral-25 data-[pressed]:bg-neutral-100 data-[disabled]:text-neutral-400 data-[disabled]:shadow-none data-[hovered]:shadow-level-3 data-[pressed]:shadow-none"
		},
		{
			size: "xs",
			icon: true,
			class: "size-6 shrink-0 px-0"
		},
		{
			size: "sm",
			icon: true,
			class: "size-8 shrink-0 px-0"
		},
		{
			size: "md",
			icon: true,
			class: "size-10 shrink-0 px-0"
		},
		{
			size: "lg",
			icon: true,
			class: "size-12 shrink-0 px-0"
		}
	],
	defaultVariants: {
		variant: "solid",
		color: "brand",
		size: "lg"
	}
});
const spinnerStyles = tv({
	base: "absolute mr-0",
	variants: { size: {
		xs: "h-3 w-3",
		sm: "h-4 w-4",
		md: "h-6 w-6",
		lg: "h-8 w-8"
	} },
	defaultVariants: { size: "lg" }
});
const ButtonContext = createContext({});
const Button$1 = forwardRef((p, r) => {
	const [props, ref] = useContextProps(p, r, ButtonContext);
	const { className, children, isDisabled, isLoading, variant, size, color, icon: Icon, iconPosition = "start", iconProps, tooltip, slot: _slot, ...restProps } = props;
	const iconSizeMap = {
		xs: "sm",
		sm: "sm",
		md: "md",
		lg: "md"
	};
	const button = /* @__PURE__ */ jsx(Button, {
		isDisabled: isDisabled || isLoading,
		className: buttonStyles({
			className,
			variant,
			size,
			color,
			icon: Boolean(Icon) && !children
		}),
		...restProps,
		ref,
		children: Icon && !children ? /* @__PURE__ */ jsx(Icon, {
			size: size && iconSizeMap[size],
			...iconProps
		}) : /* @__PURE__ */ jsxs("div", {
			className: "flex h-full items-center justify-center",
			children: [isLoading && /* @__PURE__ */ jsx(Spinner, { className: spinnerStyles({ size }) }), /* @__PURE__ */ jsxs("div", {
				className: cn("flex gap-2 overflow-hidden", isLoading && "opacity-0"),
				children: [
					!!Icon && iconPosition === "start" && /* @__PURE__ */ jsx(Icon, {
						size: "sm",
						className: "self-center",
						...iconProps
					}),
					typeof children === "string" ? /* @__PURE__ */ jsx("div", {
						className: "inline-block truncate",
						title: children,
						children
					}) : children,
					!!Icon && iconPosition === "end" && /* @__PURE__ */ jsx(Icon, {
						size: "sm",
						className: "self-center",
						...iconProps
					})
				]
			})]
		})
	});
	return tooltip ? /* @__PURE__ */ jsxs(Tooltip$1.Trigger, { children: [button, /* @__PURE__ */ jsx(Tooltip$1, { children: tooltip })] }) : button;
});
Button$1.displayName = "Button";
//#endregion
//#region src/negroni/utils/createOverlayOpenEvent.ts
const eventType$1 = "overlay_open";
function createOverlayOpenEvent(detail) {
	return new CustomEvent(eventType$1, {
		detail,
		bubbles: true,
		cancelable: false
	});
}
//#endregion
//#region src/negroni/Popover/Popover.tsx
const popoverStyles = tv({
	slots: {
		popover: `${popoverAnimationClasses} w-72 rounded-lg p-4`,
		closeIcon: "absolute right-0 top-0"
	},
	variants: { accent: {
		true: {
			popover: "bg-accent2-500 text-content-contrast",
			closeIcon: "text-white data-[hovered]:bg-transparent"
		},
		false: {
			popover: "bg-neutral-0 text-content-1 shadow-level-2",
			closeIcon: "text-black"
		}
	} },
	defaultVariants: { accent: true }
});
const PopoverHeader = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		className: cx("mr-2 text-body-2 text-accent2-50", className),
		...props
	});
};
const PopoverTitle = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		className: cx("popover-title mr-2 text-body-1 font-semibold", className),
		...props
	});
};
const PopoverBody = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		className: cx("text-body-2", className),
		...props
	});
};
const PopoverFooter = ({ className, ...props }) => {
	return /* @__PURE__ */ jsx("div", {
		className: cx("text-body-2 text-success-50", className),
		...props
	});
};
const arrow = tv({
	base: "text-accent2-500",
	variants: {
		placement: {
			center: "",
			bottom: "",
			top: "[&>svg]:rotate-180",
			left: "-m-1 [&>svg]:rotate-90",
			right: "-m-1 [&>svg]:-rotate-90"
		},
		accent: {
			true: "text-accent2-500",
			false: "text-neutral-0"
		}
	},
	defaultVariants: { accent: true }
});
const emitOverlayOpenEvent = (ref) => {
	if (!ref.current) return;
	const overlayOpenEvent = createOverlayOpenEvent({
		id: ref.current.id,
		title: ref.current.querySelector(".popover-title")?.textContent?.toString(),
		type: "popover"
	});
	ref.current.dispatchEvent(overlayOpenEvent);
};
/**
* 
* A popover is an overlay element positioned relative to a trigger.
*
* Popover is composed the following sub components
* 
* ```
* <Popover.Trigger />
* <Popover.Header />
* <Popover.Title /> 
* <Popover.Body />
* <Popover.Footer />
* ```
* _Example:_ 
*
* ```
<Popover.Trigger isOpen={isOpen} onOpenChange={setOpen}>
<Button onPress={() => setOpen(true)}>Open Me</Button>
<Popover setIsOpen={setOpen}>
<Popover.Header>Extra content</Popover.header>
<Popover.Title>Bank Accounts</Popover.title>
<Popover.Body>You currently have 6 accounts connected</Popover.Body>
<Popover.Footer>Last sync: 12:02</Popover.Footer>
</Popover>
</Popover.trigger>
* ```
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=81-569&mode=design&t=UfibUGmY5BVmo3IM-0)
* 
* [RAC Popover](https://react-spectrum.adobe.com/react-aria/Popover.html)
* 
* @see {@link https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/experimental-popover--docs | Storybook} for more detailed usage and examples.
*/
const Popover$1 = ({ showArrow, showCloseButton, onOpenChange, children, className, accent, ...props }) => {
	const dialogRef = useRef(null);
	useEffect(() => {
		if (props?.isOpen) emitOverlayOpenEvent(dialogRef);
	}, [props?.isOpen]);
	const { popover, closeIcon } = popoverStyles({ accent });
	return /* @__PURE__ */ jsx(PopoverWrapper, {
		onOpenChange,
		className: popover({ className }),
		...props,
		children: /* @__PURE__ */ jsxs(Fragment$1, { children: [showArrow && /* @__PURE__ */ jsx(OverlayArrow, {
			className: ({ placement }) => arrow({
				placement: placement ?? "center",
				accent
			}),
			children: /* @__PURE__ */ jsx("svg", {
				width: "16",
				height: "8",
				viewBox: "0 0 16 8",
				children: /* @__PURE__ */ jsx("path", {
					d: "M8 0L16 8H0L8 0Z",
					fill: "currentColor"
				})
			})
		}), /* @__PURE__ */ jsxs(Dialog, {
			ref: dialogRef,
			id: props?.id,
			className: "relative flex flex-col gap-2 outline-none",
			children: [children, showCloseButton && /* @__PURE__ */ jsx(Button$1, {
				"aria-label": "close",
				className: closeIcon(),
				variant: "ghost",
				color: "neutral",
				icon: XIcon,
				onPress: () => onOpenChange && onOpenChange(false)
			})]
		})] })
	});
};
Popover$1.Trigger = DialogTrigger;
Popover$1.Header = PopoverHeader;
Popover$1.Title = PopoverTitle;
Popover$1.Body = PopoverBody;
Popover$1.Footer = PopoverFooter;
//#endregion
//#region src/negroni/Dropdown/Dropdown.tsx
const { menuWrapper, item: item$1, buttonLabel: buttonLabelStyles } = tv({
	slots: {
		menuWrapper: "flex max-h-[inherit] flex-col gap-1 overflow-auto rounded-lg border bg-neutral-0 fill-neutral-0 stroke-neutral-100 p-2 shadow-level-3",
		item: "flex w-full cursor-pointer items-center gap-1.5 rounded-lg bg-neutral-0 p-4 hover:bg-accent1-100 focus-visible:bg-accent1-100 focus-visible:outline-none",
		buttonLabel: "flex items-center gap-2"
	},
	variants: { color: {
		brand: { item: "text-brand-500" },
		neutral: { item: "" },
		error: { item: "text-error-500" }
	} },
	defaultVariants: { color: "neutral" }
})();
function DropdownItem({ "aria-label": ariaLabel, id, icon: Icon, children, color, className = "", ...props }) {
	return /* @__PURE__ */ jsxs(MenuItem, {
		...props,
		id,
		"aria-label": ariaLabel,
		className: item$1({
			color,
			className
		}),
		children: [Icon && /* @__PURE__ */ jsx(Icon, { size: "sm" }), children]
	});
}
/**
* Dropdown Menu
*
* Figma: https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=7581-250517&mode=design&t=c5RPmhXbyz1LiOL2-0
*/
function Dropdown({ type, label, size = "md", variant = "solid", color, children, isDisabled, hideChevron = false, popOverPlacement, popOverClassName, onAction, onOpenChange, "aria-label": ariaLabel, ...restProps }) {
	return /* @__PURE__ */ jsxs(MenuTrigger, {
		onOpenChange,
		children: [/* @__PURE__ */ jsx(Button$1, {
			isDisabled,
			size,
			variant,
			color,
			"aria-label": ariaLabel,
			icon: type === "icon" ? DotsHorizontalIcon : void 0,
			...restProps,
			children: type === "button" && /* @__PURE__ */ jsxs("div", {
				className: buttonLabelStyles(),
				children: [label, !hideChevron && /* @__PURE__ */ jsx(ChevronDownIcon, { size: "sm" })]
			})
		}), /* @__PURE__ */ jsx(PopoverWrapper, {
			placement: popOverPlacement || "bottom right",
			className: cx("w-64", popoverAnimationClasses, popOverClassName),
			children: /* @__PURE__ */ jsx("div", {
				className: menuWrapper(),
				children: /* @__PURE__ */ jsx(Menu, {
					onAction,
					className: "outline-none",
					"data-testid": "dropdown-container",
					children
				})
			})
		})]
	});
}
Dropdown.Item = DropdownItem;
//#endregion
//#region src/negroni/ActionGroup/ActionGroup.tsx
/**
* <b>ActionGroup component</b>
*
* A container for a set of interactive controls. At the moment, it only supports `IconButtons` and an `Dropdown`.
*
* `maxDisplayedItems` - Maximum amount of items displayed on the `ActionGroup`, this also includes the `Dropdown`.
*
* ActionGroup items are dynamically displayed depending on the `maxDisplayedItems` prop. If the amount of `items` exceeds the `maxDisplayedItems`, these extra items will be collapsed into the `Dropdown`.
*
* <b>Note: Vertical variant should only be used in mobile view.</b>
*/
function ActionGroup({ id, "data-testid": dataTestId, maxDisplayedItems = 2, onAction, items = [], variant = "outline", color = "neutral", orientation = "horizontal", className, size = "xs", isAllDisabled = false }) {
	let iconButtons = [];
	let overflowItems = [];
	const adjustedMaxDisplayedItems = Math.min(maxDisplayedItems, items.length);
	if (adjustedMaxDisplayedItems === items.length) iconButtons = items.slice();
	else {
		iconButtons = items.slice(0, adjustedMaxDisplayedItems - 1);
		overflowItems = items.slice(adjustedMaxDisplayedItems - 1);
	}
	const filteredOverflowItems = overflowItems.filter((item) => {
		return !item.isDisabled;
	});
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: cx("flex gap-1", orientation === "vertical" && "flex-col", className),
		children: [iconButtons.map((item) => {
			const { id: itemId, isDisabled, icon: Icon, ...restItem } = item;
			return /* @__PURE__ */ jsx(Button$1, {
				icon: Icon,
				color,
				size,
				variant,
				onPress: () => {
					onAction(itemId);
				},
				isDisabled: isAllDisabled || isDisabled,
				...restItem
			}, itemId);
		}), overflowItems.length >= 1 && /* @__PURE__ */ jsx(Dropdown, {
			variant,
			color: "neutral",
			type: "icon",
			size,
			onAction,
			isDisabled: isAllDisabled || filteredOverflowItems.length === 0,
			children: filteredOverflowItems.map((item) => {
				const { icon, ...restItem } = item;
				return /* @__PURE__ */ jsx(Dropdown.Item, {
					color: item.color,
					icon,
					...restItem,
					children: item.children
				}, restItem.id);
			})
		})]
	});
}
//#endregion
//#region src/negroni/AttentionBox/AttentionBox.tsx
const infoTipStyles = tv({
	base: "rounded-lg p-4",
	variants: { variant: {
		warning: "bg-accent1-100",
		success: "bg-success-25 text-success-800",
		error: "bg-error-25 text-error-800"
	} },
	defaultVariants: { variant: "warning" }
});
/**
* Attention Box Component
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=1968-14441&t=rePGYAUCtsPIepri-0)
*/
function AttentionBox({ className, id, "data-testid": dataTestId, children, title = "", icon: Icon, iconProps, link, variant, onClose }) {
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: infoTipStyles({
			variant,
			className
		}),
		children: [
			/* @__PURE__ */ jsxs("div", {
				className: "flex justify-between",
				children: [Icon && /* @__PURE__ */ jsx("div", {
					className: "pb-4",
					children: /* @__PURE__ */ jsx(Icon, { ...iconProps })
				}), onClose && /* @__PURE__ */ jsx(Button$1, {
					icon: XIcon,
					variant: "ghost",
					color: "neutral",
					size: "lg",
					onPress: onClose
				})]
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "flex flex-col gap-1",
				children: [title && /* @__PURE__ */ jsx("p", {
					className: "text-body-1 font-semibold text-neutral-800",
					children: title
				}), /* @__PURE__ */ jsx("div", {
					className: "text-body-2 font-normal text-neutral-800",
					children
				})]
			}),
			link && /* @__PURE__ */ jsx("div", {
				className: "pt-4",
				children: link
			})
		]
	});
}
//#endregion
//#region src/negroni/Avatar/Avatar.tsx
const avatarStyles = tv({
	slots: {
		wrapper: "flex items-center justify-center overflow-hidden rounded-full border border-solid border-neutral-0 bg-accent1-200",
		content: "h-full w-full rounded-full border border-solid border-neutral-0 object-cover",
		text: "text-footnote font-semibold no-underline"
	},
	variants: { size: {
		xl: {
			wrapper: "h-52 w-52",
			text: "text-headline-3"
		},
		lg: {
			wrapper: "h-30 w-30",
			text: "text-headline-6"
		},
		md: { wrapper: "h-10 w-10" },
		sm: { wrapper: "h-8 w-8" },
		xs: { wrapper: "h-6 w-6" }
	} },
	defaultVariants: { size: "md" }
});
const { content, text, wrapper } = avatarStyles();
const getAvatarContent = ({ size, image, name, initials, icon: Icon, imgProps }) => {
	const { src, alt, ...restImgProps } = imgProps || {};
	if (image || src) return /* @__PURE__ */ jsx("figure", {
		className: "h-full w-full",
		children: /* @__PURE__ */ jsx("img", {
			...restImgProps,
			className: content(),
			src: image || src,
			alt: name || alt
		})
	});
	if (name) return /* @__PURE__ */ jsx("abbr", {
		className: text({ size }),
		title: name,
		children: initials
	});
	const getIconSize = () => {
		if (size === "lg" || size === "xl") return "xxl";
		return "sm";
	};
	return Icon ? /* @__PURE__ */ jsx(Icon, { size: getIconSize() }) : null;
};
/**
* Avatar component (base)
*
* An image, icon, or set of initials meant to represent a person/entity.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=4459-57969&mode=design&t=SpAuY62CoV17WmhT-0)
*/
function Avatar({ size = "md", image, name, icon, className, "data-testid": dataTestId, id, imgProps }) {
	const AvatarContent = getAvatarContent({
		size,
		image,
		name,
		initials: useMemo(() => {
			if (!name) return "";
			const nameParts = name.trim().split(" ");
			if (nameParts.length === 1) return nameParts[0]?.substring(0, 2)?.toUpperCase();
			const firstName = nameParts[0];
			let lastName = nameParts[nameParts.length - 1];
			if (lastName.includes("-")) [lastName] = lastName.split("-");
			return `${firstName[0] || ""}${lastName[0] || ""}`.toUpperCase();
		}, [name]),
		icon,
		imgProps
	});
	return /* @__PURE__ */ jsx("div", {
		id,
		"data-testid": dataTestId,
		className: wrapper({
			size,
			className
		}),
		children: AvatarContent
	});
}
//#endregion
//#region src/negroni/AvatarStack/AvatarStack.tsx
/**
* AvatarStack component (base)
*
* An overlapping list of Avatar components populated with initials.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=1989-19172&t=JKA6fYuX920pQafF-0)
*/
function AvatarStack({ names, className, "data-testid": testId, id }) {
	const namesToRender = useMemo(() => {
		if (names.length <= 4) return names;
		const firstThreeActors = names.slice(0, 3);
		const additionalActorCount = names.slice(3).length;
		return [...firstThreeActors, `+${additionalActorCount}`];
	}, [names]);
	return /* @__PURE__ */ jsx("div", {
		id,
		"data-testid": testId,
		className: cx("flex -space-x-2", className),
		children: namesToRender.map((name) => /* @__PURE__ */ jsx(Avatar, { name }, name))
	});
}
//#endregion
//#region src/negroni/Link/Link.tsx
const buttonLinkStyles = tv({
	extend: buttonStyles,
	base: "inline-flex flex-none cursor-pointer items-center justify-center"
});
const textLinkStyles = tv({
	base: "cursor-pointer font-semibold no-underline outline-none data-[disabled]:pointer-events-none data-[disabled]:text-neutral-400 data-[focus-visible]:outline-kbf",
	variants: {
		color: {
			brand: "text-brand-500 data-[hovered]:text-brand-600 data-[pressed]:text-brand-700",
			neutral: "text-neutral-800 data-[hovered]:text-brand-500 data-[pressed]:text-brand-600",
			error: "text-error-500 data-[hovered]:text-error-600 data-[pressed]:text-error-700"
		},
		size: {
			sm: "text-xs tracking-[-.0125rem]",
			md: "text-sm tracking-[-.025rem]",
			lg: "text-base tracking-[-.025rem]"
		}
	},
	defaultVariants: {
		color: "brand",
		size: "md"
	}
});
/**
* Link component for rendering an accessible HTML Anchor styled as a button or link
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=4931-53857&t=0YB09Fnsx2TIYKGy-0)
*
* Wrapper component: React Aria Link headless UI component:
* https://react-spectrum.adobe.com/react-aria/Link.html
*/
const Link$1 = forwardRef(({ type = "text", className, variant, color, size, target = "_self", ...restProps }, ref) => /* @__PURE__ */ jsx(Link, {
	...restProps,
	ref,
	target,
	className: type === "text" ? textLinkStyles({
		color,
		size,
		className
	}) : buttonLinkStyles({
		variant,
		color,
		size,
		className
	})
}));
//#endregion
//#region src/negroni/Banner/Banner.tsx
const bannerStyles = tv({
	slots: {
		wrapper: "flex justify-start gap-4 rounded-lg border p-4 text-sm",
		icon: ""
	},
	variants: { variant: {
		info: {
			wrapper: "border-neutral-100 bg-neutral-25 text-neutral-800",
			icon: "text-neutral-800"
		},
		success: {
			wrapper: "border-success-500 bg-success-25 text-success-800",
			icon: "text-success-500"
		},
		warning: {
			wrapper: "border-accent1-500 bg-accent1-50 text-accent1-900",
			icon: "text-accent1-500"
		},
		error: {
			wrapper: "border-error-500 bg-error-25 text-error-800",
			icon: "text-error-500"
		}
	} }
});
const getIcon = {
	info: InfoIcon,
	success: CheckCircleIcon,
	warning: AlertTriangleIcon,
	error: AlertTriangleIcon
};
/**
* Banner Component
*
* This is a general purpose banner that should be dismissible, and may include a CTA.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3868-46230&t=w41lFJEgxz1Jajrl-0)
*/
function Banner({ className, id, "data-testid": dataTestId, children, variant, isDismissable = true, onDismiss }) {
	const { wrapper, icon: iconStyles } = bannerStyles({ variant });
	const Icon = getIcon[variant];
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: wrapper({ className }),
		children: [
			/* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Icon, { className: iconStyles() }) }),
			/* @__PURE__ */ jsx("div", {
				className: "grow",
				children
			}),
			isDismissable && /* @__PURE__ */ jsx("span", {
				className: "ml-2 self-start",
				children: /* @__PURE__ */ jsx(Button$1, {
					icon: XIcon,
					variant: "ghost",
					color: "neutral",
					size: "md",
					onPress: onDismiss,
					"data-testid": `${dataTestId ? `${dataTestId}-` : ""}banner-dismiss-button`
				})
			})
		]
	});
}
Banner.Title = function Title({ children }) {
	return /* @__PURE__ */ jsx("div", {
		className: "text-body-1 font-semibold",
		children
	});
};
Banner.Description = function Description({ className, children }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("max-w-[720px] text-body-2", className),
		children
	});
};
Banner.CTA = function CTA({ children, onClick }) {
	return /* @__PURE__ */ jsx("div", {
		className: "mt-3",
		children: /* @__PURE__ */ jsx(Link$1, {
			color: "neutral",
			size: "lg",
			onPress: onClick,
			className: "cursor-pointer underline",
			target: "_blank",
			children
		})
	});
};
//#endregion
//#region src/negroni/Breadcrumbs/Breadcrumbs.tsx
/** Individual breadcrumb, used in the Breadcrumbs component. */
function Breadcrumb$1({ id, className, style, children, label, ...rest }) {
	return /* @__PURE__ */ jsxs(Breadcrumb, {
		id: id ?? label,
		className: cx(className, "group flex items-center gap-1"),
		style,
		children: [/* @__PURE__ */ jsx(Link, {
			...rest,
			className: "data-[disabled]:[&:not([data-current])]text-neutral-400 cursor-pointer text-body-1 font-semibold text-neutral-600 outline-none data-[disabled]:pointer-events-none data-[current]:cursor-default data-[current]:font-semibold data-[current]:text-neutral-800 data-[hovered]:text-brand-500 data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf data-[current]:hover:text-neutral-800 last:[&>svg]:hidden",
			children: label ?? children
		}), /* @__PURE__ */ jsx(ChevronRightIcon, {
			className: "group-last:hidden",
			size: "sm"
		})]
	});
}
/**
* Breadcrumbs show a hierarchy of links to the current page/section.
*/
function Breadcrumbs$1({ className, ...props }) {
	return /* @__PURE__ */ jsx(Breadcrumbs, {
		...props,
		className: cn("flex gap-1", className),
		children: ({ label, id, ...restItemProps }) => /* @__PURE__ */ jsx(Breadcrumb$1, {
			id: id ?? label,
			...restItemProps,
			children: label
		})
	});
}
//#endregion
//#region src/negroni/BulletList/BulletList.tsx
const BulletListStyles = tv({
	slots: {
		wrapper: "flex flex-col p-2 text-body-1 text-neutral-800",
		item: "",
		icon: "flex-none self-auto text-brand-500"
	},
	variants: { hasIcon: {
		true: {
			wrapper: "gap-y-4",
			item: "flex flex-row gap-x-3"
		},
		false: {
			wrapper: "ml-6 list-outside list-disc gap-y-2",
			item: ""
		}
	} }
});
/**
* BulletList - A simple bulleted list with customizable bullet icons.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=7238-230337&t=0nSvjG4PuCHRrEJj-0)
*/
function BulletList({ content, icon: Icon, iconProps, id, "data-testid": dataTestId, className }) {
	const hasIcon = !!Icon;
	const { wrapper, item: itemStyle, icon: iconStyle } = BulletListStyles();
	return /* @__PURE__ */ jsx("ul", {
		className: wrapper({
			hasIcon,
			className
		}),
		id,
		"data-testid": dataTestId,
		children: content.map((item) => /* @__PURE__ */ jsxs("li", {
			className: itemStyle({ hasIcon }),
			children: [hasIcon && /* @__PURE__ */ jsx(Icon, {
				...iconProps,
				className: iconStyle({ className: iconProps?.className })
			}), item]
		}, item))
	});
}
//#endregion
//#region src/utils/getChildrenBySlots.ts
const getSlotByComponent = (slots, component) => Object.keys(slots).find((key) => isValidElement(component) && slots[key] === component.type);
/**
* Converts children to a map of defined slots
* @example
* ```ts
* const { component: componentReactNodes, rest: restOfChildrenNodes } = getChildrenBySlots(children, {slotName: Component});
* ```
*
* @example
* ```ts
* Component.slot = 'component'
* const { component: componentReactNodes, rest: restOfChildrenNodes } = getChildrenBySlots(children);
* ```
*/
const getChildrenBySlots = (children, slots) => {
	let normalizedChildren;
	if (children instanceof Array) normalizedChildren = Children.toArray(children.flatMap((child) => {
		if (isFragment(child) && isValidElement(child)) {
			const fragmentChildren = child.props.children;
			return fragmentChildren ? Children.toArray(fragmentChildren) : [];
		}
		return child;
	}));
	else normalizedChildren = Children.toArray(children);
	return normalizedChildren.reduce((slottedResults, child) => {
		let slot = getSlotByComponent(slots ?? {}, child);
		slot = !slot && isValidElement(child) ? child.type?.slot : slot;
		if (slot) return {
			...slottedResults,
			[slot]: [...slottedResults[slot] ?? [], child]
		};
		return {
			...slottedResults,
			rest: [...slottedResults.rest, child]
		};
	}, { rest: [] });
};
//#endregion
//#region src/utils/mergeRefs.ts
function mergeRefs(...refs) {
	return (element) => {
		refs.forEach((ref) => {
			if (typeof ref === "function") ref(element);
			else if (ref) ref.current = element;
		});
	};
}
//#endregion
//#region src/negroni/Checkbox/Checkbox.tsx
const checkboxStyles = tv({ slots: {
	wrapper: "label group relative flex cursor-pointer items-center justify-center gap-3 transition duration-200 ease-in-out data-[disabled]:cursor-default data-[disabled]:text-neutral-400",
	box: `pointer-cursor flex size-6 min-w-6 items-center justify-center rounded-lg border border-neutral-100 bg-neutral-0 outline-none transition-all duration-200 ease-in-out group-data-[disabled]:pointer-events-none group-data-[disabled]:border-neutral-400 group-data-[disabled]:group-data-[selected]:border-neutral-100 group-data-[hovered]:border-brand-600 group-data-[invalid]:border-error-500 group-data-[invalid]:group-data-[disabled]:border-neutral-400 group-data-[invalid]:group-data-[hovered]:border-brand-500 group-data-[selected]:border-brand-600 group-data-[selected]:group-data-[hovered]:border-brand-700 group-data-[disabled]:bg-neutral-100 group-data-[disabled]:group-data-[selected]:bg-neutral-100 group-data-[hovered]:bg-accent1-100 group-data-[invalid]:group-data-[disabled]:bg-neutral-100 group-data-[invalid]:group-data-[selected]:bg-error-500 group-data-[invalid]:group-data-[selected]:group-data-[hovered]:bg-brand-500 group-data-[selected]:bg-brand-600 group-data-[selected]:group-data-[hovered]:bg-brand-700 group-data-[hovered]:shadow-level-3 group-data-[focus-visible]:outline-2 group-data-[focus-visible]:outline-kbf`,
	check: "animate-fade-in-grow-200ms text-white group-data-[disabled]:text-neutral-400"
} });
/**
* Checkbox component (base)
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3851-46074&t=H3GPlm3IPDMwchJY-0)
*
* [RAC Checkbox](https://react-spectrum.adobe.com/react-aria/Checkbox.html)
*/
function Checkbox$1({ className, ...props }) {
	const { wrapper, box, check } = checkboxStyles();
	return /* @__PURE__ */ jsx(Checkbox, {
		...props,
		className: (checkboxRenderProps) => cx(wrapper(), typeof className === "function" ? className(checkboxRenderProps) : className),
		children: ({ isIndeterminate, isSelected }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
			className: box(),
			children: [isSelected && !isIndeterminate && /* @__PURE__ */ jsx(CheckIcon, {
				size: "sm",
				className: check()
			}), isIndeterminate && /* @__PURE__ */ jsx(MinusIcon, {
				size: "sm",
				className: check()
			})]
		}), /* @__PURE__ */ jsx("div", {
			className: "flex-1",
			children: props.children
		})] })
	});
}
//#endregion
//#region src/negroni/utils/createPickerSelectionEvent.ts
const eventType = "picker_select";
function createPickerSelectionEvent(detail) {
	return new CustomEvent(eventType, {
		detail,
		bubbles: true,
		cancelable: false
	});
}
//#endregion
//#region src/negroni/PickerOption/PickerOption.tsx
/** @internal - used to fire custom browser event for universal tracking purposes */
const emitPickerEvent = (ref, items, label, type = "select") => {
	if (!ref?.current) return;
	const pickerSelectEvent = createPickerSelectionEvent({
		id: items?.map((i) => i.id).join(","),
		name: items?.map((i) => i.name).join(","),
		label,
		type
	});
	ref.current.dispatchEvent(pickerSelectEvent);
};
/** @internal individual options, can be either a ListBoxItem (single select) or MenuItem (multi select) */
const SelectOption = ({ id, name, description, textValue, type = "listbox", isDisabled, testId }) => {
	return /* @__PURE__ */ jsx(type === "listbox" ? ListBoxItem : MenuItem, {
		id,
		textValue: textValue ?? (typeof name === "string" ? name : void 0),
		className: "group flex min-h-[44px] w-full cursor-pointer items-center gap-2 rounded-lg p-2 outline-none transition-colors data-[focus-visible]:bg-accent1-100 data-[hovered]:bg-accent1-100 data-[selection-mode=single]:data-[selected]:bg-accent1-200 data-[disabled]:text-neutral-300",
		isDisabled,
		"data-testid": testId,
		children: ({ selectionMode }) => {
			const { box, check } = checkboxStyles();
			return /* @__PURE__ */ jsxs(Fragment$1, { children: [selectionMode === "multiple" && /* @__PURE__ */ jsx("div", {
				className: box({ className: "flex-none group-data-[focus-visible]:border-brand-500" }),
				children: /* @__PURE__ */ jsx("div", {
					className: "hidden animate-fade-in-grow-200ms group-data-[selected]:block",
					children: /* @__PURE__ */ jsx(CheckIcon, {
						size: "sm",
						className: check()
					})
				})
			}), /* @__PURE__ */ jsxs("div", {
				className: "flex flex-col gap-2",
				children: [/* @__PURE__ */ jsx(Text, {
					slot: "label",
					className: "truncate",
					children: name
				}), description && /* @__PURE__ */ jsx(Text, {
					slot: "description",
					className: "truncate text-body-2 text-neutral-600 group-data-[disabled]:text-neutral-300",
					children: description
				})]
			})] });
		}
	});
};
//#endregion
//#region src/negroni/FieldLabels/FieldLabels.tsx
/** @internal */
function FieldLabels({ label, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick }) {
	return (label || secondaryLabel) && /* @__PURE__ */ jsxs("div", {
		className: "flex items-center justify-between text-footnote",
		children: [label && /* @__PURE__ */ jsx(Label, { children: label }), secondaryLabel && (!!secondaryHref || !!onSecondaryClick ? /* @__PURE__ */ jsx(Link$1, {
			className: secondaryClassName,
			onPress: onSecondaryClick,
			href: secondaryHref,
			children: secondaryLabel
		}) : /* @__PURE__ */ jsx("span", {
			className: "text-neutral-600",
			children: secondaryLabel
		}))]
	});
}
//#endregion
//#region src/negroni/ListBox/ListBox.tsx
const listBoxStyles = tv({ slots: {
	listbox: "max-h-[inherit] w-full overflow-auto rounded-lg border bg-neutral-0 fill-neutral-0 stroke-neutral-100 p-2 shadow-level-3 outline-none data-[focus-visible]:outline-kbf",
	item: "flex min-h-[44px] cursor-pointer flex-col justify-center gap-2 rounded-lg p-2 outline-none aria-selected:bg-accent1-200 data-[focused]:bg-accent1-100 data-[hovered]:bg-accent1-100 data-[focused]:aria-selected:bg-accent1-200"
} });
const { listbox, item } = listBoxStyles();
const ListBox$1 = ({ children, className, selectionMode = "single", ...props }) => /* @__PURE__ */ jsx(ListBox, {
	...props,
	className: listbox({ className }),
	selectionMode,
	children
});
const ListBoxItem$1 = ({ children, className, textValue: textValueProp, ...props }) => {
	const textValue = textValueProp ?? (typeof children === "string" ? children : void 0);
	return /* @__PURE__ */ jsx(ListBoxItem, {
		className: item({ className }),
		textValue,
		...props,
		children
	});
};
//#endregion
//#region src/negroni/Select/Select.common.tsx
const selectStyles = tv({
	slots: {
		root: "group flex w-full flex-col gap-1",
		button: "group/trg flex w-full items-center justify-between gap-2 whitespace-nowrap rounded-lg border border-neutral-100 bg-white p-2 text-body-1 text-neutral-300 outline-none data-[disabled]:border-neutral-300 data-[pressed]:border-neutral-800 data-[disabled]:bg-neutral-50 data-[disabled]:text-neutral-400 group-data-[focused]:border-neutral-800 group-data-[invalid]:border-error-500 group-data-[invalid]:bg-error-25 group-data-[focused]:text-neutral-800",
		icon: "flex-none transition-all duration-300 group-data-[open]:rotate-180",
		popover: `min-w-[max(var(--trigger-width),theme(spacing.56))] max-w-[calc(100vw-theme(spacing.16))] outline-none ${popoverAnimationClasses}`,
		descText: "text-footnote text-neutral-600",
		errText: "text-footnote text-error"
	},
	variants: { variant: {
		form: {
			button: "h-12 border px-3 py-1 transition-[border-color]",
			icon: "text-neutral-300 group-data-[focused]:text-neutral-800"
		},
		filter: { button: "h-8 border p-2 text-neutral-800 data-[pressed]:bg-neutral-100 group-data-[focus-visible]:border-neutral-800 group-data-[focused]:border-neutral-100 group-data-[selection]:border-neutral-800 group-data-[focus-visible]:bg-neutral-100 group-data-[open]:bg-neutral-100" },
		table: {
			button: "group/trg h-8 border-transparent bg-transparent px-3 py-1 text-neutral-300 data-[pressed]:border-neutral-800 data-[hovered]:bg-neutral-50",
			icon: "text-transparent group-data-[focused]:text-neutral-800 group-data-[hovered]/trg:text-neutral-300"
		}
	} },
	defaultVariants: { variant: "form" }
});
const preComputedStyles = selectStyles();
const getAreOptionsGrouped = (options) => {
	return Array.isArray(options) && options.some((option) => "children" in option);
};
/** @internal The Button triger for single- and multi- selects */
const SelectTrigger = ({ variant = "form", isDisabled, children, className, "aria-label": ariaLabel }) => {
	const { button: buttonStyle, icon: iconStyle } = preComputedStyles;
	return /* @__PURE__ */ jsxs(Button, {
		"aria-label": ariaLabel,
		className: buttonStyle({
			variant,
			className
		}),
		isDisabled,
		children: [children, /* @__PURE__ */ jsx(ChevronDownIcon, {
			size: variant === "form" ? "sm" : "xs",
			className: iconStyle({ variant })
		})]
	});
};
/**
* @internal Common content for single and multi-select components, namely the trigger structure, popover content,
* and field labels
*/
const CommonSelectContent = ({ label, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick, className, description, variant, options, errorMessage, children, isDisabled, "aria-label": ariaLabel }) => {
	const { descText, errText, popover } = preComputedStyles;
	const areOptionsGrouped = getAreOptionsGrouped(options);
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsx(FieldLabels, {
			label,
			secondaryLabel,
			secondaryHref,
			secondaryClassName,
			onSecondaryClick
		}),
		/* @__PURE__ */ jsx(SelectTrigger, {
			variant,
			isDisabled,
			className,
			"aria-label": ariaLabel,
			children
		}),
		description && /* @__PURE__ */ jsx(Text, {
			slot: "description",
			className: descText(),
			children: description
		}),
		/* @__PURE__ */ jsx(FieldError, {
			className: errText(),
			children: errorMessage
		}),
		/* @__PURE__ */ jsx(PopoverWrapper, {
			className: popover(),
			children: areOptionsGrouped ? /* @__PURE__ */ jsx(ListBox$1, {
				items: options,
				children: (group) => /* @__PURE__ */ jsxs(ListBoxSection, {
					id: group.name,
					className: "-mx-2 mb-2 border-b border-neutral-100 px-2 pb-2 last:border-b-0 last:pb-0",
					children: [/* @__PURE__ */ jsx(Header, {
						className: "p-2 font-bold",
						children: group.name
					}), /* @__PURE__ */ jsx(Collection, {
						items: group.children,
						children: (item) => /* @__PURE__ */ jsx(SelectOption, { ...item })
					})]
				})
			}) : /* @__PURE__ */ jsx(ListBox$1, {
				items: options,
				children: (item) => /* @__PURE__ */ jsx(SelectOption, { ...item })
			})
		})
	] });
};
//#endregion
//#region src/negroni/Select/MultiSelect.tsx
const _MultiSelect = (props, ref) => {
	const { label, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick, className, containerClassName, description, icon: Icon, variant, options, triggerText, errorMessage, isMultiSelect, isInvalid, onChange, onSelectionChange, defaultValue, defaultSelectedKeys, value, selectedKeys, placeholder, ...selectProps } = props;
	const { root } = preComputedStyles;
	const flattenedOptions = getAreOptionsGrouped(options) ? options.flatMap((group) => group.children) : options;
	const normalizedValue = normalizeValue(value, selectedKeys, flattenedOptions);
	const normalizedDefaultValue = normalizeValue(defaultValue, defaultSelectedKeys, flattenedOptions);
	const selectRef = useRef(null);
	const combinedRef = mergeRefs(ref, selectRef);
	const handleChange = (val) => {
		onChange?.(val);
		onSelectionChange?.(new Set(val ?? []));
		const items = flattenedOptions?.filter((option) => val.includes(option.id));
		emitPickerEvent(selectRef, items, label);
	};
	return /* @__PURE__ */ jsx(Select, {
		...selectProps,
		selectionMode: "multiple",
		className: root({ className: containerClassName }),
		onChange: handleChange,
		value: normalizedValue,
		defaultValue: normalizedDefaultValue,
		ref: combinedRef,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		children: /* @__PURE__ */ jsxs(CommonSelectContent, {
			...props,
			children: [Icon && /* @__PURE__ */ jsx(Icon, {
				size: "sm",
				className: "flex-none"
			}), /* @__PURE__ */ jsx(SelectValue, {
				className: "flex grow items-center gap-2 overflow-hidden text-neutral-800 data-[placeholder]:text-inherit [&_[slot=description]]:hidden",
				children: ({ selectedItems }) => {
					const itemsCount = selectedItems.length;
					return itemsCount >= 1 ? /* @__PURE__ */ jsxs("div", {
						className: "flex grow items-center justify-between gap-2 overflow-hidden text-left text-neutral-800",
						children: [/* @__PURE__ */ jsx("div", {
							className: "truncate",
							children: triggerText || placeholder || "Values"
						}), /* @__PURE__ */ jsxs("div", {
							className: "flex-none",
							children: [
								"(",
								itemsCount,
								")"
							]
						})]
					}) : /* @__PURE__ */ jsx("div", {
						className: "grow truncate text-left",
						children: placeholder || triggerText || "Select values"
					});
				}
			})]
		})
	});
};
const normalizeValue = (value, selectedKeys, flattenedOptions) => {
	if (value !== void 0) return value;
	if (selectedKeys === "all") return flattenedOptions?.map((option) => option.id);
	if (selectedKeys !== void 0) return [...selectedKeys];
};
/**
* @internal
* Multiple selection dropdown component, based on RAC Menu for keyboard a11y
* TODO: Add support for HTML forms and validation:
* * Add validation hooks
* * Add hidden input for form submission
*/
const MultiSelect = forwardRef(_MultiSelect);
//#endregion
//#region src/negroni/Select/SingleSelect.tsx
const _SingleSelect = (props, ref) => {
	const { label, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick, className, containerClassName, description, icon: Icon, variant, options, triggerText, errorMessage, isMultiSelect, isInvalid, onChange, value, selectedKey, ...selectProps } = props;
	const { root } = preComputedStyles;
	const normalizedValue = value !== void 0 ? value : selectedKey;
	const flattenedOptions = getAreOptionsGrouped(options) ? options.flatMap((group) => group.children) : options;
	const selectRef = useRef(null);
	const combinedRef = mergeRefs(ref, selectRef);
	const handleChange = (val) => {
		onChange?.(val);
		const item = val ? flattenedOptions?.find((option) => option.id === val) : void 0;
		emitPickerEvent(selectRef, item ? [item] : void 0, label);
	};
	return /* @__PURE__ */ jsx(Select, {
		...selectProps,
		selectionMode: "single",
		className: root({ className: containerClassName }),
		onChange: handleChange,
		value: normalizedValue,
		ref: combinedRef,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		children: /* @__PURE__ */ jsx(CommonSelectContent, {
			...props,
			children: /* @__PURE__ */ jsx(SelectValue, {
				className: "flex grow items-center gap-2 overflow-hidden text-neutral-800 data-[placeholder]:text-inherit [&_[slot=description]]:hidden",
				children: ({ defaultChildren, isPlaceholder }) => /* @__PURE__ */ jsxs(Fragment$1, { children: [Icon && /* @__PURE__ */ jsx(Icon, {
					size: "sm",
					className: "flex-none"
				}), /* @__PURE__ */ jsx("span", {
					className: "truncate pr-1 text-left",
					children: isPlaceholder ? defaultChildren || triggerText : triggerText || defaultChildren
				})] })
			})
		})
	});
};
/**
* @internal
* Single selection component based on RAC Select
*/
const SingleSelect = forwardRef(_SingleSelect);
//#endregion
//#region src/negroni/Select/Select.tsx
const _Select = (props, ref) => {
	const typedProps = props;
	return typedProps.isMultiSelect === true ? /* @__PURE__ */ jsx(MultiSelect, {
		...typedProps,
		ref
	}) : /* @__PURE__ */ jsx(SingleSelect, {
		...typedProps,
		ref
	});
};
/**
* Combined selection component that handles both single- and multiple- selection use cases.
*
* [Figma Specs](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=81-569&mode=design&t=UfibUGmY5BVmo3IM-0)
*
* This component switches between single- and multi-select based on the `isMultiselect` prop,
* which drives value types and which props are available.
*
* **New!** Validation and HTML forms are now supported in both modes.
*/
const Select$1 = forwardRef(_Select);
//#endregion
//#region src/negroni/Calendar/MonthSelect.tsx
/**
* @internal MonthSelect component for the Calendar component.
*/
function MonthSelect() {
	const { focusedDate, minValue, maxValue, setFocusedDate } = useContext(CalendarStateContext);
	const formatter = useDateFormatter({ month: "long" });
	const months = useMemo(() => {
		const monthOptions = [];
		for (let m = 0; m < 12; m++) {
			if (minValue && focusedDate.year === minValue.year && m < minValue.month - 1) continue;
			if (maxValue && focusedDate.year === maxValue.year && m > maxValue.month - 1) continue;
			const date = new Date(focusedDate.year, m, 1);
			monthOptions.push({
				id: m,
				name: formatter.format(date)
			});
		}
		return monthOptions;
	}, [
		minValue,
		maxValue,
		focusedDate,
		formatter
	]);
	return /* @__PURE__ */ jsx(Select$1, {
		variant: "filter",
		"aria-label": "Month",
		options: months,
		value: focusedDate.month - 1,
		onChange: (key) => {
			if (key != null) setFocusedDate(focusedDate.set({ month: key + 1 }));
		}
	});
}
/**
* @internal YearSelect component for the Calendar component.
*/
function YearSelect() {
	const { focusedDate, minValue, maxValue, setFocusedDate } = useContext(CalendarStateContext);
	const years = useMemo(() => {
		const minYear = minValue ? minValue.year : focusedDate.year - 20;
		const maxYear = maxValue ? maxValue.year : focusedDate.year + 20;
		const yearOpts = [];
		for (let y = minYear; y <= maxYear; y++) yearOpts.push({
			id: y,
			name: String(y)
		});
		return yearOpts;
	}, [
		minValue,
		maxValue,
		focusedDate
	]);
	return /* @__PURE__ */ jsx(Select$1, {
		variant: "filter",
		"aria-label": "Year",
		options: years,
		value: focusedDate.year,
		onChange: (key) => {
			if (key != null) setFocusedDate(focusedDate.set({ year: key }));
		}
	});
}
//#endregion
//#region src/negroni/Calendar/Calendar.tsx
const calendarStyles$1 = tv({
	slots: {
		wrapper: "absolute flex items-center justify-end",
		content: "w-76 top-full items-center justify-center rounded-md border border-neutral-100 bg-white p-2 shadow-lg",
		headerWrapper: "flex items-center justify-between pt-1",
		headerButton: "outline-none data-[disabled]:text-neutral-300 data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf",
		calendarHeaderCell: "pt-4 text-body-2 text-gray-700",
		monthHeader: "text-body-2 font-semibold",
		calendarCell: "relative flex size-10 items-center justify-center rounded-lg p-3 text-body-2 outline-none aria-[disabled]:pointer-events-none aria-[disabled]:text-gray-500 data-[hovered]:bg-accent2-50 data-[selected]:bg-accent2-400 data-[selected]:data-[hovered]:bg-accent2-400 data-[outside-month]:text-gray-500 data-[selected]:text-white data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf aria-[disabled]:data-[hovered]:bg-inherit"
	},
	variants: {
		isTodaysDate: { true: { calendarCell: "border border-neutral-400 font-semibold data-[hovered]:border-none data-[selected]:border-none" } },
		hasEvent: { true: { calendarCell: "after:absolute after:bottom-1.5 after:h-1 after:w-1 after:rounded-full after:bg-brand after:content-[\"\"]" } }
	}
});
/**
* A calendar displays one or more date grids and allows users to select a single date.
*
* Construct + manipulate dates by using objects and methods from the ['\@internationalized/date'](https://react-spectrum.adobe.com/internationalized/date/index.html) package.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=4079-39787&mode=design&t=jhg0hzomCLcC8cRD-0)
*
* [RAC Calendar](https://react-spectrum.adobe.com/react-aria/Calendar.html)
*
* See [Storybook](https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/negroni-date-time-calendar--docs) for more detailed usage and examples.
*
*/
function Calendar$1(props) {
	const { datesWithEvents, showPickers, ...restProps } = props;
	const { wrapper, content, headerWrapper, headerButton, calendarHeaderCell, monthHeader, calendarCell } = calendarStyles$1();
	return /* @__PURE__ */ jsx(Calendar, {
		...restProps,
		children: /* @__PURE__ */ jsx("div", {
			className: wrapper(),
			children: /* @__PURE__ */ jsxs("div", {
				className: content(),
				children: [/* @__PURE__ */ jsxs("header", {
					className: headerWrapper(),
					children: [
						/* @__PURE__ */ jsx(Button, {
							className: headerButton(),
							slot: "previous",
							children: /* @__PURE__ */ jsx(ChevronLeftIcon, {})
						}),
						showPickers ? /* @__PURE__ */ jsxs("div", {
							className: "flex items-center gap-1",
							children: [/* @__PURE__ */ jsx(MonthSelect, {}), /* @__PURE__ */ jsx(YearSelect, {})]
						}) : /* @__PURE__ */ jsx(Heading, { className: monthHeader() }),
						/* @__PURE__ */ jsx(Button, {
							className: headerButton(),
							slot: "next",
							children: /* @__PURE__ */ jsx(ChevronRightIcon, {})
						})
					]
				}), /* @__PURE__ */ jsx("div", {
					className: "pt-1",
					children: /* @__PURE__ */ jsxs(CalendarGrid, { children: [/* @__PURE__ */ jsx(CalendarGridHeader, { children: (day) => /* @__PURE__ */ jsx(CalendarHeaderCell, {
						className: calendarHeaderCell(),
						children: day
					}) }), /* @__PURE__ */ jsx(CalendarGridBody, { children: (date) => {
						return /* @__PURE__ */ jsx(CalendarCell, {
							date,
							className: calendarCell({
								isTodaysDate: isToday(date, getLocalTimeZone()),
								hasEvent: datesWithEvents?.some((eventDate) => date.compare(eventDate) === 0)
							})
						});
					} })] })
				})]
			})
		})
	});
}
//#endregion
//#region src/negroni/Card/Card.tsx
/**
* Card component (base)
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3851-46074&t=H3GPlm3IPDMwchJY-0)
*/
function Card({ className, children, id, "data-testid": dataTestId }) {
	return /* @__PURE__ */ jsx("div", {
		id,
		"data-testid": dataTestId,
		className: cx("min-w-[280px] overflow-hidden rounded-lg bg-white", className),
		children
	});
}
Card.Header = function Header(props) {
	return /* @__PURE__ */ jsx("div", {
		className: "box-content flex h-8 items-center justify-between gap-4 px-4 pb-4 pt-4 md:px-6 md:pt-6",
		...props
	});
};
Card.Body = function Body({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cx(className, "px-4 md:px-6"),
		...props
	});
};
Card.Footer = function Footer({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cx(className, "flex justify-between p-4 md:p-6"),
		...props
	});
};
/**
* This Section is meant to be used within Card.Header or Card.Footer
*/
function Section({ className, ...props }) {
	return /* @__PURE__ */ jsx("div", {
		className: cx(className, "flex items-center gap-3"),
		...props
	});
}
Card.HeaderSection = Section;
Card.FooterSection = Section;
//#endregion
//#region src/negroni/PaginationDots/PageCounter.tsx
const pageCounterStyles = tv({
	slots: {
		container: "relative h-fit w-fit max-w-[160px] overflow-hidden rounded-lg px-2 py-0.5 text-body-2",
		activePage: ""
	},
	variants: { theme: {
		default: {
			container: "bg-neutral-700 text-neutral-400",
			activePage: "text-white"
		},
		brand: {
			container: "text-neutral-600",
			activePage: "text-neutral-800"
		}
	} }
});
/**
* PageCounter component
*
* [Figma](https://www.figma.com/design/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?node-id=37084-246364&t=HWHP6GXm1A246DHl-0)
*/
function PageCounter({ className, id, "data-testid": dataTestId, theme = "default", pageCount, activePage }) {
	const { container, activePage: activePageStyle } = pageCounterStyles();
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: container({
			theme,
			className
		}),
		children: [
			/* @__PURE__ */ jsx("span", {
				className: activePageStyle({ theme }),
				children: activePage
			}),
			"/",
			pageCount
		]
	});
}
//#endregion
//#region src/negroni/PaginationDots/PaginationDots.tsx
const paginationDotsStyles = tv({
	slots: {
		container: "relative h-6 w-fit max-w-[160px] overflow-hidden rounded-lg p-2",
		dot: "mr-2 h-2 w-2 shrink-0 overflow-hidden rounded-full transition-all duration-200 ease-out last:mr-0 data-[focused]:outline-none data-[focus-visible]:outline data-[focus-visible]:outline-kbf"
	},
	variants: {
		theme: {
			default: {
				container: "bg-neutral-700",
				dot: "bg-neutral-500"
			},
			brand: {
				container: "",
				dot: "bg-neutral-300"
			}
		},
		active: { true: { dot: "w-4" } }
	},
	compoundVariants: [{
		theme: "brand",
		active: true,
		class: { dot: "bg-brand-500" }
	}, {
		theme: "default",
		active: true,
		class: { dot: "bg-white" }
	}]
});
function PaginationDot({ itemNumber, isActive, theme, className, onClick }) {
	const { dot } = paginationDotsStyles();
	return /* @__PURE__ */ jsx(Button, {
		onPress: () => onClick(itemNumber),
		className: dot({
			theme,
			active: isActive,
			className
		})
	});
}
const maxDots = 9;
/**
* PaginationDots component
*
* [Figma](https://www.figma.com/design/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?node-id=37084-246364&t=HWHP6GXm1A246DHl-0)
*/
function PaginationDots({ className, id, "data-testid": dataTestId, pageCount, theme = "default", activePage, onChange }) {
	const [offSet, setOffSet] = useState(0);
	const { container } = paginationDotsStyles();
	const hasOverflow = pageCount > maxDots;
	const handleDotClick = (index) => onChange?.(index);
	const dots = Array.from({ length: pageCount }, (v, i) => {
		const indexItem = i + 1;
		return /* @__PURE__ */ jsx(PaginationDot, {
			itemNumber: indexItem,
			isActive: activePage === indexItem,
			onClick: () => handleDotClick(indexItem),
			theme,
			className: hasOverflow && (indexItem === maxDots + offSet && indexItem !== pageCount || offSet > 0 && i === offSet) ? "my-px mr-2.5 h-1.5 w-1.5" : ""
		}, indexItem);
	});
	useEffect(() => {
		if (hasOverflow) if (activePage > maxDots - 5) {
			const maxOffset = pageCount - maxDots;
			setOffSet(Math.min(maxOffset, activePage - (maxDots - 5)));
		} else setOffSet(0);
	}, [
		activePage,
		hasOverflow,
		pageCount,
		offSet,
		setOffSet
	]);
	return /* @__PURE__ */ jsx("div", {
		id,
		"data-testid": dataTestId,
		className: container({
			theme,
			className
		}),
		children: /* @__PURE__ */ jsx("div", {
			className: "relative flex transition-all duration-200 ease-out",
			style: { transform: `translate(${-16 * offSet}px, 0px)` },
			children: dots
		})
	});
}
//#endregion
//#region src/negroni/Carousel/CarouselContext.tsx
const CarouselContext = createContext(null);
function CarouselProvider({ pageCount, isInfiniteScroll, children }) {
	const [activePage, setActivePage] = useState(1);
	const goToNextPage = () => {
		if (activePage < pageCount) setActivePage(activePage + 1);
		else if (isInfiniteScroll && activePage === pageCount) setActivePage(1);
	};
	const goToPrevPage = () => {
		if (activePage > 1) setActivePage(activePage - 1);
		else if (isInfiniteScroll && activePage === 1) setActivePage(pageCount);
	};
	return /* @__PURE__ */ jsx(CarouselContext.Provider, {
		value: {
			activePage,
			setActivePage,
			goToNextPage,
			goToPrevPage,
			isInfiniteScroll
		},
		children
	});
}
const useCarouselContext = () => {
	const context = useContext(CarouselContext);
	if (context === null) {
		const err = /* @__PURE__ */ new Error("Missing CarouselProvider");
		if (Error.captureStackTrace) Error.captureStackTrace(err, useCarouselContext);
		throw err;
	}
	return context;
};
//#endregion
//#region src/negroni/Carousel/Carousel.tsx
const carouselStyles = tv({
	slots: {
		wrapper: "h-fit",
		title: "mb-3 text-base font-semibold text-neutral-800",
		tray: "flex snap-x snap-mandatory [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
		carouselButton: "absolute top-1/2 -translate-y-1/2 transition-all duration-100 ease-in",
		carouselItem: "relative",
		paginationContainer: "flex gap-2"
	},
	variants: {
		paginationPlacement: {
			insideLeft: { paginationContainer: "absolute bottom-4 left-4" },
			insideCentered: { paginationContainer: "absolute bottom-4 left-1/2 -translate-x-1/2 transform" },
			insideRight: { paginationContainer: "absolute bottom-4 right-4" },
			outsideLeft: { paginationContainer: "relative mt-4" },
			outsideCentered: { paginationContainer: "relative mt-4 justify-center" },
			outsideRight: { paginationContainer: "relative mt-4 justify-end" }
		},
		scrollVariant: {
			fullWidth: {
				tray: "w-full gap-1 overflow-x-scroll",
				carouselItem: "flex w-full min-w-full snap-start snap-always items-center justify-center transition-transform duration-300 ease-in-out motion-reduce:transition-none"
			},
			cards: {
				tray: "flex-nowrap items-stretch justify-start gap-2 overflow-auto [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
				carouselItem: "flex max-w-[90%] snap-proximity snap-center md:snap-start"
			}
		},
		isHidden: { true: { carouselButton: "invisible opacity-0" } },
		carouselButtonScrollPosition: {
			left: { carouselButton: "left-4" },
			right: { carouselButton: "right-4" }
		}
	}
});
/**
* Carousel component
*
* [Figma](https://www.figma.com/design/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?node-id=37084-246719&t=lLlMpkusWlWzPsvc-0)
*/
function CarouselBase({ items = [], className = "", arrowSize = "md", scrollVariant = "cards", paginationPlacement = "insideCentered", children, hideArrows, hideArrowsUntilHover, showPageCounter, showPaginationDots }) {
	const { wrapper, tray, carouselButton, carouselItem, paginationContainer } = carouselStyles();
	const { activePage, setActivePage, goToNextPage, goToPrevPage } = useCarouselContext();
	const scrollRef = useRef(null);
	const prefersReducedMotion = typeof window !== "undefined" && window.matchMedia("(prefers-reduced-motion: reduce)")?.matches;
	const [isHovered, setIsHovered] = useState(false);
	const [hideLeftArrow, setHideLeftArrow] = useState(true);
	const [hideRightArrow, setHideRightArrow] = useState(false);
	const getScrollValue = useCallback((direction) => {
		if (scrollRef.current) {
			const parentBounds = scrollRef.current.getBoundingClientRect();
			if (scrollRef.current?.children?.length && parentBounds) for (const child of scrollRef.current.children) {
				const childBounds = child.getBoundingClientRect();
				if (direction === "next" && childBounds.right > parentBounds.right && childBounds.left > parentBounds.left || direction === "prev" && childBounds.left > -scrollRef.current.clientWidth) return childBounds.left - parentBounds.left;
			}
			return .75 * (scrollRef?.current?.clientWidth || 0);
		}
	}, [scrollRef]);
	const jumpToPage = useCallback((page) => {
		if (scrollRef.current) {
			const value = (page - 1) * scrollRef.current.clientWidth;
			if (value >= 0) scrollRef?.current?.scrollTo({
				left: value,
				behavior: prefersReducedMotion ? "instant" : "smooth"
			});
		}
	}, [scrollRef, prefersReducedMotion]);
	const handleNextArrowPress = () => {
		if (scrollVariant === "fullWidth") goToNextPage();
		else scrollRef?.current?.scrollBy({
			left: getScrollValue("next"),
			behavior: prefersReducedMotion ? "instant" : "smooth"
		});
	};
	const handlePrevArrowPress = () => {
		if (scrollVariant === "fullWidth") goToPrevPage();
		else scrollRef?.current?.scrollBy({
			left: getScrollValue("prev"),
			behavior: prefersReducedMotion ? "instant" : "smooth"
		});
	};
	const hideBothArrows = hideArrows || hideArrowsUntilHover && !isHovered || scrollVariant === "fullWidth" && showPaginationDots || Boolean(scrollRef?.current && scrollRef.current.clientWidth === scrollRef.current.scrollWidth);
	const setArrowVisibilityOnScroll = () => {
		const hideRight = Boolean(scrollRef.current && scrollRef.current?.scrollLeft + scrollRef.current?.clientWidth >= scrollRef.current.scrollWidth);
		setHideLeftArrow(scrollRef.current?.scrollLeft === 0 || !scrollRef.current);
		setHideRightArrow(hideRight);
	};
	useEffect(() => {
		if (scrollRef?.current && scrollVariant === "fullWidth") {
			const handleScrollEnd = () => {
				const page = scrollRef?.current ? scrollRef.current.scrollLeft / scrollRef.current.clientWidth : 1;
				const newPage = Math.floor(page) + 1;
				if (newPage !== activePage) setActivePage?.(newPage);
			};
			if (typeof window !== "undefined" && "onscrollend" in window) scrollRef.current.onscrollend = handleScrollEnd;
			else scrollRef.current.onscroll = debounce(handleScrollEnd, 300);
		}
	}, [
		scrollRef,
		scrollVariant,
		activePage,
		setActivePage
	]);
	useEffect(() => {
		if (activePage) jumpToPage(activePage);
	}, [activePage, jumpToPage]);
	return items.length ? /* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("div", {
		className: wrapper({ className }),
		onMouseEnter: () => setIsHovered(true),
		onMouseLeave: () => setIsHovered(false),
		children: /* @__PURE__ */ jsxs("div", {
			className: "relative overflow-hidden",
			children: [
				/* @__PURE__ */ jsx("div", {
					ref: scrollRef,
					className: tray({ scrollVariant }),
					onScroll: setArrowVisibilityOnScroll,
					children: items.map((item, i) => /* @__PURE__ */ jsx("div", {
						className: carouselItem({ scrollVariant }),
						...scrollVariant === "fullWidth" ? {
							"aria-hidden": activePage !== i + 1,
							"aria-roledescription": "slide",
							role: "group"
						} : {},
						children: item.content
					}, item.id))
				}),
				/* @__PURE__ */ jsx("div", {
					className: carouselButton({
						isHidden: hideLeftArrow || hideBothArrows,
						carouselButtonScrollPosition: "left"
					}),
					children: /* @__PURE__ */ jsx(Button$1, {
						"aria-label": "Previous",
						icon: ChevronLeftIcon,
						size: arrowSize,
						variant: "outline",
						color: "neutral",
						onPress: handlePrevArrowPress
					})
				}),
				/* @__PURE__ */ jsx("div", {
					className: carouselButton({
						isHidden: hideRightArrow || hideBothArrows,
						carouselButtonScrollPosition: "right"
					}),
					children: /* @__PURE__ */ jsx(Button$1, {
						"aria-label": "Next",
						icon: ChevronRightIcon,
						size: arrowSize,
						variant: "outline",
						color: "neutral",
						onPress: handleNextArrowPress
					})
				}),
				scrollVariant === "fullWidth" && (showPaginationDots || showPageCounter) && /* @__PURE__ */ jsxs("div", {
					className: paginationContainer({ paginationPlacement: showPaginationDots ? paginationPlacement : void 0 }),
					children: [showPaginationDots && /* @__PURE__ */ jsx(PaginationDots, {
						pageCount: items.length,
						activePage,
						onChange: setActivePage
					}), showPageCounter && /* @__PURE__ */ jsx(PageCounter, {
						activePage,
						pageCount: items.length,
						className: !showPaginationDots ? "absolute left-4 top-4" : ""
					})]
				})
			]
		})
	}), children] }) : null;
}
/**
* A Carousel is a horizontal scrolling area that displays a list of items, such as cards or images.
*/
function Carousel(props) {
	if (useContext(CarouselContext) === null) return /* @__PURE__ */ jsx(CarouselProvider, {
		pageCount: props.items.length,
		isInfiniteScroll: props.isInfiniteScroll,
		children: /* @__PURE__ */ jsx(CarouselBase, { ...props })
	});
	return /* @__PURE__ */ jsx(CarouselBase, { ...props });
}
//#endregion
//#region src/negroni/CheckboxGroup/CheckboxGroup.tsx
/**
* [RAC Checkbox Group](https://react-spectrum.adobe.com/react-aria/CheckboxGroup.html)
*/
function CheckboxGroup$1({ label, description, errorMessage, children, orientation = "horizontal", isDisabled, className, isInvalid, ...props }) {
	return /* @__PURE__ */ jsxs(CheckboxGroup, {
		...props,
		isDisabled,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		children: [
			label && /* @__PURE__ */ jsx("div", {
				className: cn("mb-2", isDisabled && "text-neutral-400"),
				children: /* @__PURE__ */ jsx(Label, { children: label })
			}),
			/* @__PURE__ */ jsx("div", {
				className: cx("flex", orientation === "horizontal" && "gap-8", orientation === "vertical" && "flex-col gap-4", className),
				children
			}),
			description && /* @__PURE__ */ jsx("div", {
				className: "pt-2 text-footnote text-neutral-800",
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: "text-footnote text-error",
				children: errorMessage
			})
		]
	});
}
//#endregion
//#region src/negroni/Color/internal/ColorThumb.tsx
function ColorThumb$1({ className }) {
	return /* @__PURE__ */ jsx(ColorThumb, { className: cx("size-7 rounded-full border-8 border-white ring-1 ring-neutral-200 data-[focus-visible]:ring-4 data-[focus-visible]:ring-kbf", className) });
}
//#endregion
//#region src/negroni/Color/internal/ColorArea.tsx
/** @internal */
function ColorArea$1({ ...props }) {
	return /* @__PURE__ */ jsx(ColorArea, {
		className: "h-60 w-full rounded-lg",
		...props,
		children: /* @__PURE__ */ jsx(ColorThumb$1, { className: "size-7 rounded-full border-8 border-white ring-1 ring-neutral-200 data-[focus-visible]:ring-4 data-[focus-visible]:ring-kbf" })
	});
}
//#endregion
//#region src/negroni/Color/internal/ColorField.tsx
/** @internal */
function ColorField$1({ label, errorMessage, ...props }) {
	return /* @__PURE__ */ jsxs(ColorField, {
		...props,
		children: [
			label && /* @__PURE__ */ jsx(Label, {
				className: "text-footnote",
				children: label
			}),
			/* @__PURE__ */ jsx(Input, { className: "h-12 w-full rounded-lg border border-solid border-neutral-100 bg-neutral-0 px-3 py-4 text-16 text-body-1 text-neutral-800 outline-none transition-[filter,border-color,box-shadow] duration-200 ease-in-out placeholder:text-neutral-300 data-[focused]:border-black data-[invalid]:border-error data-[invalid]:bg-error-25" }),
			/* @__PURE__ */ jsx(FieldError, { children: errorMessage })
		]
	});
}
//#endregion
//#region src/negroni/Color/internal/ColorSlider.tsx
/** @internal */
function ColorSlider$1({ variant }) {
	return /* @__PURE__ */ jsxs(ColorSlider, {
		colorSpace: variant === "hue" ? "hsb" : void 0,
		channel: variant === "alpha" ? "alpha" : "hue",
		className: "flex flex-col gap-2",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex justify-between",
			children: [/* @__PURE__ */ jsx(Label, {}), variant === "alpha" && /* @__PURE__ */ jsx(SliderOutput, {})]
		}), /* @__PURE__ */ jsx(SliderTrack, {
			className: "h-5 rounded-md",
			style: variant === "alpha" ? ({ defaultStyle }) => ({ background: `${defaultStyle.background},
            repeating-conic-gradient(#CCC 0% 25%, white 0% 50%) 50% / 16px 16px` }) : void 0,
			children: /* @__PURE__ */ jsx(ColorThumb$1, { className: "top-1/2" })
		})]
	});
}
//#endregion
//#region src/negroni/Color/internal/ColorSwatch.tsx
const styles$2 = tv({
	base: "rounded-lg",
	variants: { size: {
		xs: "size-5",
		sm: "size-7",
		md: "size-8",
		lg: "size-10"
	} },
	defaultVariants: { size: "md" }
});
/** @internal */
const ColorSwatch$1 = ({ className, size, ...props }) => /* @__PURE__ */ jsx(ColorSwatch, {
	className: styles$2({
		className,
		size
	}),
	...props
});
//#endregion
//#region src/negroni/Color/ColorPicker/ColorPicker.tsx
const colorchannels = {
	rgb: { channels: [
		"red",
		"green",
		"blue"
	] },
	hsl: { channels: [
		"hue",
		"saturation",
		"lightness"
	] },
	hsb: { channels: [
		"hue",
		"saturation",
		"brightness"
	] }
};
const formatOptions = [
	{
		id: "hex",
		name: "Hex"
	},
	{
		id: "rgb",
		name: "RGB"
	},
	{
		id: "hsb",
		name: "HSB"
	},
	{
		id: "hsl",
		name: "HSL"
	}
];
/**
* ColorPicker provides an overlay to allow the user to pick a color via a color area, slider, and input fields.
* Alternatively, it can use a ColorSwatchPicker to allow the user to select a color from a list of swatches.
* It supports RGB, HSL, and HSB color spaces, as well as hex format.
*
* [Figma](https://www.figma.com/design/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?node-id=46449-66767&m=dev)
*/
function ColorPicker$1({ label, customTrigger, children, className, onChange, ...props }) {
	const [format, setFormat] = useState("hex");
	const [value, setValue] = useState(parseColor("#000000"));
	const formatVal = formatOptions.find((fmt) => format === fmt.id)?.id;
	const handleValueChange = (val) => {
		setValue(val);
		onChange?.(val.toString(formatVal), val);
	};
	const handleFormatChange = (newFormat) => {
		setFormat(newFormat);
		setValue((prevValue) => {
			const newValue = parseColor(prevValue.toString(newFormat));
			onChange?.(newValue.toString(newFormat), newValue);
			return newValue;
		});
	};
	return /* @__PURE__ */ jsx(ColorPicker, {
		...props,
		value,
		onChange: handleValueChange,
		children: /* @__PURE__ */ jsxs(DialogTrigger, { children: [customTrigger || /* @__PURE__ */ jsxs(Button, {
			"aria-label": !label ? "Color Picker" : void 0,
			className: "flex items-center justify-center gap-2 p-2 outline-none data-[focus-visible]:rounded-lg data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf",
			children: [/* @__PURE__ */ jsx(ColorSwatch$1, {}), label && /* @__PURE__ */ jsx("span", { children: label })]
		}), /* @__PURE__ */ jsx(Popover, {
			placement: "bottom start",
			className: "rounded-lg border",
			children: /* @__PURE__ */ jsx(Dialog, {
				className: cx("w-72 rounded-lg bg-surface-1 p-4 outline-none", className),
				children: children || /* @__PURE__ */ jsxs("div", {
					className: "flex flex-col gap-6",
					children: [
						/* @__PURE__ */ jsx(ColorArea$1, {
							colorSpace: format === "hsl" ? "hsl" : "hsb",
							xChannel: "saturation",
							yChannel: format === "hsl" ? "lightness" : "brightness"
						}),
						/* @__PURE__ */ jsx(ColorSlider$1, { variant: "hue" }),
						/* @__PURE__ */ jsx(Select$1, {
							label: "Format",
							selectedKey: format,
							onSelectionChange: (key) => handleFormatChange(key),
							options: formatOptions
						}),
						format === "hex" ? /* @__PURE__ */ jsx(ColorField$1, { label: "Hex" }) : /* @__PURE__ */ jsx("div", {
							className: "flex gap-1",
							children: colorchannels[format].channels.map((channel) => /* @__PURE__ */ jsx(ColorField$1, {
								label: channel.charAt(0).toUpperCase(),
								channel,
								colorSpace: formatOptions.find((fmt) => format === fmt.id)?.id,
								className: "w-1/3"
							}, channel))
						})
					]
				})
			})
		})] })
	});
}
//#endregion
//#region src/negroni/Color/ColorSwatchPicker/ColorSwatchPicker.tsx
const SizeContext = createContext(void 0);
/**
* A ColorSwatchPicker provides a list of color swatches that the user can select from.
*/
const ColorSwatchPicker$1 = ({ size, children, ...restProps }) => /* @__PURE__ */ jsx(SizeContext.Provider, {
	value: size,
	children: /* @__PURE__ */ jsx(ColorSwatchPicker, {
		className: "flex gap-2",
		...restProps,
		children
	})
});
/**
* A ColorSwatchPickerItem is a preview of a color swatch that the user can select from.
*/
const ColorSwatchPickerItem$1 = ({ color, className, ...restProps }) => {
	const size = useContext(SizeContext);
	return /* @__PURE__ */ jsx(ColorSwatchPickerItem, {
		...restProps,
		color,
		className: "group rounded-lg outline-none",
		children: /* @__PURE__ */ jsx(ColorSwatch$1, {
			size,
			className: cx("inset-0 border-2 border-transparent outline-2 ring-2 ring-transparent group-data-[selected]:border-white group-data-[focus-visible]:ring-4 group-data-[focus-visible]:ring-kbf group-data-[selected]:ring-black group-data-[focus-visible]:ring-offset-2", className)
		})
	});
};
//#endregion
//#region src/negroni/Combobox/Combobox.tsx
const comboboxStyles = tv({
	slots: {
		input: "w-full text-ellipsis rounded-lg border-neutral-100 px-3 py-1 pr-10 text-16 text-body-1 text-neutral-800 outline-none transition-[border-color] group-focus-within:border-solid group-focus-within:border-neutral-800 data-[disabled]:border-neutral-300 data-[invalid]:border-error-500 data-[disabled]:bg-neutral-50",
		icon: "absolute inset-y-0 right-0 hidden items-center pr-4 text-neutral-300 outline-none data-[focus-visible]:ring data-[focus-visible]:ring-kbf data-[focus-visible]:ring-offset-2 group-data-[focused]:text-neutral-800",
		label: "footnote text-xs tracking-neg-0point2",
		loaderSpinner: "absolute"
	},
	variants: {
		variant: {
			default: {
				input: "h-12 border",
				loaderSpinner: "right-3 top-2"
			},
			table: {
				input: "h-8 border border-transparent group-hover:bg-neutral-50",
				loaderSpinner: "right-1 top-2.5 h-3 w-3"
			}
		},
		showHelperIcon: {
			true: {},
			false: {}
		},
		error: { true: {
			input: "border-error-500",
			label: "text-error-500"
		} }
	},
	compoundVariants: [{
		variant: "default",
		showHelperIcon: true,
		class: { icon: "flex" }
	}, {
		variant: "table",
		showHelperIcon: true,
		class: { icon: "group-hover:flex group-hover:text-neutral-800 group-data-[focused]:flex" }
	}],
	defaultVariants: { showHelperIcon: true }
});
function HelperIcons({ isLoading, helperIcon, variant, onClear }) {
	const state = useContext(ComboBoxStateContext);
	const { icon, loaderSpinner } = comboboxStyles();
	const iconSize = variant === "default" ? "sm" : "xs";
	if (isLoading) return /* @__PURE__ */ jsx(Button, {
		slot: null,
		children: /* @__PURE__ */ jsx(Spinner, {
			size: "md",
			className: loaderSpinner({ variant })
		})
	});
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [state?.inputValue !== "" && /* @__PURE__ */ jsx(Button, {
		slot: null,
		className: icon({ variant }),
		"aria-label": "Clear",
		onPress: () => {
			state?.setInputValue("");
			onClear?.();
		},
		children: /* @__PURE__ */ jsx(XIcon, { size: iconSize })
	}), helperIcon !== "none" && /* @__PURE__ */ jsx(Button, {
		className: icon({
			showHelperIcon: state?.inputValue === "",
			variant
		}),
		children: helperIcon === "chevron" ? /* @__PURE__ */ jsx(ChevronDownIcon, {
			size: iconSize,
			className: "transition-transform group-data-[open]:rotate-180"
		}) : /* @__PURE__ */ jsx(SearchIcon, { size: iconSize })
	})] });
}
function HighlightText({ text }) {
	const highlight = useContext(ComboBoxStateContext)?.inputValue || "";
	let parts;
	try {
		parts = text.split(new RegExp(`(${highlight})`, "gi"));
	} catch (err) {
		parts = text.split("");
	}
	return /* @__PURE__ */ jsx("span", { children: parts.map((part, i) => /* @__PURE__ */ jsx("span", {
		className: part.toLowerCase() === highlight.toLowerCase() ? "font-bold" : void 0,
		children: part
	}, i)) });
}
/**
* A Combobox combines a text input with a list of options to select from. It is also sometimes called a "typeahead" or
* "autocomplete" (not to be confused with RAC's Autocomplete).
*/
function Combobox({ isLoading = false, placeholder = "Search", label, description, errorMessage, helperIcon = "search", emptyStateText = isLoading ? "Loading Results..." : "No Results Found.", secondaryLabel, secondaryClassName, secondaryHref, onSecondaryClick, isInvalid, variant = "default", className, onSelectionChange, listBoxClassName, onClear, ...props }) {
	const { input, label: labelStyles } = comboboxStyles();
	const sizeRef = useRef(null);
	const { width = 0 } = useResizeObserver({
		ref: sizeRef,
		box: "border-box"
	});
	const typeaheadRef = useRef(null);
	const handleSelectionChange = (k) => {
		const items = props.items ?? props.defaultItems;
		const payload = Array.from(items || []).find((item) => item.id === k);
		emitPickerEvent(typeaheadRef, payload ? [payload] : void 0, label, "typeahead");
		onSelectionChange?.(k);
	};
	return /* @__PURE__ */ jsxs(ComboBox, {
		allowsEmptyCollection: true,
		className: cx("group flex w-full flex-col gap-1", className),
		"aria-label": !label ? "Search" : void 0,
		ref: typeaheadRef,
		onSelectionChange: handleSelectionChange,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		...props,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "relative flex items-center",
				children: [/* @__PURE__ */ jsx(Input, {
					autoComplete: "off",
					className: input({
						error: !!errorMessage || isInvalid,
						variant
					}),
					placeholder,
					type: "text",
					ref: sizeRef
				}), /* @__PURE__ */ jsx(HelperIcons, {
					isLoading,
					helperIcon,
					variant,
					onClear
				})]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: labelStyles({ className: "mt-1" }),
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: "text-footnote text-error",
				children: errorMessage
			}),
			/* @__PURE__ */ jsx(PopoverWrapper, {
				style: { width },
				className: cn(popoverAnimationClasses, "min-w-56"),
				children: /* @__PURE__ */ jsx(ListBox$1, {
					renderEmptyState: () => /* @__PURE__ */ jsx("p", {
						className: "p-2 text-body-1",
						children: emptyStateText
					}),
					className: listBoxClassName,
					children: (item) => /* @__PURE__ */ jsx(SelectOption, {
						...item,
						name: /* @__PURE__ */ jsx(HighlightText, { text: item.name }),
						textValue: item.name
					})
				})
			})
		]
	});
}
//#endregion
//#region src/negroni/constants.ts
const BreakpointWidths = {
	MIN_TABLET: 768,
	MIN_DESKTOP: 1024
};
const COLORS = [
	"neutral",
	"info",
	"success",
	"warning",
	"error"
];
const SIZES = [
	"xs",
	"sm",
	"md",
	"lg",
	"xl",
	"xxl"
];
//#endregion
//#region src/negroni/DatePicker/DatePicker.tsx
/**
* A date picker combines a DateField and a Calendar popover to allow users to enter or select a date and time value.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/branch/VuqsUupcTrsSu5vfTNiCIP/Negroni-Library?type=design&node-id=20133-231854&mode=design&t=wa7mVOvUnUPttNED-0)
*
* [RAC DatePicker](https://react-spectrum.adobe.com/react-aria/DatePicker.html)
*
* See [Storybook](https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/experimental-datepicker--docs) for more detailed usage and examples.
*
*/
function DatePicker$1({ description, errorMessage, className, isInvalid, label, secondaryLabel, secondaryClassName, secondaryHref, onSecondaryClick, placement, offset, crossOffset, showPickers = false, ...props }) {
	return /* @__PURE__ */ jsxs(DatePicker, {
		className: cx("flex flex-col gap-1", className),
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		...props,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs(Group, {
				className: "relative flex h-12 w-full items-center rounded-md border border-neutral-100 bg-white pl-3 text-body-1 text-neutral-600 focus-within:border-black focus-within:text-black data-[disabled]:border-neutral-300 data-[invalid]:border-error data-[disabled]:bg-neutral-100 data-[invalid]:bg-error-25 data-[disabled]:text-neutral-300",
				children: [
					/* @__PURE__ */ jsx(DateInput, {
						className: "flex flex-1 py-2",
						children: (segment) => /* @__PURE__ */ jsx(DateSegment, {
							className: "rounded-md p-1 text-end outline-none data-[focused]:bg-accent1-200",
							segment
						})
					}),
					" ",
					/* @__PURE__ */ jsx(Button, {
						className: "absolute right-2 flex items-center justify-center rounded-md p-2 outline-none ring-offset-2 ring-offset-white data-[hovered]:bg-neutral-100 data-[pressed]:bg-neutral-100 data-[disabled]:text-neutral-300 data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf",
						children: /* @__PURE__ */ jsx(CalendarIcon, { size: "sm" })
					})
				]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: "text-footnote",
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: "text-footnote text-error",
				children: errorMessage
			}),
			/* @__PURE__ */ jsx(PopoverWrapper, {
				placement,
				offset,
				crossOffset,
				className: popoverAnimationClasses,
				children: /* @__PURE__ */ jsx(Dialog, { children: /* @__PURE__ */ jsx(Calendar$1, { showPickers }) })
			})
		]
	});
}
//#endregion
//#region src/negroni/RangeCalendar/RangeCalendar.tsx
const calendarStyles = tv({
	slots: {
		wrapper: "absolute flex items-center justify-end",
		content: "top-full items-center justify-center rounded-md border-2 border-neutral-100 bg-white p-2 shadow-lg",
		headerWrapper: "flex items-center justify-between pt-1",
		headerButton: "outline-none data-[disabled]:text-neutral-300 data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf",
		calendarHeaderCell: "pt-4 text-body-2 font-normal text-gray-700",
		monthHeader: "text-body-2 font-semibold",
		calendarCell: "relative flex size-10 items-center justify-center text-body-2 outline-none aria-[disabled]:pointer-events-none aria-[disabled]:text-gray-500 data-[outside-month]:hidden data-[hovered]:rounded-lg data-[selected]:data-[hovered]:rounded-none data-[selection-end]:data-[hovered]:rounded-r-lg data-[selection-end]:rounded-r-lg data-[selection-start]:data-[hovered]:rounded-l-lg data-[selection-start]:rounded-l-lg data-[hovered]:bg-accent2-50 data-[selected]:bg-accent2-100 data-[selection-end]:bg-accent2-300 data-[selection-start]:bg-accent2-300 data-[outside-month]:text-gray-500 data-[selected]:text-white data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf aria-[disabled]:data-[hovered]:bg-inherit"
	},
	variants: { isTodaysDate: { true: { calendarCell: "rounded-lg border border-neutral-400 font-semibold data-[selected]:rounded-none data-[hovered]:border-none data-[selected]:border-none" } } }
});
/**
* A RangeCalendar allows the user to select a range of dates from one or more date grids (months).
*/
function RangeCalendar$1({ errorMessage, numOfMonths = 2, ...props }) {
	const { wrapper, content, headerWrapper, headerButton, calendarHeaderCell, monthHeader, calendarCell } = calendarStyles();
	return /* @__PURE__ */ jsx(RangeCalendar, {
		...props,
		visibleDuration: { months: numOfMonths },
		pageBehavior: "single",
		children: /* @__PURE__ */ jsx("div", {
			className: wrapper(),
			children: /* @__PURE__ */ jsxs("div", {
				className: content(),
				children: [
					/* @__PURE__ */ jsxs("header", {
						className: headerWrapper(),
						children: [
							/* @__PURE__ */ jsx(Button, {
								className: headerButton(),
								slot: "previous",
								children: /* @__PURE__ */ jsx(ChevronLeftIcon, {})
							}),
							/* @__PURE__ */ jsx(Heading, { className: monthHeader() }),
							/* @__PURE__ */ jsx(Button, {
								className: headerButton(),
								slot: "next",
								children: /* @__PURE__ */ jsx(ChevronRightIcon, {})
							})
						]
					}),
					/* @__PURE__ */ jsxs("div", {
						className: "mt-4 flex justify-center gap-4",
						children: [/* @__PURE__ */ jsxs(CalendarGrid, {
							className: "[&_td]:px-0",
							weekdayStyle: "short",
							children: [/* @__PURE__ */ jsx(CalendarGridHeader, { children: (day) => /* @__PURE__ */ jsx(CalendarHeaderCell, {
								className: calendarHeaderCell(),
								children: day
							}) }), /* @__PURE__ */ jsx(CalendarGridBody, { children: (date) => {
								return /* @__PURE__ */ jsx(CalendarCell, {
									date,
									className: calendarCell({ isTodaysDate: isToday(date, getLocalTimeZone()) })
								});
							} })]
						}), numOfMonths === 2 && /* @__PURE__ */ jsxs(CalendarGrid, {
							className: "h-full [&_td]:px-0",
							weekdayStyle: "short",
							offset: { months: 1 },
							children: [/* @__PURE__ */ jsx(CalendarGridHeader, { children: (day) => /* @__PURE__ */ jsx(CalendarHeaderCell, {
								className: calendarHeaderCell(),
								children: day
							}) }), /* @__PURE__ */ jsx(CalendarGridBody, { children: (date) => {
								return /* @__PURE__ */ jsx(CalendarCell, {
									date,
									className: calendarCell()
								});
							} })]
						})]
					}),
					errorMessage && /* @__PURE__ */ jsx(Text, {
						slot: "errorMessage",
						className: "text-footnote text-error",
						children: errorMessage
					})
				]
			})
		})
	});
}
//#endregion
//#region src/negroni/DateRangePicker/DateRangePicker.tsx
const pickerStyles = tv({
	slots: {
		container: "flex h-full w-full flex-col gap-1",
		dateInput: "flex py-2",
		dateSegment: "rounded-md p-px text-end outline-none data-[focused]:bg-accent1-200",
		dateGroup: "relative flex h-12 w-80 items-center rounded-md border-2 border-neutral-100 bg-white pl-3 text-body-1 text-neutral-600 focus-within:border-black focus-within:text-black data-[disabled]:border-neutral-300 data-[invalid]:border-error data-[disabled]:bg-neutral-100 data-[invalid]:bg-error-25 data-[disabled]:text-neutral-300",
		button: "absolute right-2 flex items-center justify-center rounded-md p-2 outline-none ring-offset-2 ring-offset-white data-[hovered]:bg-neutral-100 data-[pressed]:bg-neutral-100 data-[disabled]:text-neutral-300 data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf"
	},
	variants: { variant: {
		filter: {
			dateGroup: "box-border h-8 border",
			dateInput: "py-0"
		},
		form: { dateGroup: "" }
	} }
});
/**
* A DateRangePicker combines two date inputs with RangeCalendar(s) to allow the user to select a range of dates.
*/
function DateRangePicker$1({ description, errorMessage, className, defaultValue, isInvalid, label, secondaryLabel, secondaryClassName, secondaryHref, onSecondaryClick, numOfMonths, variant = "form", ...props }) {
	const { container, dateInput, dateSegment, dateGroup, button } = pickerStyles({ variant });
	return /* @__PURE__ */ jsxs(DateRangePicker, {
		className: container({ className }),
		defaultValue,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		...props,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs(Group, {
				className: dateGroup(),
				children: [
					/* @__PURE__ */ jsx(DateInput, {
						slot: "start",
						className: dateInput(),
						children: (segment) => /* @__PURE__ */ jsx(DateSegment, {
							className: dateSegment(),
							segment
						})
					}),
					/* @__PURE__ */ jsx("span", {
						"aria-hidden": "true",
						className: "mx-2",
						children: /* @__PURE__ */ jsx(ArrowRightIcon, { size: "sm" })
					}),
					/* @__PURE__ */ jsx(DateInput, {
						slot: "end",
						className: dateInput(),
						children: (segment) => /* @__PURE__ */ jsx(DateSegment, {
							className: dateSegment(),
							segment
						})
					}),
					/* @__PURE__ */ jsx(Button, {
						className: button(),
						children: /* @__PURE__ */ jsx(CalendarIcon, { size: variant === "form" ? "sm" : "xs" })
					})
				]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: "text-footnote",
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: "text-footnote text-error",
				children: errorMessage
			}),
			/* @__PURE__ */ jsx(Popover, {
				className: popoverAnimationClasses,
				children: /* @__PURE__ */ jsx(Dialog, { children: /* @__PURE__ */ jsxs(RangeCalendar$1, {
					numOfMonths,
					children: [/* @__PURE__ */ jsxs("header", { children: [
						/* @__PURE__ */ jsx(Button, {
							slot: "previous",
							children: "◀"
						}),
						/* @__PURE__ */ jsx(Heading, {}),
						/* @__PURE__ */ jsx(Button, {
							slot: "next",
							children: "▶"
						})
					] }), /* @__PURE__ */ jsx(CalendarGrid, { children: (date) => /* @__PURE__ */ jsx(CalendarCell, { date }) })]
				}) })
			})
		]
	});
}
//#endregion
//#region src/assets/images/documents.png
var documents_default = "data:image/png;base64,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";
//#endregion
//#region src/negroni/FileSelect/FileSelect.tsx
const FileSelect = forwardRef(({ onSelect, acceptedFileTypes, allowsMultiple, defaultCamera, "data-testid": dataTestId, inputPassThroughs, ...buttonProps }, ref) => {
	const buttonRef = useRef(null);
	useImperativeHandle(ref, () => ({ openFileSystem: () => {
		buttonRef.current?.click();
	} }));
	return /* @__PURE__ */ jsx(FileTrigger, {
		onSelect,
		acceptedFileTypes,
		allowsMultiple,
		defaultCamera,
		"data-testid": dataTestId,
		...inputPassThroughs,
		children: /* @__PURE__ */ jsx(Button$1, {
			...buttonProps,
			ref: buttonRef
		})
	});
});
//#endregion
//#region src/negroni/FileDropZone/FileDropZone.tsx
const fileDropZoneStyles = tv({
	slots: {
		root: "flex flex-col rounded-lg border-2 border-dashed border-neutral-200 data-[drop-target]:border-brand-500 data-[drop-target]:bg-accent1-100",
		label: "font-semibold",
		description: "text-neutral-700",
		textContainer: "",
		uploadButton: ""
	},
	variants: {
		isDisabled: { true: {
			root: "pointer-events-none bg-neutral-50",
			label: "text-neutral-600"
		} },
		isLoading: { true: {
			root: "pointer-events-none bg-neutral-50",
			label: "text-neutral-600"
		} },
		compact: {
			true: {
				root: "gap-3 p-6",
				label: "text-body-1",
				description: "text-body-2",
				uploadButton: "w-full md:w-fit"
			},
			false: {
				root: "w-full min-w-[270px] gap-6 bg-neutral-100 px-6 pb-6 pt-[120px]",
				textContainer: "max-w-[440px]",
				label: "text-body-1 md:text-title-2",
				description: "text-body-2 md:text-body-1",
				uploadButton: "w-full md:w-fit"
			}
		}
	}
});
const dropItemIsFile = (f) => f.kind === "file";
function FileDropZone({ className, "data-testid": dataTestId, label, description, isDisabled, hideUploadButton = false, compact = false, isLoading, acceptedFileTypes, allowsMultiple, existingFileButtonText, onExistingFileButtonPress, onSelect, ...props }) {
	const { width: windowWidth } = useWindowSize();
	const isMobile = windowWidth > 0 && windowWidth <= BreakpointWidths.MIN_TABLET;
	const { root, textContainer, label: labelStyle, description: descriptionStyle, uploadButton } = fileDropZoneStyles({
		isLoading,
		isDisabled,
		compact
	});
	const buttonText = compact ? "Upload" : `Upload document${allowsMultiple ? "s" : ""}`;
	const labelText = label || hideUploadButton && "Drop files here";
	const onFileDrop = async (e) => {
		const files = await Promise.all(e.items.filter(dropItemIsFile).map((file) => file.getFile()));
		const filteredFiles = acceptedFileTypes ? files.filter((file) => acceptedFileTypes.includes(file.type)) : files;
		onSelect?.(filteredFiles);
	};
	const onFileSelect = (e) => {
		const files = e !== null ? Array.from(e) : [];
		onSelect?.(files);
	};
	const getDropOperation = (types) => {
		return (!acceptedFileTypes || acceptedFileTypes.some((type) => types.has(type))) && !isDisabled && !isLoading ? "copy" : "cancel";
	};
	const buttonProps = compact ? {
		color: "neutral",
		variant: "outline",
		size: "sm"
	} : { size: isMobile ? "md" : "lg" };
	return /* @__PURE__ */ jsxs(DropZone, {
		...props,
		"data-testid": dataTestId,
		className: root({ className }),
		getDropOperation,
		style: compact ? {} : {
			backgroundImage: `url(${documents_default})`,
			backgroundRepeat: "no-repeat",
			backgroundPosition: "top right",
			backgroundSize: isMobile ? "240px" : "auto"
		},
		onDrop: onFileDrop,
		children: [/* @__PURE__ */ jsxs("div", {
			className: textContainer(),
			children: [!!labelText && /* @__PURE__ */ jsx(Text, {
				slot: "label",
				className: labelStyle(),
				children: labelText
			}), !!description && /* @__PURE__ */ jsx("p", {
				className: descriptionStyle(),
				children: description
			})]
		}), !hideUploadButton && /* @__PURE__ */ jsxs("div", {
			className: "flex flex-col gap-2 md:flex-row",
			children: [/* @__PURE__ */ jsx(FileSelect, {
				acceptedFileTypes,
				allowsMultiple,
				icon: DocumentsIcon,
				className: uploadButton(),
				isLoading,
				onSelect: onFileSelect,
				isDisabled,
				"data-testid": `${dataTestId}-file-input`,
				...buttonProps,
				children: buttonText
			}), Boolean(existingFileButtonText) && onExistingFileButtonPress && /* @__PURE__ */ jsx(Button$1, {
				icon: isMobile ? void 0 : FolderIcon,
				...buttonProps,
				color: "neutral",
				variant: "outline",
				onPress: onExistingFileButtonPress,
				children: existingFileButtonText
			})]
		})]
	});
}
//#endregion
//#region src/negroni/GridList/GridList.tsx
const gridListStyles = tv({ slots: {
	gridList: "flex max-h-[inherit] w-full flex-col gap-1 overflow-auto rounded-lg border bg-neutral-0 fill-neutral-0 stroke-neutral-100 p-2 shadow-level-3 outline-none data-[focus-visible]:outline-kbf",
	item: "flex min-h-[44px] w-full cursor-pointer items-center gap-2 rounded-lg p-2 outline-none data-[focus-visible]:bg-accent1-100 data-[hovered]:bg-accent1-100 [&>div]:flex"
} });
const { gridList, item: itemStyles$1 } = gridListStyles();
const GridList$1 = ({ children, className, ...props }) => {
	return /* @__PURE__ */ jsx(GridList, {
		className: gridList({ className }),
		selectionMode: "multiple",
		...props,
		children
	});
};
const GridListItem$1 = ({ children, className, ...props }) => {
	const textValue = typeof children === "string" ? children : void 0;
	return /* @__PURE__ */ jsxs(GridListItem, {
		className: itemStyles$1({ className }),
		textValue,
		...props,
		children: [/* @__PURE__ */ jsx(Checkbox$1, { slot: "selection" }), /* @__PURE__ */ jsx("div", {
			className: "flex flex-col",
			children
		})]
	});
};
//#endregion
//#region src/negroni/Input/MaskedInput.tsx
function MaskedInputContent(props, ref) {
	return /* @__PURE__ */ jsx(InputMask, {
		inputRef: ref,
		autoComplete: "one-time-code",
		...props
	});
}
var MaskedInput_default = forwardRef(MaskedInputContent);
//#endregion
//#region src/negroni/Input/Input.tsx
const inputStyles = tv({
	slots: {
		container: "flex flex-col gap-1",
		inputContainer: "group/container relative",
		input: "h-12 w-full rounded-lg border border-solid border-neutral-100 bg-neutral-0 px-3 py-4 text-16 text-body-1 text-neutral-800 transition-[filter,border-color,box-shadow] duration-200 ease-in-out placeholder:text-neutral-300 data-[invalid]:border-error data-[invalid]:bg-error-25",
		iconContainer: "neutral-300 absolute right-3.5 top-1/2 -translate-y-1/2 transform",
		icon: "text-neutral-300 group-focus-within/container:text-neutral-800 data-[hovered]:bg-transparent data-[pressed]:bg-transparent data-[hovered]:text-neutral-800 data-[hovered]:shadow-none",
		description: "text-footnote text-neutral-800",
		errorMessage: "flex items-center gap-1 text-footnote text-error-500"
	},
	variants: {
		masked: {
			true: { input: "focus:outline-none focus:drop-shadow-none disabled:border-neutral-300 disabled:bg-neutral-50 group-focus-within/container:border-neutral-800 data-[invalid]:border-error data-[invalid]:bg-error-25" },
			false: { input: "group-focus-within/container:border-neutral-800 data-[disabled]:border-neutral-300 data-[disabled]:bg-neutral-50 data-[focused]:outline-none data-[focused]:drop-shadow-none" }
		},
		block: {
			true: {
				input: "w-full",
				container: "w-full"
			},
			false: {
				input: "",
				container: ""
			}
		},
		variant: {
			filter: {
				input: "box-border h-8 py-0",
				icon: "h-7 -outline-offset-2"
			},
			form: { input: "" }
		},
		hasError: {
			true: { input: "" },
			false: { input: "" }
		}
	},
	compoundVariants: [{
		masked: true,
		hasError: true,
		class: { input: "border-error bg-error-25" }
	}]
});
function Errors({ errorIcon: ErrorIcon, errorMessage }) {
	return useContext(FieldErrorContext)?.isInvalid && /* @__PURE__ */ jsxs("div", {
		className: "flex items-center gap-1",
		children: [ErrorIcon && /* @__PURE__ */ jsx(ErrorIcon, {
			size: "xs",
			className: "text-error"
		}), /* @__PURE__ */ jsx(FieldError, {
			className: "text-footnote text-error",
			children: errorMessage
		})]
	});
}
function InputWrapper({ label, secondaryLabel, secondaryHref, secondaryClassName, variant = "form", icon: Icon, errorIcon: ErrorIcon, errorMessage, iconAriaLabel, block, mask, className, inputClassName, "data-testid": dataTestId, type, name, value, id, isInvalid, description, onSecondaryClick, onIconClick, ...restProps }, ref) {
	const [hidePassword, setHidePassword] = useState(true);
	const inputRef = useRef(null);
	useImperativeHandle(ref, () => ({
		focus: (options) => inputRef.current?.focus(options),
		blur: () => inputRef.current?.blur(),
		offsetWidth: inputRef.current?.offsetWidth || 0,
		offsetHeight: inputRef.current?.offsetHeight || 0
	}));
	const isMasked = mask !== void 0 && mask.length > 0;
	const isPassword = type === "password";
	const { container, input, inputContainer, icon: iconStyles, iconContainer, description: descriptionStyles } = inputStyles({
		masked: isMasked,
		block,
		variant
	});
	const iconElement = useMemo(() => {
		if (isPassword || Icon && onIconClick) return /* @__PURE__ */ jsx("span", {
			className: iconContainer({ className: "cursor-pointer" }),
			children: /* @__PURE__ */ jsx(Button$1, {
				icon: isPassword ? hidePassword ? EyeIcon : EyeHiddenIcon : Icon,
				size: variant === "form" ? "md" : "sm",
				variant: "ghost",
				color: "neutral",
				"aria-label": iconAriaLabel,
				isDisabled: restProps.isDisabled,
				onPress: isPassword ? () => setHidePassword((prev) => !prev) : onIconClick,
				className: iconStyles()
			})
		});
		if (Icon) return /* @__PURE__ */ jsx("span", {
			className: iconContainer(),
			children: /* @__PURE__ */ jsx(Icon, {
				size: "sm",
				className: iconStyles()
			})
		});
		return null;
	}, [
		isPassword,
		Icon,
		onIconClick,
		iconContainer,
		hidePassword,
		variant,
		iconAriaLabel,
		restProps.isDisabled,
		iconStyles
	]);
	const filterMaskedInputProps = (props) => {
		const { slot: _slot, style: _style, children: _children, isDisabled: _isDisabled, validationBehavior: _validationBehavior, ...rest } = props;
		return rest;
	};
	return type === "hidden" ? /* @__PURE__ */ jsx("input", {
		id,
		type: "hidden",
		value,
		name
	}) : /* @__PURE__ */ jsxs(TextField, {
		...restProps,
		"data-testid": dataTestId,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		className: container({ className }),
		id,
		type: isPassword ? hidePassword ? "password" : "text" : type,
		name,
		value,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs("div", {
				className: inputContainer(),
				children: [isMasked ? /* @__PURE__ */ jsx(MaskedInput_default, {
					...filterMaskedInputProps(restProps),
					mask,
					className: input({
						className: inputClassName,
						hasError: isInvalid || Boolean(errorMessage)
					}),
					onChange: (e) => restProps.onChange?.(e.target.value),
					disabled: restProps.isDisabled,
					ref: inputRef,
					id,
					type,
					name,
					value
				}) : /* @__PURE__ */ jsx(Input, {
					className: input({ className: inputClassName }),
					ref: inputRef
				}), iconElement]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: descriptionStyles(),
				children: description
			}),
			/* @__PURE__ */ jsx(Errors, {
				errorIcon: ErrorIcon,
				errorMessage
			})
		]
	});
}
const Input$1 = forwardRef(InputWrapper);
//#endregion
//#region src/negroni/DynamicDate/DynamicDate.tsx
const formatDate = (date, outputFormat) => {
	return new DateFormatter("en-US", outputFormat).format(new Date(date));
};
function DynamicDate({ date, className, "data-testid": dataTestId, id }) {
	const fullDate = formatDate(date, {
		month: "long",
		day: "numeric",
		year: "numeric"
	});
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: cx("relative flex h-10 w-10 flex-col items-center justify-center rounded-lg", className),
		children: [
			/* @__PURE__ */ jsx("div", {
				className: "absolute pb-3 text-body-1 font-semibold",
				children: formatDate(date, { day: "numeric" })
			}),
			/* @__PURE__ */ jsx("div", {
				className: "pb-1 pt-5 text-footnote",
				children: formatDate(date, { month: "short" }).toUpperCase()
			}),
			/* @__PURE__ */ jsx("span", {
				className: "sr-only",
				children: fullDate
			})
		]
	});
}
//#endregion
//#region src/negroni/ListCell/ListCell.tsx
/**
* List Cell component
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=4611-48478&t=1JEf3wVT76PDPcKo-0)
*/
function ListCell({ title, label, date, description, buttonLabel, className = "", onButtonClick, buttonProps, icon: Icon, iconProps = {}, id, "data-testid": dataTestId }) {
	const hasIcon = !!Icon;
	const { className: iconPropsClassName, ...otherIconProps } = iconProps;
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className,
		children: [label && /* @__PURE__ */ jsx("div", {
			className: "inline-block text-label uppercase",
			children: label
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex grow gap-1 rounded-lg bg-neutral-0 px-4 py-3 md:h-20 md:items-center",
			children: [date || hasIcon ? /* @__PURE__ */ jsx("div", {
				className: "flex h-10 w-10 flex-col justify-center rounded-lg bg-neutral-50 text-neutral-800",
				children: date ? /* @__PURE__ */ jsx(DynamicDate, { date }) : hasIcon && /* @__PURE__ */ jsx(Icon, {
					...otherIconProps,
					className: cx("self-center", iconPropsClassName)
				})
			}) : null, /* @__PURE__ */ jsxs("div", {
				className: "flex w-full flex-col justify-between md:flex-row md:items-center",
				children: [/* @__PURE__ */ jsx("div", {
					className: "flex-grow pl-3",
					children: /* @__PURE__ */ jsxs("div", {
						className: "flex flex-col",
						children: [/* @__PURE__ */ jsx("div", {
							className: "text-body-1 font-semibold",
							children: title
						}), description && /* @__PURE__ */ jsx("div", {
							className: "text-body-2 text-neutral-600",
							children: description
						})]
					})
				}), buttonLabel && /* @__PURE__ */ jsx("div", {
					className: "mr-9",
					children: /* @__PURE__ */ jsx(Button$1, {
						...buttonProps,
						size: "sm",
						onPress: onButtonClick,
						variant: "ghost",
						children: buttonLabel
					})
				})]
			})]
		})]
	});
}
//#endregion
//#region src/negroni/LoadingAnimations/Growth/growth-lottie.json
var growth_lottie_default = {
	v: "4.8.0",
	meta: {
		"g": "LottieFiles AE 3.4.5",
		"a": "",
		"k": "",
		"d": "",
		"tc": ""
	},
	fr: 30,
	ip: 0,
	op: 78,
	w: 600,
	h: 636,
	nm: "LegalZoom_Loader_Full",
	ddd: 0,
	assets: [],
	layers: [
		{
			"ddd": 0,
			"ind": 1,
			"ty": 4,
			"nm": "Ground accent 03",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						487.241,
						626.761,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						6.453,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						400,
						400,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [0, 0]],
								"o": [[0, 0], [0, 0]],
								"v": [[0, 0], [12.906, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 13",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 0,
			"op": 78,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 2,
			"ty": 4,
			"nm": "Ground accent 02",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						401.745,
						626.761,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						2.823,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						400,
						400,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [0, 0]],
								"o": [[0, 0], [0, 0]],
								"v": [[0, 0], [5.646, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 14",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 0,
			"op": 78,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 3,
			"ty": 4,
			"nm": "Ground accent 01",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						148.453,
						626.393,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						11.5,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						400,
						400,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [0, 0]],
								"o": [[0, 0], [0, 0]],
								"v": [[0, 0], [23, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 12",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 0,
			"op": 78,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 4,
			"ty": 4,
			"nm": "Main ground",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						298.439,
						600.949,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						72.996,
						0,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 0,
					"k": [
						400,
						400,
						100
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [0, 0]],
								"o": [[0, 0], [0, 0]],
								"v": [[0, 0], [145.993, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 11",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 0,
			"op": 78,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 5,
			"ty": 4,
			"nm": "Path 23",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						282.816,
						17.469,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						4.367,
						4.367,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 24.896,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 34.896,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 44.896,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 54.896,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 64.8955078125,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-.418, -1.129],
									[0, 0],
									[-.354, -.131],
									[0, 0],
									[1.128, -.418],
									[0, 0],
									[.13, -.355],
									[0, 0],
									[.417, 1.129],
									[0, 0],
									[.356, .131],
									[0, 0],
									[-1.129, .418],
									[0, 0],
									[-.131, .355]
								],
								"o": [
									[.417, -1.129],
									[0, 0],
									[.13, .355],
									[0, 0],
									[1.128, .418],
									[0, 0],
									[-.354, .131],
									[0, 0],
									[-.418, 1.129],
									[0, 0],
									[-.131, -.355],
									[0, 0],
									[-1.129, -.418],
									[0, 0],
									[.356, -.131],
									[0, 0]
								],
								"v": [
									[3.152, .847],
									[5.584, .847],
									[5.999, 1.97],
									[6.765, 2.736],
									[7.889, 3.151],
									[7.889, 5.583],
									[6.765, 5.999],
									[5.999, 6.765],
									[5.584, 7.888],
									[3.152, 7.888],
									[2.736, 6.765],
									[1.969, 5.999],
									[.847, 5.583],
									[.847, 3.151],
									[1.969, 2.736],
									[2.736, 1.97]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.98431372549,
								.772549019608,
								.701960784314,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 23",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 19,
			"op": 78,
			"st": 19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 6,
			"ty": 4,
			"nm": "Path 22",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 57,
						"s": [100]
					}, {
						"t": 62,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						442.816,
						420.448,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						3.623,
						3.623,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 22.343,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 32.343,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 42.343,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 52.343,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 62,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-.347, -.936],
									[0, 0],
									[-.294, -.109],
									[0, 0],
									[.936, -.347],
									[0, 0],
									[.108, -.294],
									[0, 0],
									[.346, .936],
									[0, 0],
									[.295, .109],
									[0, 0],
									[-.937, .347],
									[0, 0],
									[-.109, .294]
								],
								"o": [
									[.346, -.936],
									[0, 0],
									[.108, .294],
									[0, 0],
									[.936, .347],
									[0, 0],
									[-.294, .109],
									[0, 0],
									[-.347, .936],
									[0, 0],
									[-.109, -.294],
									[0, 0],
									[-.937, -.347],
									[0, 0],
									[.295, -.109],
									[0, 0]
								],
								"v": [
									[2.614, .702],
									[4.631, .702],
									[4.976, 1.634],
									[5.611, 2.269],
									[6.543, 2.614],
									[6.543, 4.631],
									[5.611, 4.976],
									[4.976, 5.611],
									[4.631, 6.543],
									[2.614, 6.543],
									[2.269, 5.611],
									[1.633, 4.976],
									[.702, 4.631],
									[.702, 2.614],
									[1.633, 2.269],
									[2.269, 1.634]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 22",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 19,
			"op": 78,
			"st": 19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 7,
			"ty": 4,
			"nm": "Path 21",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 64,
						"s": [100]
					}, {
						"t": 69,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						50.815,
						335.841,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						3.623,
						3.623,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 30.481,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 40.481,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 50.481,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 60,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 69,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-.346, -.936],
									[0, 0],
									[-.294, -.109],
									[0, 0],
									[.936, -.346],
									[0, 0],
									[.109, -.294],
									[0, 0],
									[.346, .936],
									[0, 0],
									[.294, .109],
									[0, 0],
									[-.936, .346],
									[0, 0],
									[-.109, .294]
								],
								"o": [
									[.346, -.936],
									[0, 0],
									[.109, .294],
									[0, 0],
									[.936, .346],
									[0, 0],
									[-.294, .109],
									[0, 0],
									[-.346, .936],
									[0, 0],
									[-.109, -.294],
									[0, 0],
									[-.936, -.346],
									[0, 0],
									[.294, -.109],
									[0, 0]
								],
								"v": [
									[2.614, .702],
									[4.631, .702],
									[4.976, 1.634],
									[5.611, 2.269],
									[6.543, 2.614],
									[6.543, 4.631],
									[5.611, 4.976],
									[4.976, 5.611],
									[4.631, 6.543],
									[2.614, 6.543],
									[2.269, 5.611],
									[1.634, 4.976],
									[.702, 4.631],
									[.702, 2.614],
									[1.634, 2.269],
									[2.269, 1.634]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 21",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 25,
			"op": 78,
			"st": 25,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 8,
			"ty": 4,
			"nm": "Path 20",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 58,
						"s": [100]
					}, {
						"t": 63,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						475.895,
						267.284,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						3.164,
						3.164,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 23.419,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 33.419,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 43.419,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 53.419,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 63,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[.254, -.965],
									[0, 0],
									[-.178, -.258],
									[0, 0],
									[.965, .254],
									[0, 0],
									[.258, -.178],
									[0, 0],
									[-.255, .965],
									[0, 0],
									[.178, .258],
									[0, 0],
									[-.965, -.254],
									[0, 0],
									[-.259, .178]
								],
								"o": [
									[.822, -.567],
									[0, 0],
									[-.08, .304],
									[0, 0],
									[.567, .822],
									[0, 0],
									[-.303, -.08],
									[0, 0],
									[-.822, .567],
									[0, 0],
									[.08, -.303],
									[0, 0],
									[-.567, -.822],
									[0, 0],
									[.303, .08],
									[0, 0]
								],
								"v": [
									[4.016, .195],
									[5.667, 1.353],
									[5.414, 2.314],
									[5.569, 3.199],
									[6.134, 4.016],
									[4.975, 5.668],
									[4.014, 5.415],
									[3.129, 5.57],
									[2.312, 6.134],
									[.661, 4.975],
									[.914, 4.015],
									[.759, 3.13],
									[.194, 2.312],
									[1.353, .661],
									[2.314, .914],
									[3.199, .759]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 20",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 19,
			"op": 78,
			"st": 19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 9,
			"ty": 4,
			"nm": "Path 19",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 54,
						"s": [100]
					}, {
						"t": 59,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						140.351,
						493.13,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						3.164,
						3.164,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 18.955,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 28.955,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 38.955,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 48.955,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 59,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[.254, -.965],
									[0, 0],
									[-.178, -.258],
									[0, 0],
									[.965, .254],
									[0, 0],
									[.258, -.179],
									[0, 0],
									[-.254, .966],
									[0, 0],
									[.178, .258],
									[0, 0],
									[-.965, -.254],
									[0, 0],
									[-.258, .178]
								],
								"o": [
									[.822, -.567],
									[0, 0],
									[-.08, .303],
									[0, 0],
									[.567, .821],
									[0, 0],
									[-.304, -.08],
									[0, 0],
									[-.822, .568],
									[0, 0],
									[.08, -.304],
									[0, 0],
									[-.567, -.822],
									[0, 0],
									[.303, .08],
									[0, 0]
								],
								"v": [
									[4.017, .195],
									[5.668, 1.353],
									[5.415, 2.314],
									[5.57, 3.199],
									[6.134, 4.017],
									[4.975, 5.668],
									[4.015, 5.415],
									[3.13, 5.57],
									[2.312, 6.134],
									[.661, 4.975],
									[.914, 4.015],
									[.759, 3.13],
									[.195, 2.312],
									[1.353, .661],
									[2.314, .914],
									[3.199, .759]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 19",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 12,
			"op": 78,
			"st": 12,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 10,
			"ty": 4,
			"nm": "Path 18",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 63,
						"s": [100]
					}, {
						"t": 68,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						172.617,
						125.324,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						3.164,
						3.164,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 27.579,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 37.579,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 47.579,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 58,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 68,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[.254, -.965],
									[0, 0],
									[-.178, -.258],
									[0, 0],
									[.965, .254],
									[0, 0],
									[.258, -.178],
									[0, 0],
									[-.254, .965],
									[0, 0],
									[.178, .258],
									[0, 0],
									[-.965, -.254],
									[0, 0],
									[-.258, .178]
								],
								"o": [
									[.822, -.567],
									[0, 0],
									[-.08, .304],
									[0, 0],
									[.567, .821],
									[0, 0],
									[-.303, -.08],
									[0, 0],
									[-.822, .567],
									[0, 0],
									[.08, -.304],
									[0, 0],
									[-.567, -.821],
									[0, 0],
									[.303, .08],
									[0, 0]
								],
								"v": [
									[4.017, .195],
									[5.668, 1.353],
									[5.415, 2.314],
									[5.57, 3.199],
									[6.134, 4.017],
									[4.975, 5.668],
									[4.015, 5.415],
									[3.13, 5.57],
									[2.312, 6.134],
									[.661, 4.975],
									[.914, 4.015],
									[.759, 3.13],
									[.195, 2.312],
									[1.353, .661],
									[2.314, .914],
									[3.199, .759]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.862745098039,
								.854901960784,
								.839215686275,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 18",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 25,
			"op": 78,
			"st": 25,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 11,
			"ty": 4,
			"nm": "Path 17",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 58,
						"s": [100]
					}, {
						"t": 63,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						69.83,
						213.984,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						7.656,
						7.656,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 22.932,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 32.932,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 42.932,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 52.932,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 63,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-.346, -.936],
									[0, 0],
									[-.294, -.109],
									[0, 0],
									[.936, -.346],
									[0, 0],
									[.109, -.294],
									[0, 0],
									[.346, .936],
									[0, 0],
									[.294, .109],
									[0, 0],
									[-.936, .346],
									[0, 0],
									[-.109, .294]
								],
								"o": [
									[.346, -.936],
									[0, 0],
									[.109, .294],
									[0, 0],
									[.936, .346],
									[0, 0],
									[-.294, .109],
									[0, 0],
									[-.346, .936],
									[0, 0],
									[-.109, -.294],
									[0, 0],
									[-.936, -.346],
									[0, 0],
									[.294, -.109],
									[0, 0]
								],
								"v": [
									[6.647, .702],
									[8.664, .702],
									[10.098, 4.578],
									[10.734, 5.213],
									[14.609, 6.647],
									[14.609, 8.664],
									[10.734, 10.098],
									[10.098, 10.734],
									[8.664, 14.609],
									[6.647, 14.609],
									[5.213, 10.734],
									[4.578, 10.098],
									[.702, 8.664],
									[.702, 6.647],
									[4.578, 5.213],
									[5.213, 4.578]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.98431372549,
								.772549019608,
								.701960784314,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 17",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 19,
			"op": 78,
			"st": 19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 12,
			"ty": 4,
			"nm": "Path 16",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 61,
						"s": [100]
					}, {
						"t": 66,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						402.147,
						484.998,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						7.656,
						7.656,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 26.301,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 36.301,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 46.301,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 56.301,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 66,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-.346, -.936],
									[0, 0],
									[-.294, -.109],
									[0, 0],
									[.936, -.346],
									[0, 0],
									[.109, -.294],
									[0, 0],
									[.346, .936],
									[0, 0],
									[.294, .109],
									[0, 0],
									[-.936, .346],
									[0, 0],
									[-.109, .294]
								],
								"o": [
									[.346, -.936],
									[0, 0],
									[.109, .294],
									[0, 0],
									[.936, .346],
									[0, 0],
									[-.294, .109],
									[0, 0],
									[-.346, .936],
									[0, 0],
									[-.109, -.294],
									[0, 0],
									[-.936, -.346],
									[0, 0],
									[.294, -.109],
									[0, 0]
								],
								"v": [
									[6.647, .702],
									[8.664, .702],
									[10.098, 4.578],
									[10.734, 5.213],
									[14.609, 6.647],
									[14.609, 8.664],
									[10.734, 10.098],
									[10.098, 10.734],
									[8.664, 14.609],
									[6.647, 14.609],
									[5.213, 10.734],
									[4.578, 10.098],
									[.702, 8.664],
									[.702, 6.647],
									[4.578, 5.213],
									[5.213, 4.578]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.98431372549,
								.772549019608,
								.701960784314,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 16",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 19,
			"op": 78,
			"st": 19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 13,
			"ty": 4,
			"nm": "Path 15",
			"sr": 1,
			"ks": {
				"o": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.833],
							"y": [.833]
						},
						"o": {
							"x": [.167],
							"y": [.167]
						},
						"t": 63,
						"s": [100]
					}, {
						"t": 68,
						"s": [0]
					}],
					"ix": 11
				},
				"r": {
					"a": 0,
					"k": 0,
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						415.048,
						149.456,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						7.655,
						7.656,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 28.202,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 38.202,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 48.202,
							"s": [
								200,
								200,
								100
							]
						},
						{
							"i": {
								"x": [
									.667,
									.667,
									.667
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.333,
									.333,
									.333
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 58.202,
							"s": [
								400,
								400,
								100
							]
						},
						{
							"t": 68,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-.347, -.936],
									[0, 0],
									[-.294, -.109],
									[0, 0],
									[.936, -.346],
									[0, 0],
									[.109, -.294],
									[0, 0],
									[.346, .936],
									[0, 0],
									[.294, .109],
									[0, 0],
									[-.936, .346],
									[0, 0],
									[-.109, .294]
								],
								"o": [
									[.346, -.936],
									[0, 0],
									[.109, .294],
									[0, 0],
									[.936, .346],
									[0, 0],
									[-.294, .109],
									[0, 0],
									[-.347, .936],
									[0, 0],
									[-.109, -.294],
									[0, 0],
									[-.936, -.346],
									[0, 0],
									[.294, -.109],
									[0, 0]
								],
								"v": [
									[6.647, .702],
									[8.664, .702],
									[10.098, 4.578],
									[10.734, 5.213],
									[14.609, 6.647],
									[14.609, 8.664],
									[10.734, 10.098],
									[10.098, 10.734],
									[8.664, 14.609],
									[6.647, 14.609],
									[5.213, 10.734],
									[4.578, 10.098],
									[.702, 8.664],
									[.702, 6.647],
									[4.578, 5.213],
									[5.213, 4.578]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.98431372549,
								.772549019608,
								.701960784314,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 15",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 22,
			"op": 78,
			"st": 22,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 14,
			"ty": 4,
			"nm": "R small leaf stem",
			"parent": 22,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 25,
							"s": [-7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 38,
							"s": [4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 48,
							"s": [-1.5]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 55,
							"s": [0]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.167],
								"y": [0]
							},
							"t": 63,
							"s": [0]
						},
						{
							"t": 73,
							"s": [-10]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						3.854,
						36.083,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						0,
						10.394,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.999,
								.999,
								.999
							],
							"y": [
								.288,
								.288,
								1
							]
						},
						"o": {
							"x": [
								1,
								1,
								1
							],
							"y": [
								0,
								0,
								0
							]
						},
						"t": 61,
						"s": [
							100,
							100,
							100
						]
					}, {
						"t": 73,
						"s": [
							0,
							0,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [-10.02, -.051]],
								"o": [[.669, -2.466], [0, 0]],
								"v": [[0, 10.394], [16.55, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.43137254902,
								.427450980392,
								.419607843137,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 10",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "tm",
				"s": {
					"a": 0,
					"k": 0,
					"ix": 1
				},
				"e": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 25,
						"s": [0]
					}, {
						"t": 36.5,
						"s": [100]
					}],
					"ix": 2
				},
				"o": {
					"a": 0,
					"k": 0,
					"ix": 3
				},
				"m": 1,
				"ix": 2,
				"nm": "Trim Paths 1",
				"mn": "ADBE Vector Filter - Trim",
				"hd": false
			}],
			"ip": 25,
			"op": 78,
			"st": -25,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 15,
			"ty": 4,
			"nm": "R small leaf",
			"parent": 14,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 29,
							"s": [7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 42,
							"s": [-4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 52,
							"s": [1.5]
						},
						{
							"t": 59,
							"s": [0]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						8.966,
						1.624,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						.18,
						9.155,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.6,
								.6,
								.6
							],
							"y": [
								1,
								1,
								1
							]
						},
						"o": {
							"x": [
								.32,
								.32,
								.32
							],
							"y": [
								.94,
								.94,
								0
							]
						},
						"t": 31,
						"s": [
							0,
							0,
							100
						]
					}, {
						"t": 39,
						"s": [
							100,
							100,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[-2.067, .721],
									[-3.178, -2.952],
									[.625, -.957],
									[4.844, -1.318],
									[1.319, 2.585],
									[.011, .318]
								],
								"o": [
									[5.268, -2.496],
									[.838, .778],
									[-1.541, 2.359],
									[-5.79, 1.575],
									[-.145, -.283],
									[-.157, -4.635]
								],
								"v": [
									[5.873, .84],
									[20.1, 4.873],
									[20.511, 7.844],
									[11.013, 14.752],
									[.24, 9.682],
									[.005, 8.77]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.043137254902,
								.41568627451,
								.23137254902,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.76862745098,
								.976470588235,
								.874509803922,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 9",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 25,
			"op": 78,
			"st": -25,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 16,
			"ty": 4,
			"nm": "L small leaf stem",
			"parent": 22,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 21,
							"s": [7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 34,
							"s": [-4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 44,
							"s": [1.5]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 51,
							"s": [0]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.167],
								"y": [0]
							},
							"t": 63,
							"s": [0]
						},
						{
							"t": 73,
							"s": [10]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						4.275,
						33.668,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						15.32,
						12.133,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.999,
								.999,
								.999
							],
							"y": [
								.288,
								.288,
								1
							]
						},
						"o": {
							"x": [
								1,
								1,
								1
							],
							"y": [
								0,
								0,
								0
							]
						},
						"t": 61,
						"s": [
							100,
							100,
							100
						]
					}, {
						"t": 73,
						"s": [
							0,
							0,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [9.966, 1.04]],
								"o": [[-.396, -2.525], [0, 0]],
								"v": [[15.32, 12.133], [0, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.43137254902,
								.427450980392,
								.419607843137,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 8",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "tm",
				"s": {
					"a": 0,
					"k": 0,
					"ix": 1
				},
				"e": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 21,
						"s": [0]
					}, {
						"t": 32.5,
						"s": [100]
					}],
					"ix": 2
				},
				"o": {
					"a": 0,
					"k": 0,
					"ix": 3
				},
				"m": 1,
				"ix": 2,
				"nm": "Trim Paths 1",
				"mn": "ADBE Vector Filter - Trim",
				"hd": false
			}],
			"ip": 21,
			"op": 78,
			"st": -29,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 17,
			"ty": 4,
			"nm": "L small leaf",
			"parent": 16,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 25,
							"s": [7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 38,
							"s": [-4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 48,
							"s": [1.5]
						},
						{
							"t": 55,
							"s": [0]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						8.839,
						3.418,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						19.94,
						10.87,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.6,
								.6,
								.6
							],
							"y": [
								1,
								1,
								1
							]
						},
						"o": {
							"x": [
								.32,
								.32,
								.32
							],
							"y": [
								.94,
								.94,
								0
							]
						},
						"t": 27,
						"s": [
							0,
							0,
							100
						]
					}, {
						"t": 35,
						"s": [
							100,
							100,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[1.896, 1.094],
									[3.673, -2.308],
									[-.436, -1.057],
									[-4.514, -2.197],
									[-1.777, 2.294],
									[-.07, .31]
								],
								"o": [
									[-4.711, -3.434],
									[-.968, .608],
									[1.075, 2.605],
									[5.395, 2.626],
									[.195, -.251],
									[1.018, -4.524]
								],
								"v": [
									[15.857, 1.706],
									[1.128, 3.018],
									[.171, 5.86],
									[8.216, 14.416],
									[19.744, 11.442],
									[20.146, 10.589]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.043137254902,
								.41568627451,
								.23137254902,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.76862745098,
								.976470588235,
								.874509803922,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 7",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 21,
			"op": 78,
			"st": -29,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 18,
			"ty": 4,
			"nm": "R big leaf stem",
			"parent": 22,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 15,
							"s": [-7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 28,
							"s": [4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 38,
							"s": [-1.5]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 45,
							"s": [0]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.167],
								"y": [0]
							},
							"t": 63,
							"s": [0]
						},
						{
							"t": 73,
							"s": [-10]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						1.024,
						66.985,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						.17,
						14.936,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.999,
								.999,
								.999
							],
							"y": [
								.288,
								.288,
								1
							]
						},
						"o": {
							"x": [
								1,
								1,
								1
							],
							"y": [
								0,
								0,
								0
							]
						},
						"t": 61,
						"s": [
							100,
							100,
							100
						]
					}, {
						"t": 73,
						"s": [
							0,
							0,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [-12.381, 1.292]],
								"o": [[.492, -3.136], [0, 0]],
								"v": [[.168, 14.936], [19.032, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.43137254902,
								.427450980392,
								.419607843137,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 4",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "tm",
				"s": {
					"a": 0,
					"k": 0,
					"ix": 1
				},
				"e": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 15,
						"s": [0]
					}, {
						"t": 26.5,
						"s": [100]
					}],
					"ix": 2
				},
				"o": {
					"a": 0,
					"k": 0,
					"ix": 3
				},
				"m": 1,
				"ix": 2,
				"nm": "Trim Paths 1",
				"mn": "ADBE Vector Filter - Trim",
				"hd": false
			}],
			"ip": 13,
			"op": 78,
			"st": -17,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 19,
			"ty": 4,
			"nm": "R big leaf",
			"parent": 18,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 18,
							"s": [-7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 31,
							"s": [4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 41,
							"s": [-1.5]
						},
						{
							"t": 48,
							"s": [0]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						9.144,
						3.967,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						.46,
						13.932,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.6,
								.6,
								.6
							],
							"y": [
								1,
								1,
								1
							]
						},
						"o": {
							"x": [
								.32,
								.32,
								.32
							],
							"y": [
								.94,
								.94,
								0
							]
						},
						"t": 20,
						"s": [
							0,
							0,
							100
						]
					}, {
						"t": 28,
						"s": [
							100,
							100,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[-2.616, 1.247],
									[-4.472, -3.475],
									[.484, -1.036],
									[6.469, -2.544],
									[2.03, 3.183],
									[.05, .314]
								],
								"o": [
									[6.748, -4.151],
									[.903, .701],
									[-1.546, 3.312],
									[-7.43, 2.921],
									[-.171, -.268],
									[-.968, -6.11]
								],
								"v": [
									[6.63, 1.714],
									[26.242, 5.299],
									[26.993, 8.237],
									[15.327, 19.137],
									[.46, 13.932],
									[.126, 13.05]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.043137254902,
								.41568627451,
								.23137254902,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.76862745098,
								.976470588235,
								.874509803922,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 3",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 13,
			"op": 78,
			"st": -17,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 20,
			"ty": 4,
			"nm": "L big leaf stem",
			"parent": 22,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 11,
							"s": [7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 24,
							"s": [-4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 34,
							"s": [1.5]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 41,
							"s": [0]
						},
						{
							"i": {
								"x": [.833],
								"y": [1]
							},
							"o": {
								"x": [.167],
								"y": [0]
							},
							"t": 63,
							"s": [0]
						},
						{
							"t": 73,
							"s": [10]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						.578,
						63.094,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						19.032,
						15.073,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.999,
								.999,
								.999
							],
							"y": [
								.288,
								.288,
								1
							]
						},
						"o": {
							"x": [
								1,
								1,
								1
							],
							"y": [
								0,
								0,
								0
							]
						},
						"t": 61,
						"s": [
							100,
							100,
							100
						]
					}, {
						"t": 73,
						"s": [
							0,
							0,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [[0, 0], [12.381, 1.292]],
								"o": [[-.493, -3.136], [0, 0]],
								"v": [[19.032, 15.073], [0, 0]],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.43137254902,
								.427450980392,
								.419607843137,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 2",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "tm",
				"s": {
					"a": 0,
					"k": 0,
					"ix": 1
				},
				"e": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.667],
							"y": [1]
						},
						"o": {
							"x": [.333],
							"y": [0]
						},
						"t": 11,
						"s": [0]
					}, {
						"t": 22.5,
						"s": [100]
					}],
					"ix": 2
				},
				"o": {
					"a": 0,
					"k": 0,
					"ix": 3
				},
				"m": 1,
				"ix": 2,
				"nm": "Trim Paths 1",
				"mn": "ADBE Vector Filter - Trim",
				"hd": false
			}],
			"ip": 11,
			"op": 78,
			"st": -19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 21,
			"ty": 4,
			"nm": "L big leaf",
			"parent": 20,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 15,
							"s": [7]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 28,
							"s": [-4.5]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 38,
							"s": [1.5]
						},
						{
							"t": 45,
							"s": [0]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						10.392,
						3.829,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						26.084,
						14.768,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.6,
								.6,
								.6
							],
							"y": [
								1,
								1,
								1
							]
						},
						"o": {
							"x": [
								.32,
								.32,
								.32
							],
							"y": [
								.94,
								.94,
								0
							]
						},
						"t": 17,
						"s": [
							0,
							0,
							100
						]
					}, {
						"t": 25,
						"s": [
							100,
							100,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[2.478, 1.503],
									[4.798, -3.009],
									[-.377, -1.079],
									[-6.181, -3.179],
									[-2.339, 2.963],
									[-.081, .308]
								],
								"o": [
									[-6.298, -4.807],
									[-.968, .607],
									[1.206, 3.45],
									[7.1, 3.652],
									[.197, -.25],
									[1.576, -5.982]
								],
								"v": [
									[21.048, 2.402],
									[1.174, 4.003],
									[.133, 6.851],
									[10.647, 18.866],
									[25.961, 15.178],
									[26.382, 14.333]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.043137254902,
								.41568627451,
								.23137254902,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.76862745098,
								.976470588235,
								.874509803922,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 1",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 11,
			"op": 78,
			"st": -19,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 22,
			"ty": 4,
			"nm": "Main stem",
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 0,
							"s": [2]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 21,
							"s": [-2]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 41,
							"s": [1]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 52,
							"s": [-.3]
						},
						{
							"t": 60,
							"s": [0]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 0,
					"k": [
						309.652,
						597.227,
						0
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						11.657,
						108.083,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [{
						"i": {
							"x": [
								.999,
								.999,
								.999
							],
							"y": [
								.05,
								.05,
								1
							]
						},
						"o": {
							"x": [
								1,
								1,
								1
							],
							"y": [
								0,
								0,
								0
							]
						},
						"t": 56,
						"s": [
							400,
							400,
							100
						]
					}, {
						"t": 74,
						"s": [
							0,
							0,
							100
						]
					}],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[0, 0],
									[-7.731, 14.591],
									[2.906, 6.888]
								],
								"o": [
									[-4.091, -5.495],
									[7.731, -14.591],
									[0, 0]
								],
								"v": [
									[11.657, 108.083],
									[2.424, 38.904],
									[3.371, 0]
								],
								"c": false
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.43137254902,
								.427450980392,
								.419607843137,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 6",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}, {
				"ty": "tm",
				"s": {
					"a": 0,
					"k": 0,
					"ix": 1
				},
				"e": {
					"a": 1,
					"k": [{
						"i": {
							"x": [.31],
							"y": [.944]
						},
						"o": {
							"x": [.21],
							"y": [.365]
						},
						"t": 0,
						"s": [0]
					}, {
						"t": 40.51953125,
						"s": [100]
					}],
					"ix": 2
				},
				"o": {
					"a": 0,
					"k": 0,
					"ix": 3
				},
				"m": 1,
				"ix": 2,
				"nm": "Trim Paths 1",
				"mn": "ADBE Vector Filter - Trim",
				"hd": false
			}],
			"ip": 0,
			"op": 74,
			"st": 0,
			"bm": 0
		},
		{
			"ddd": 0,
			"ind": 23,
			"ty": 4,
			"nm": "Top leaf",
			"parent": 22,
			"sr": 1,
			"ks": {
				"o": {
					"a": 0,
					"k": 100,
					"ix": 11
				},
				"r": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 2.77,
							"s": [0]
						},
						{
							"i": {
								"x": [.667],
								"y": [.705]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 11.308,
							"s": [15.3]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [.922]
							},
							"t": 14,
							"s": [29.523]
						},
						{
							"i": {
								"x": [.736],
								"y": [.688]
							},
							"o": {
								"x": [.426],
								"y": [0]
							},
							"t": 17.712,
							"s": [35.8]
						},
						{
							"i": {
								"x": [.67],
								"y": [1]
							},
							"o": {
								"x": [.33],
								"y": [.895]
							},
							"t": 22,
							"s": [20.571]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 32,
							"s": [5.1]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 43.327,
							"s": [4]
						},
						{
							"i": {
								"x": [.667],
								"y": [1]
							},
							"o": {
								"x": [.333],
								"y": [0]
							},
							"t": 51,
							"s": [-1]
						},
						{
							"t": 57,
							"s": [0]
						}
					],
					"ix": 10
				},
				"p": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": .833,
								"y": .833
							},
							"o": {
								"x": .273,
								"y": .507
							},
							"t": 0,
							"s": [
								14.373,
								114.243,
								0
							],
							"to": [
								-1.332,
								-1.789,
								0
							],
							"ti": [
								3.632,
								16.737,
								0
							]
						},
						{
							"i": {
								"x": .833,
								"y": .833
							},
							"o": {
								"x": .167,
								"y": .167
							},
							"t": 5.654,
							"s": [
								3.663,
								80.293,
								0
							],
							"to": [
								-2.991,
								-13.781,
								0
							],
							"ti": [
								-1.664,
								8.643,
								0
							]
						},
						{
							"i": {
								"x": .833,
								"y": .833
							},
							"o": {
								"x": .167,
								"y": .167
							},
							"t": 14.135,
							"s": [
								1.02,
								43.193,
								0
							],
							"to": [
								.322,
								-1.67,
								0
							],
							"ti": [
								-.592,
								4.087,
								0
							]
						},
						{
							"i": {
								"x": .511,
								"y": .948
							},
							"o": {
								"x": .167,
								"y": .167
							},
							"t": 19.788,
							"s": [
								6.269,
								25.364,
								0
							],
							"to": [
								1.279,
								-8.834,
								0
							],
							"ti": [
								.509,
								2.952,
								0
							]
						},
						{
							"t": 40.51953125,
							"s": [
								5.643,
								6.959,
								0
							]
						}
					],
					"ix": 2
				},
				"a": {
					"a": 0,
					"k": [
						12.305,
						22.093,
						0
					],
					"ix": 1
				},
				"s": {
					"a": 1,
					"k": [
						{
							"i": {
								"x": [
									.48,
									.48,
									.48
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.26,
									.26,
									.26
								],
								"y": [
									.682,
									.682,
									0
								]
							},
							"t": 3,
							"s": [
								0,
								0,
								100
							]
						},
						{
							"i": {
								"x": [
									.833,
									.833,
									.833
								],
								"y": [
									1,
									1,
									1
								]
							},
							"o": {
								"x": [
									.167,
									.167,
									.167
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 15.846,
							"s": [
								100,
								100,
								100
							]
						},
						{
							"i": {
								"x": [
									.999,
									.999,
									.999
								],
								"y": [
									.288,
									.288,
									1
								]
							},
							"o": {
								"x": [
									1,
									1,
									1
								],
								"y": [
									0,
									0,
									0
								]
							},
							"t": 61,
							"s": [
								100,
								100,
								100
							]
						},
						{
							"t": 73,
							"s": [
								0,
								0,
								100
							]
						}
					],
					"ix": 6
				}
			},
			"ao": 0,
			"shapes": [{
				"ty": "gr",
				"it": [
					{
						"ind": 0,
						"ty": "sh",
						"ix": 1,
						"ks": {
							"a": 0,
							"k": {
								"i": [
									[.12, 2.895],
									[5.008, 2.343],
									[.69, -.911],
									[-.774, -6.908],
									[-3.763, -.308],
									[-.301, .103]
								],
								"o": [
									[-.325, -7.859],
									[-1.035, -.484],
									[-2.206, 2.914],
									[.889, 7.934],
									[.317, .026],
									[5.855, -1.999]
								],
								"v": [
									[19.602, 15.89],
									[7.263, .237],
									[4.32, .934],
									[.133, 16.341],
									[11.681, 27.054],
									[12.618, 26.937]
								],
								"c": true
							},
							"ix": 2
						},
						"nm": "Path 1",
						"mn": "ADBE Vector Shape - Group",
						"hd": false
					},
					{
						"ty": "st",
						"c": {
							"a": 0,
							"k": [
								.043137254902,
								.41568627451,
								.23137254902,
								1
							],
							"ix": 3
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 4
						},
						"w": {
							"a": 0,
							"k": 3.226,
							"ix": 5
						},
						"lc": 2,
						"lj": 2,
						"bm": 0,
						"nm": "Stroke 1",
						"mn": "ADBE Vector Graphic - Stroke",
						"hd": false
					},
					{
						"ty": "fl",
						"c": {
							"a": 0,
							"k": [
								.76862745098,
								.976470588235,
								.874509803922,
								1
							],
							"ix": 4
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 5
						},
						"r": 1,
						"bm": 0,
						"nm": "Fill 1",
						"mn": "ADBE Vector Graphic - Fill",
						"hd": false
					},
					{
						"ty": "tr",
						"p": {
							"a": 0,
							"k": [0, 0],
							"ix": 2
						},
						"a": {
							"a": 0,
							"k": [0, 0],
							"ix": 1
						},
						"s": {
							"a": 0,
							"k": [100, 100],
							"ix": 3
						},
						"r": {
							"a": 0,
							"k": 0,
							"ix": 6
						},
						"o": {
							"a": 0,
							"k": 100,
							"ix": 7
						},
						"sk": {
							"a": 0,
							"k": 0,
							"ix": 4
						},
						"sa": {
							"a": 0,
							"k": 0,
							"ix": 5
						},
						"nm": "Transform"
					}
				],
				"nm": "Path 5",
				"np": 3,
				"cix": 2,
				"bm": 0,
				"ix": 1,
				"mn": "ADBE Vector Group",
				"hd": false
			}],
			"ip": 0,
			"op": 78,
			"st": 0,
			"bm": 0
		}
	],
	markers: []
};
//#endregion
//#region src/negroni/LoadingAnimations/Growth/Growth.tsx
/**
* An animation of a growing plant, typically used as a loading indicator.
*/
function Growth({ className }) {
	const growthRef = useRef(null);
	useEffect(() => {
		if (growthRef.current) lottie.loadAnimation({
			container: growthRef.current,
			renderer: "svg",
			loop: true,
			autoplay: true,
			animationData: growth_lottie_default
		});
	}, []);
	return /* @__PURE__ */ jsx("div", {
		ref: growthRef,
		className: cx("w-30", className)
	});
}
//#endregion
//#region src/negroni/Slots/Container.tsx
const ContainerContext = React.createContext({});
/** Raw container component @internal */
const _Container = (p, r) => {
	const [props, ref] = useContextProps(p, r, ContainerContext);
	const { className, slot: _, elementType: Tag = "div", ...rest } = props;
	return /* @__PURE__ */ jsx(Tag, {
		...rest,
		className: cx(className, "nds-container"),
		ref
	});
};
/**
* Simple container component that can render as a div, header, footer, or section and is wired
* to receive props via slot names. This component is referenced by components that make use of
* layout slots.
*
* This component is not typically used on its own as there are wrapper components that add
* additional functionality, but it can be used as an escape hatch for fully custom layout
* components.
*
* ### Slots: N/A
*/
const Container = forwardRef(_Container);
//#endregion
//#region src/negroni/Slots/Content.tsx
/** Raw Content component @internal */
const _Content = (props, ref) => /* @__PURE__ */ jsx(Container, {
	...props,
	slot: "content",
	elementType: "div",
	ref
});
/**
* Convenience wrapper for use in components which accept universal layout components.
* It wraps `<Container slot='content'/>`.
*
* ### Slots: None
*/
const Content = forwardRef(_Content);
//#endregion
//#region src/negroni/Slots/Header.tsx
const headerStyles = tv({
	slots: {
		container: "flex shrink-0 items-start justify-between gap-3 bg-neutral-0",
		title: "text-body-1 font-semibold",
		subtitle: "text-body-2 text-content-2",
		content: "flex grow gap-3",
		icon: "self-center rounded-full p-2"
	},
	variants: {
		size: {
			default: "",
			hero: { title: "mb-1 text-title-2" }
		},
		iconVariant: {
			info: { icon: "bg-accent3-100 text-accent3-500" },
			neutral: { icon: "bg-neutral-100 text-neutral-500" },
			success: { icon: "bg-success-100 text-success-500" },
			warning: { icon: "bg-accent1-100 text-accent1-500" },
			error: { icon: "bg-error-100 text-error-500" }
		}
	},
	defaultVariants: { iconVariant: "neutral" }
});
const HeaderContext = createContext({});
/** Special usecase button for header @internal */
const HeaderActionButton = ({ icon: Icon, iconProps, onPress: callback, label, className, ...props }) => !!callback && /* @__PURE__ */ jsx(Button, {
	...props,
	className: cx("self-start rounded border-none bg-transparent outline-none data-[focus-visible]:outline-kbf", className),
	onPress: callback,
	"aria-label": label,
	children: /* @__PURE__ */ jsx(Icon, {
		className: "self-center",
		...iconProps
	})
});
/** Raw `Header` component @internal */
const _Header = (p, r) => {
	const [props, ref] = useContextProps(p, r, HeaderContext);
	const { rightCtxContent: contextContent, children, className, size = "default", subtitle, title, icon: HeaderIcon, iconVariant, ...rest } = props;
	const styles = headerStyles({
		size,
		iconVariant
	});
	const { width } = useWindowSize();
	const renderTitle = () => /* @__PURE__ */ jsx(Heading, {
		slot: "title",
		className: styles.title(),
		children: title
	});
	const renderSubtitle = () => subtitle && /* @__PURE__ */ jsx("p", {
		className: styles.subtitle(),
		children: subtitle
	});
	const renderActionAndChildren = () => /* @__PURE__ */ jsxs("div", {
		className: "flex grow items-center gap-2",
		children: [/* @__PURE__ */ jsx("div", {
			className: styles.content({ className: title && "justify-end" }),
			children
		}), contextContent]
	});
	const renderHeaderWithIcon = () => /* @__PURE__ */ jsx("div", {
		className: "flex w-full justify-between",
		children: /* @__PURE__ */ jsxs("div", {
			className: "flex w-full flex-col",
			children: [/* @__PURE__ */ jsxs("div", {
				className: "flex w-full flex-col gap-4",
				children: [/* @__PURE__ */ jsxs("div", {
					className: "flex w-full items-center justify-between",
					children: [HeaderIcon && /* @__PURE__ */ jsx(HeaderIcon, {
						className: styles.icon(),
						size: "xl"
					}), renderActionAndChildren()]
				}), renderTitle()]
			}), renderSubtitle()]
		})
	});
	const renderHeaderWithoutIcon = () => /* @__PURE__ */ jsxs("div", {
		className: "w-full",
		children: [/* @__PURE__ */ jsxs("div", {
			className: "flex w-full items-center justify-between",
			children: [renderTitle(), renderActionAndChildren()]
		}), renderSubtitle()]
	});
	return /* @__PURE__ */ jsx(Container, {
		elementType: "header",
		slot: "header",
		className: styles.container({ className }),
		...rest,
		ref,
		children: title ? width >= 768 && HeaderIcon ? renderHeaderWithIcon() : renderHeaderWithoutIcon() : renderActionAndChildren()
	});
};
/**
* Header component for use in components that accept universal layout components. It wraps
* `<Container slot="header"/>` and can accept additional content via context (for actions
* such as expand/collapse and close)
*
* ###Slots: None
*/
const Header$1 = forwardRef(_Header);
//#endregion
//#region src/negroni/Slots/Footer.tsx
/** Raw `Footer` component @internal */
const _Footer = ({ className, ...props }, ref) => {
	return /* @__PURE__ */ jsx(Provider, {
		values: [[ButtonContext, { slots: {
			[DEFAULT_SLOT]: {},
			cta: { variant: "solid" },
			close: {
				variant: "outline",
				color: "neutral"
			}
		} }]],
		children: /* @__PURE__ */ jsx(Container, {
			...props,
			className: cx("flex w-full flex-col gap-2 md:flex-row md:justify-end", className),
			slot: "footer",
			elementType: "footer",
			ref
		})
	});
};
/**
* Footer component for use in components that accept universal layout components. It wraps
* `<Container slot="footer"/>` and accepts a few button slots of its own.
*
* ### Slots
* `Button` component:
* * `cta`: Call to action button. Will be styled as "primary".
* * `close`: Secondary button, typically for a close/dismiss action. Styled as "secondary control"
*/
const Footer = forwardRef(_Footer);
//#endregion
//#region src/negroni/utils/hooks/useIsTouchDevice.ts
function useIsTouchDevice() {
	const [isTouchDevice, setIsTouchDevice] = useState(false);
	useEffect(() => {
		function onResize() {
			setIsTouchDevice("ontouchstart" in window || navigator.maxTouchPoints > 0);
		}
		window.addEventListener("resize", onResize);
		onResize();
		return () => {
			window.removeEventListener("resize", onResize);
		};
	}, []);
	return isTouchDevice;
}
//#endregion
//#region src/negroni/Sheet/DragSheet.tsx
const INITIAL_Y = 0;
const STATIC_TRANSITION = {
	duration: .5,
	ease: [
		.32,
		.72,
		0,
		1
	]
};
const INERTIA_TRANSITION = {
	bounceStiffness: 300,
	bounceDamping: 40,
	timeConstant: 100
};
const getHeight = (ref) => ref.current?.getBoundingClientRect()?.height ?? 0;
/** Sheet that supports universal layout components and drag behavior @internal */
const _DragSheet = ({ children, className, isDismissable = true, isDockable = false, onDismiss, onExpansionChange }, ref) => {
	const { width: windowWidth } = useWindowSize();
	const isTouch = useIsTouchDevice();
	const isMobile = windowWidth <= 768;
	const isMotionReduced = useReducedMotion();
	const sheetId = useId();
	const contentId = useId();
	const footerId = useId();
	const sheetRef = useRef(null);
	const handleContainerRef = useRef(null);
	const contentContainerRef = useRef(null);
	const headerRef = useRef(null);
	const dragControls = useDragControls();
	const isDraggable = !isMotionReduced && (isDockable || isDismissable) && (isTouch || isMobile);
	const dragTargetRef = useRef(INITIAL_Y);
	const startDrag = (e) => {
		if (isDraggable) dragControls.start(e, { snapToCursor: false });
	};
	const [isExpanded, setIsExpanded] = useState(isDockable ? true : null);
	const showCloseButton = isDismissable && (!isDraggable || isDockable);
	const ariaExpanderLabel = isExpanded ? "Collapse" : "Expand";
	const ariaExpanded = isDockable ? !!isExpanded : true;
	const ariaExpanderControls = isDockable ? `${contentId} ${footerId}` : sheetId;
	const [isTransitioning, setIsTransitioning] = useState(false);
	const visibilityClasses = isExpanded === false && !isTransitioning && "invisible";
	const [stops, setStops] = useState({
		initial: 0,
		collapsed: 0,
		dismissed: 0,
		midpoints: {
			ic: 0,
			id: 0
		}
	});
	useEffect(() => {
		if (!contentContainerRef.current) return;
		const setYStops = () => {
			const hh = getHeight(headerRef) + getHeight(handleContainerRef);
			const ch = getHeight(contentContainerRef);
			const dismissed = ch + INITIAL_Y;
			const collapsed = ch - hh + INITIAL_Y;
			setStops({
				initial: INITIAL_Y,
				dismissed,
				collapsed,
				midpoints: {
					ic: Math.floor((INITIAL_Y + collapsed) / 2),
					id: Math.floor((INITIAL_Y + dismissed) / 2)
				}
			});
		};
		setYStops();
		if (typeof ResizeObserver !== "undefined") {
			const observer = new ResizeObserver(() => setYStops());
			if (headerRef.current) observer.observe(headerRef.current);
			observer.observe(contentContainerRef.current);
			return () => observer.disconnect();
		}
	}, [isTouch, isMobile]);
	useImperativeHandle(ref, () => {
		return {
			stops,
			sheetRef
		};
	}, [stops]);
	const changeExpansion = (val) => {
		if (val !== isExpanded) {
			setIsTransitioning(true);
			setIsExpanded(val);
			onExpansionChange?.(val);
		}
	};
	const dismiss = () => {
		onDismiss?.();
	};
	const onDragTransitionEnd = () => {
		setIsTransitioning(false);
		if (dragTargetRef.current === stops.dismissed) dismiss();
		else if (dragTargetRef.current === stops.initial && isExpanded === false) changeExpansion(true);
		else if (dragTargetRef.current === stops.collapsed) changeExpansion(false);
	};
	const modifyTarget = (target) => {
		let newTarget;
		if (isExpanded === null) newTarget = target <= stops.midpoints.id || !isDismissable ? stops.initial : stops.dismissed;
		else newTarget = target <= stops.midpoints.ic ? stops.initial : stops.collapsed;
		dragTargetRef.current = newTarget;
		return newTarget;
	};
	const headerActions = /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(HeaderActionButton, {
		icon: ChevronUpIcon,
		label: ariaExpanderLabel,
		"aria-controls": ariaExpanderControls,
		"aria-expanded": ariaExpanded,
		iconProps: { className: cn("motion-safe:transition-transform", isExpanded && "rotate-180") },
		isDisabled: isTransitioning,
		onPress: isDockable && !isDraggable ? () => changeExpansion(!isExpanded) : void 0
	}), /* @__PURE__ */ jsx(HeaderActionButton, {
		isDisabled: isTransitioning,
		icon: XIcon,
		label: "Close",
		"aria-controls": sheetId,
		"aria-expanded": true,
		onPress: showCloseButton ? dismiss : void 0
	})] });
	return /* @__PURE__ */ jsx(motion.div, {
		id: sheetId,
		ref: sheetRef,
		className: "fixed bottom-0 right-0 z-50 flex max-h-[95dvh] w-full flex-col rounded-t-lg bg-neutral-0 text-black shadow-level-2 outline-none will-change-transform after:absolute after:bottom-0 after:h-96 after:w-full after:translate-y-full after:bg-white after:bg-gradient-to-b after:from-white after:to-neutral-800 md:max-h-[50dvh] md:w-[448px]",
		initial: { y: "100%" },
		exit: { y: stops.dismissed },
		animate: isExpanded === false ? { y: stops.collapsed } : { y: stops.initial },
		onAnimationStart: () => setIsTransitioning(true),
		onAnimationComplete: () => setIsTransitioning(false),
		transition: {
			...STATIC_TRANSITION,
			duration: isMotionReduced ? 0 : STATIC_TRANSITION.duration
		},
		drag: "y",
		dragConstraints: { top: stops.initial },
		dragElastic: .1,
		dragTransition: {
			...INERTIA_TRANSITION,
			modifyTarget
		},
		onDragStart: () => {
			setIsTransitioning(true);
		},
		onDragTransitionEnd,
		dragControls,
		dragListener: false,
		children: /* @__PURE__ */ jsxs("div", {
			className: "m-0 flex touch-none flex-col overflow-hidden rounded-t-lg p-0",
			ref: contentContainerRef,
			children: [isDraggable ? /* @__PURE__ */ jsx("div", {
				className: "z-0 flex w-full items-center justify-center pb-1 pt-3",
				ref: handleContainerRef,
				onPointerDown: startDrag,
				children: /* @__PURE__ */ jsx(Button, {
					"aria-label": isDockable ? ariaExpanderLabel : "Close",
					"aria-expanded": ariaExpanded,
					"aria-controls": ariaExpanderControls,
					onPress: () => {
						if (isDockable) changeExpansion(!isExpanded);
						else dismiss();
					},
					className: "pointer-events-none mx-auto h-1.5 w-8 rounded-full border-none bg-neutral-300 outline-none data-[focus-visible]:outline-kbf"
				})
			}) : null, /* @__PURE__ */ jsx("div", {
				className: cx("flex flex-col overflow-auto", className),
				children: /* @__PURE__ */ jsx(Provider, {
					values: [[ContainerContext, { slots: {
						header: {
							className: "p-5 touch-none",
							ref: headerRef,
							onPointerDown: startDrag
						},
						content: {
							id: contentId,
							className: cx("grow overflow-y-auto px-5", visibilityClasses)
						},
						footer: {
							id: footerId,
							className: cx("p-5", visibilityClasses)
						}
					} }], [HeaderContext, {
						size: "default",
						rightCtxContent: headerActions
					}]],
					children
				})
			})]
		})
	});
};
const DragSheet = forwardRef(_DragSheet);
//#endregion
//#region src/negroni/Sheet/ModalSheet.tsx
/** Wrap the modal overlay to animate the scrim. Animations for the sheet are handled in `DragSheet` */
const ModalOverlayWrapper = forwardRef((props, ref) => {
	return /* @__PURE__ */ jsx(ModalOverlay, {
		...props,
		ref
	});
});
ModalOverlayWrapper.displayName = "ModalOverlayWrapper";
const MotionModalOverlay = motion(ModalOverlayWrapper);
const _ModalSheet = ({ id, children, className, isDismissable = true, isKeyboardDismissDisabled, onOpenChange, ...props }, ref) => {
	return /* @__PURE__ */ jsx(MotionModalOverlay, {
		isKeyboardDismissDisabled: !isDismissable || isKeyboardDismissDisabled,
		isOpen: true,
		onOpenChange,
		className: "fixed inset-0 z-30 bg-scrim",
		initial: { opacity: 0 },
		animate: { opacity: 1 },
		exit: { opacity: 0 },
		isDismissable,
		...props,
		children: /* @__PURE__ */ jsx(Modal, { children: /* @__PURE__ */ jsx(Dialog, {
			id,
			className: "outline-none",
			ref,
			children: /* @__PURE__ */ jsx(DragSheet, {
				className,
				isDismissable,
				onDismiss: () => onOpenChange?.(false),
				children
			})
		}) })
	}, "ms-overlay");
};
/**
* Sheet presented as an RAC modal
* @internal
*/
const ModalSheet = forwardRef(_ModalSheet);
//#endregion
//#region src/negroni/Sheet/NonModalSteet.tsx
const _NonModalSheet = ({ id, isDismissable = true, isDockable = false, onOpenChange, ...props }, ref) => {
	const headingId = useId();
	const [hasHeading, setHasHeading] = useState(false);
	const [headerHeight, setHeaderHeight] = useState(0);
	return createPortal(/* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx(motion.div, {
		className: "w-full md:max-h-0",
		style: {
			height: headerHeight,
			content: " "
		},
		exit: { height: 0 }
	}), /* @__PURE__ */ jsx(HeadingContext.Provider, {
		value: {
			id: headingId,
			level: 2,
			ref: (el) => setHasHeading(!!el)
		},
		children: /* @__PURE__ */ jsx("section", {
			id,
			"aria-labelledby": hasHeading ? headingId : void 0,
			ref,
			children: /* @__PURE__ */ jsx(DragSheet, {
				isDismissable,
				isDockable,
				onDismiss: () => onOpenChange?.(false),
				ref: (r) => {
					setHeaderHeight(r !== null && isDockable ? r.stops.dismissed - r.stops.collapsed : 0);
				},
				...props,
				children: props.children
			}, "ds")
		})
	})] }), document.body);
};
/**
* Sheet presented in-flow
* @internal
*/
const NonModalSheet = forwardRef(_NonModalSheet);
//#endregion
//#region src/negroni/Sheet/Sheet.tsx
/**
* Overlay component that slides up from the bottom of the screen. It is not commonly used on its own but all
* overlay components will be (WIP) rendered as sheets on mobile devices (except `Tooltip` which doesn't exist at
* mobile). `Sheet` can either be modal or overlay content without blocking interaction.
*
* ### Slots:
* The sheet supports three `Container` slots:
* * `header`
* * `content`
* * `footer`
*
* We recommend the matching universal layout components (`Header`, `Content`, `Footer`) which
* receive additional slots and context.
*/
const Sheet = ({ isOpen, mobileVersionOf, ...props }) => {
	const ref = useRef(null);
	useEffect(() => {
		if (isOpen && ref.current) {
			const element = ref.current;
			const overlayOpenEvent = createOverlayOpenEvent({
				id: element.id,
				title: element.querySelector("header")?.textContent?.toString(),
				type: mobileVersionOf ?? "sheet"
			});
			element.dispatchEvent(overlayOpenEvent);
		}
	}, [isOpen, mobileVersionOf]);
	return /* @__PURE__ */ jsx(AnimatePresence, { children: isOpen && (props.isNonModal ? /* @__PURE__ */ jsx(NonModalSheet, {
		...props,
		ref
	}, "nms") : /* @__PURE__ */ jsx(ModalSheet, {
		...props,
		ref
	}, "ms")) });
};
//#endregion
//#region src/negroni/Modal/Modal.tsx
const modalStyles = tv({
	slots: {
		overlay: "fixed inset-0 z-30 bg-scrim data-[entering]:animate-fade-in data-[exiting]:animate-fade-out",
		modal: "flex has-[.nds-container]:!p-0",
		dialog: "relative flex w-full flex-col outline-none",
		header: "",
		content: "grow overflow-y-auto",
		footer: "",
		sheet: "px-6 pb-6 has-[.nds-container]:!p-0"
	},
	variants: { variant: {
		modal: {
			overlay: "flex items-center justify-center",
			modal: "mx-auto max-h-[80vh] w-full max-w-[600px] overflow-y-auto rounded-lg bg-neutral-0 p-6 align-middle shadow-level-2 outline-none data-[entering]:motion-safe:animate-slide-in-up data-[exiting]:motion-safe:animate-slide-out-down",
			header: "p-6",
			content: "px-6",
			footer: "p-6"
		},
		drawer: {
			modal: "fixed bottom-0 right-0 top-0 h-dvh w-[424px] bg-surface-1 p-5 outline-none data-[entering]:motion-safe:animate-slide-in-right data-[exiting]:motion-safe:animate-slide-out-right",
			header: "p-5",
			content: "px-5",
			footer: "p-5"
		}
	} },
	defaultVariants: { variant: "modal" }
});
/**
* Overlay component that interupts the user's flow and must be interacted with or dismissed. It comes in
* two variants, a centered dialog or drawer. In either case, it collapses into a `Sheet` on mobile.
*
* ### Slots:
* `Modal` supports three `Container` slots:
* * `header`
* * `content`
* * `footer`
*
* We recommend the matching universal layout components (`Header`, `Content`, `Footer`) which
* receive additional slots and context.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3596-45908&t=qXLQpDJewH7XczK0-0)
*/
const Modal$1 = ({ id, isOpen, onOpenChange, children, className: dialogClassName, modalClassName, hideCloseButton, overlayProps, isDismissable = true, variant = "modal", ...dialogProps }) => {
	const { width: windowWidth } = useWindowSize();
	const isMobile = windowWidth <= 768;
	const displayCloseButton = isDismissable && !hideCloseButton;
	const { dialog: dialogStyle, modal: modalStyle, overlay: overlayStyle, header: headerStyle, content: contentStyle, footer: footerStyle, sheet: sheetStyle } = modalStyles({ variant });
	const ref = useRef(null);
	useEffect(() => {
		if (!isMobile && isOpen && ref.current) {
			const element = ref.current;
			const overlayOpenEvent = createOverlayOpenEvent({
				id: element.id,
				title: element.querySelector("header")?.textContent?.toString(),
				type: variant
			});
			element.dispatchEvent(overlayOpenEvent);
		}
	}, [
		isOpen,
		isMobile,
		variant
	]);
	const _onOpenChange = (val) => {
		onOpenChange?.(val);
	};
	return isMobile ? /* @__PURE__ */ jsx(Sheet, {
		id,
		isDismissable,
		isOpen,
		onOpenChange: _onOpenChange,
		mobileVersionOf: "modal",
		className: sheetStyle({ className: dialogClassName }),
		children
	}) : /* @__PURE__ */ jsx(ModalOverlay, {
		className: overlayStyle({ className: overlayProps }),
		isOpen,
		onOpenChange: _onOpenChange,
		isDismissable,
		isKeyboardDismissDisabled: !isDismissable,
		children: /* @__PURE__ */ jsx(Modal, {
			className: modalStyle({ className: modalClassName }),
			children: /* @__PURE__ */ jsx(Dialog, {
				...dialogProps,
				className: dialogStyle({ className: dialogClassName }),
				ref,
				id,
				children: /* @__PURE__ */ jsx(Provider, {
					values: [[ContainerContext, { slots: {
						header: { className: headerStyle() },
						content: { className: contentStyle() },
						footer: { className: footerStyle() }
					} }], [HeaderContext, {
						size: variant === "modal" ? "hero" : "default",
						rightCtxContent: displayCloseButton && /* @__PURE__ */ jsx(HeaderActionButton, {
							label: "Close",
							icon: XIcon,
							onPress: () => _onOpenChange(false)
						})
					}]],
					children
				})
			})
		})
	});
};
//#endregion
//#region src/negroni/Notifications/NotificationWrapper.tsx
/**
* Rounded badge to display notifications.
* @internal @component
*
* @todo build minimal "pip" variant for use on icons, add motion
*/
const NotificationIndicator = ({ count, className, label }) => {
	const formatter = useNumberFormatter({ style: "decimal" });
	const countString = count !== void 0 ? formatter.format(count) : void 0;
	const accessibleLabel = count !== void 0 ? `${count} ${label}` : label;
	return /* @__PURE__ */ jsx("span", {
		role: "status",
		"aria-label": accessibleLabel,
		className: cx("h-4 min-w-[1rem] rounded-full bg-error-600 px-1 text-center text-[.75rem] leading-[1rem] -tracking-[.0125rem] text-white", className),
		children: countString
	});
};
/**
* Simple wrapper which positions a notification bubble on the top right of wrapped content. It is Intended
* for use on components such as buttons and avatars, typically for chat/messaging or similar use cases.
*
* _Note_: This is not styled yet for use on `Icon` components - use custom SVGs for now.
*
* @component
*/
const NotificationWrapper = ({ children, className, id, "data-testid": testId, label, notifications, indicatorClassName }) => {
	return /* @__PURE__ */ jsxs("div", {
		className: cx("relative w-fit", className),
		id,
		"data-testid": testId,
		children: [children, /* @__PURE__ */ jsx(NotificationIndicator, {
			label,
			className: cx("absolute -right-1 -top-1", !notifications && "hidden", indicatorClassName),
			count: typeof notifications == "number" ? notifications : void 0
		})]
	});
};
//#endregion
//#region src/negroni/NumberInput/NumberInput.tsx
const numberInputStyles = tv({ slots: {
	root: "flex flex-col gap-1",
	group: "group/container flex h-12 items-center overflow-hidden rounded-lg border border-solid border-neutral-100 bg-neutral-0 transition-[border-color] duration-200 ease-in-out focus-within:border-neutral-800 data-[disabled]:border-neutral-300 data-[invalid]:border-error data-[disabled]:bg-neutral-50 data-[invalid]:bg-error-25",
	input: "min-w-0 flex-1 bg-transparent px-3 py-4 text-body-1 text-neutral-800 outline-none placeholder:text-neutral-300 data-[disabled]:text-neutral-300",
	stepButtonGroup: "flex shrink-0 flex-col self-stretch border-l border-neutral-100",
	stepButton: "flex flex-1 cursor-pointer items-center justify-center px-2 text-neutral-300 outline-none data-[disabled]:cursor-default data-[pressed]:bg-neutral-50 data-[disabled]:text-neutral-300 data-[hovered]:text-neutral-800 data-[focus-visible]:outline-kbf",
	stepButtonDivider: "border-t border-neutral-100",
	description: "text-footnote text-neutral-800",
	errorMessage: "text-footnote text-error"
} });
/**
* NumberInput allows users to enter a numeric value and increment or decrement it
* using stepper buttons stacked on the right side of the input. It supports several
* formatting options, including currency symbols, percentage, and decimal places.
*
* [RAC NumberField](https://react-spectrum.adobe.com/react-aria/NumberField.html)
*/
function NumberInputInner({ label, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick, description, errorMessage, className, isInvalid, "data-testid": dataTestId, ...restProps }, ref) {
	const { root, group, input, stepButtonGroup, stepButton, stepButtonDivider, description: descriptionStyles, errorMessage: errorMessageStyles } = numberInputStyles();
	return /* @__PURE__ */ jsxs(NumberField, {
		ref,
		"data-testid": dataTestId,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		className: root({ className }),
		...restProps,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs(Group, {
				className: group(),
				children: [/* @__PURE__ */ jsx(Input, { className: input() }), /* @__PURE__ */ jsxs("div", {
					className: stepButtonGroup(),
					children: [
						/* @__PURE__ */ jsx(Button, {
							slot: "increment",
							className: stepButton(),
							children: /* @__PURE__ */ jsx(PlusIcon, { size: "xs" })
						}),
						/* @__PURE__ */ jsx("div", { className: stepButtonDivider() }),
						/* @__PURE__ */ jsx(Button, {
							slot: "decrement",
							className: stepButton(),
							children: /* @__PURE__ */ jsx(MinusIcon, { size: "xs" })
						})
					]
				})]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: descriptionStyles(),
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: errorMessageStyles(),
				children: errorMessage
			})
		]
	});
}
const NumberInput = forwardRef(NumberInputInner);
//#endregion
//#region src/negroni/Panel/Panel.tsx
const panelStyles = tv({ slots: {
	panel: "transistion group flex h-full w-0 flex-none flex-col overflow-hidden bg-neutral-0 shadow-level-2 duration-500 data-[open]:w-[392px]",
	panelInner: "flex h-full w-[392px] flex-col",
	header: "p-5",
	content: "grow overflow-y-auto px-5",
	footer: "p-5"
} });
const PanelContext = createContext({});
const _Panel = (p, r) => {
	const [props, ref] = useContextProps(p, r, PanelContext);
	const { children, className, "data-testid": testId, id, isDismissable = true, isOpen, onOpenChange, ...rest } = props;
	const { panel, panelInner, header, content, footer } = panelStyles();
	const panelId = useId(id);
	const { width } = useWindowSize();
	const isMobile = width <= 768;
	useEffect(() => {
		if (!isMobile && isOpen && ref.current) {
			const element = ref.current;
			const overlayOpenEvent = createOverlayOpenEvent({
				id: element.id,
				title: element.querySelector("header")?.textContent?.toString(),
				type: "panel"
			});
			element.dispatchEvent(overlayOpenEvent);
		}
	}, [
		isOpen,
		isMobile,
		ref
	]);
	return isMobile ? /* @__PURE__ */ jsx(Sheet, {
		isDismissable,
		isDockable: true,
		isNonModal: true,
		isOpen,
		mobileVersionOf: "panel",
		className,
		onOpenChange,
		children
	}) : /* @__PURE__ */ jsx("section", {
		id: panelId,
		"data-testid": testId,
		className: panel({ className }),
		"data-open": isOpen ? true : void 0,
		ref,
		...rest,
		children: /* @__PURE__ */ jsx("div", {
			className: panelInner({ className }),
			children: /* @__PURE__ */ jsx(Provider, {
				values: [[ContainerContext, { slots: {
					header: { className: header() },
					content: { className: content() },
					footer: { className: footer() }
				} }], [HeaderContext, {
					size: "default",
					rightCtxContent: /* @__PURE__ */ jsx(HeaderActionButton, {
						icon: XIcon,
						label: "Close",
						"aria-controls": panelId,
						"aria-expanded": true,
						onPress: isDismissable ? () => onOpenChange?.(false) : void 0
					})
				}]],
				children
			})
		})
	});
};
/**
* A panel is essentially a non-modal version of a drawer. It slides in from the right, pushing content to make
* space and switches to a dockable, non-modal sheet on mobile so the user can conveniently cross-reference
* main and panel content.
*
* ### Slots:
* The panel supports three `Container` slots:
* * `header`
* * `content`
* * `footer`
*
* The `PanelContainer` wrapper component also supports a `content` slot to streamline layout.
*
* We recommend the matching universal layout components (`Header`, `Content`, `Footer`) which
* receive additional slots and context.
*
* ### Simple Example:
* ```tsx
*<PanelContainer isOpen={open} onOpenChange={callback}>
* <Content>
*   Body content
* </Content>
* <Panel>
*   <Header title="Panel Title"/>
*   <Content>Panel body content</Content>
* </Panel>
*</PanelContainer>
* ```
*/
const Panel = forwardRef(_Panel);
//#endregion
//#region src/negroni/Panel/PanelContainer.tsx
const PanelContainer = ({ id, children, className, "data-testid": testId, ...panelProps }) => {
	return /* @__PURE__ */ jsx(Provider, {
		values: [[PanelContext, panelProps], [ContainerContext, { slots: { content: { className: "h-full w-full p-5" } } }]],
		children: /* @__PURE__ */ jsx("div", {
			id,
			"data-testid": testId,
			className: cx("relative h-full w-full overflow-hidden md:flex", className),
			children
		})
	});
};
//#endregion
//#region src/negroni/PhoneInput/countryData.ts
const countryPatches = { Argentina: { patterns: {
	default: "(..) ........",
	"/^9/": ". .. ........"
} } };
const normalizeCountries = (countries) => countries.map((c) => {
	const patch = countryPatches[c[0]];
	const country = [...c];
	if (patch) country[3] = patch.patterns ?? country[3];
	return country;
});
normalizeCountries(defaultCountries);
/**
* Returns a list of countries, filtering by dial codes. Sorted by country name,
* while placing the United States & Canada as the first two entries.
* @param excludedDialCodes list of dial codes of countries we want to exclude
* @param restrictToDialCodes list of dial codes to exclusively include (takes precedence over excludedDialCodes)
* @returns
*/
const getCountryDataExcept = (excludedDialCodes, restrictToDialCodes = []) => {
	return normalizeCountries(defaultCountries).filter((country) => {
		const { dialCode } = parseCountry(country);
		if (!dialCode) return false;
		if (restrictToDialCodes.length > 0) return restrictToDialCodes.includes(dialCode);
		return !excludedDialCodes.includes(dialCode);
	}).sort((a, b) => {
		const countryA = parseCountry(a);
		const countryB = parseCountry(b);
		if (countryA.name === "United States") return -1;
		if (countryB.name === "United States") return 1;
		if (countryA.name === "Canada") return -1;
		if (countryB.name === "Canada") return 1;
		return countryA.name.localeCompare(countryB.name);
	});
};
//#endregion
//#region src/negroni/PhoneInput/CountrySelect.tsx
/** @internal */
const CountrySelect = ({ country, setCountry, popoverWidth, onOpenChange, countries, classNames, ...p }) => {
	const { icon } = selectStyles();
	const { listbox, item } = listBoxStyles();
	return /* @__PURE__ */ jsxs(Select, {
		...p,
		"aria-label": "country code",
		className: cn("group/sel", classNames),
		selectedKey: country.iso2,
		onSelectionChange: (k) => setCountry(k),
		onOpenChange,
		children: [/* @__PURE__ */ jsxs(Button, {
			className: "flex h-[calc(3rem_-_2px)] w-[84px] items-center gap-2 rounded-l-lg border-r p-3 pl-4 focus:outline-none data-[hovered]:bg-neutral-25 data-[focus-visible]:ring data-[focus-visible]:ring-kbf group-data-[open]/sel:bg-neutral-100",
			children: [/* @__PURE__ */ jsx(SelectValue, { className: "[&_[slot=description]]:hidden" }), /* @__PURE__ */ jsx(ChevronDownIcon, {
				size: "sm",
				className: icon({ className: "group-data-[open]/sel:rotate-180 group-data-[disabled]/sel:text-neutral-300" })
			})]
		}), /* @__PURE__ */ jsx(PopoverWrapper, {
			className: cn("min-w-[220px] outline-none", popoverAnimationClasses),
			offset: 18,
			style: { width: popoverWidth },
			children: /* @__PURE__ */ jsx(ListBox, {
				className: listbox({}),
				children: countries.map((c) => {
					const countryItem = parseCountry(c);
					return /* @__PURE__ */ jsxs(ListBoxItem, {
						id: countryItem.iso2,
						className: item({ className: "flex-row items-center justify-start gap-4" }),
						textValue: countryItem.name,
						children: [/* @__PURE__ */ jsx(Text, {
							slot: "label",
							className: "shrink-0",
							children: /* @__PURE__ */ jsx(FlagImage, {
								iso2: countryItem.iso2,
								size: 32
							})
						}), /* @__PURE__ */ jsxs(Text, {
							slot: "description",
							className: "flex grow justify-between",
							children: [
								/* @__PURE__ */ jsx("span", { children: countryItem.name }),
								" ",
								/* @__PURE__ */ jsxs("span", {
									className: "w-[5ch] text-neutral-500",
									"data-testid": `dial-code-${countryItem.dialCode}`,
									children: ["+", countryItem.dialCode]
								})
							]
						})]
					}, countryItem.iso2);
				})
			})
		})]
	});
};
//#endregion
//#region src/negroni/PhoneInput/PhoneInput.tsx
/**
* A PhoneInput combines a country selector with a phone number input to allow the user to enter a phone
* number in E.164 format.
*/
const PhoneInput = ({ block, className, description, errorMessage, hideCountryCode, label, isDisabled, isInvalid, placeholder, secondaryClassName, secondaryHref, secondaryLabel, value, variant, onSecondaryClick, onChange, isRequired, restrictToDialCodes = [], excludedDialCodes = [], validationBehavior = "native", ...rest }) => {
	const sizeRef = useRef(null);
	const { width = 0 } = useResizeObserver({
		ref: sizeRef,
		box: "border-box"
	});
	const countries = getCountryDataExcept(excludedDialCodes, restrictToDialCodes);
	const disableCountrySelect = restrictToDialCodes?.length === 1;
	const { inputValue, handlePhoneValueChange, inputRef, country, setCountry, phone } = usePhoneInput({
		defaultCountry: "us",
		value,
		countries,
		disableDialCodeAndPrefix: hideCountryCode,
		onChange: (data) => {
			onChange?.(data.phone, {
				iso2: data.country.iso2,
				dialCode: data.country.dialCode,
				inputValue: data.inputValue
			});
		}
	});
	const defaultValidate = () => {
		return !isRequired && phone.length <= country.dialCode.length + 1 || isValidPhoneNumber(phone) ? "" : "Enter a valid phone number.";
	};
	const hasError = isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0;
	const { container: containerStyles, inputContainer: inputContainerStyles, description: descStyles, errorMessage: errorStyles, input: boxStyles } = inputStyles({
		masked: false,
		block,
		variant,
		hasError
	});
	const onOpenChange = (open) => {
		if (!open && inputRef.current) inputRef.current.focus();
	};
	return /* @__PURE__ */ jsxs(TextField, {
		className: cx(containerStyles(), inputContainerStyles(), className),
		isInvalid: hasError,
		isDisabled,
		isRequired,
		value: inputValue,
		validationBehavior,
		validate: validationBehavior === "native" ? defaultValidate : void 0,
		...rest,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs(Group, {
				className: boxStyles({ className: cx("flex items-center p-0 has-[[data-invalid]]:border-error has-[[data-open]]:!border-neutral-800 has-[[data-invalid]]:bg-error-25", !disableCountrySelect ? "has-[[data-disabled]]:border-neutral-300 has-[[data-disabled]]:bg-neutral-50" : "") }),
				ref: sizeRef,
				children: [/* @__PURE__ */ jsx(CountrySelect, {
					country,
					setCountry,
					popoverWidth: width,
					isDisabled: isDisabled || disableCountrySelect,
					onOpenChange,
					classNames: disableCountrySelect ? "has-[[data-disabled]]:border-neutral-300 has-[[data-disabled]]:bg-neutral-50 has-[[data-disabled]]:rounded-l-lg" : "",
					countries,
					name: `${rest.name || "phone"}CountryCode`
				}), /* @__PURE__ */ jsx(Input, {
					ref: inputRef,
					className: "h-full w-full rounded-r-lg bg-transparent px-3 placeholder:text-neutral-300 focus-visible:outline-none data-[disabled]:text-neutral-300 data-[focus]:outline-none data-[focus-visible]:ring data-[focus-visible]:ring-kbf",
					placeholder: placeholder || "Enter phone number",
					onChange: handlePhoneValueChange,
					value: inputValue
				})]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: descStyles(),
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: errorStyles(),
				children: errorMessage
			})
		]
	});
};
//#endregion
//#region src/negroni/ProgressBar/ProgressBar.tsx
const progressBarStyles = tv({
	slots: {
		barWrapper: "overflow-hidden rounded-lg bg-neutral-200",
		bar: "rounded-lg",
		circleWrapper: "relative",
		svg: "",
		circle: "",
		label: "pt-1 text-footnote text-neutral-800"
	},
	variants: {
		size: {
			sm: {
				barWrapper: "h-1",
				bar: "h-1",
				circleWrapper: "h-6 w-6",
				svg: "h-6 w-6"
			},
			lg: {
				barWrapper: "h-3",
				bar: "h-3",
				circleWrapper: "h-15 w-15",
				svg: "h-15 w-15"
			}
		},
		color: {
			brand: {
				bar: "bg-brand-500",
				circle: "text-brand-500"
			},
			success: {
				bar: "bg-success-500",
				circle: "text-success-500"
			},
			error: {
				bar: "bg-error-500",
				circle: "text-error-500"
			},
			neutral: {
				bar: "bg-neutral-900",
				circle: "text-neutral-900"
			},
			accent: {
				bar: "bg-accent2-100",
				circle: "text-accent2-200"
			}
		},
		isIndeterminate: { true: {
			bar: "animate-slide-in-out-infinite",
			svg: "animate-spinner"
		} },
		hideLabelOnMobile: { true: { label: "hidden md:block" } }
	}
});
const center = 16;
const strokeWidth = 4;
const r = 12;
const c = 2 * Math.PI * r;
/**
*
* Progress bars show either determinate or indeterminate progress of an operation over time.
*
* [Figma Specs](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=29290-41259&mode=design&t=dykdXMDtPZs9gs9U-4)
*
* [RAC ProgressBar](https://react-spectrum.adobe.com/react-aria/ProgressBar.html#progressbar)
*/
function ProgressBar$1({ label, showValueText = true, color = "success", isIndeterminate = false, hideLabelOnMobile = false, size = "sm", variant = "linear", "data-testid": dataTestId, ...restProps }) {
	const { barWrapper, bar, circleWrapper, svg, circle, label: labelStyle } = progressBarStyles({
		size,
		color,
		isIndeterminate,
		hideLabelOnMobile
	});
	return /* @__PURE__ */ jsx(ProgressBar, {
		"data-testid": dataTestId,
		...restProps,
		children: ({ percentage, valueText }) => variant === "linear" ? /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("div", {
			className: barWrapper(),
			children: /* @__PURE__ */ jsx("div", {
				className: bar(),
				style: { width: `${percentage}%` }
			})
		}), /* @__PURE__ */ jsxs("div", {
			className: "flex justify-between",
			children: [label && /* @__PURE__ */ jsx(Label, {
				className: labelStyle(),
				children: label
			}), showValueText && /* @__PURE__ */ jsx("span", {
				className: labelStyle(),
				children: valueText
			})]
		})] }) : /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsxs("div", {
			className: circleWrapper(),
			children: [/* @__PURE__ */ jsxs("svg", {
				className: svg(),
				viewBox: "0 0 32 32",
				fill: "none",
				strokeWidth,
				children: [/* @__PURE__ */ jsx("circle", {
					className: "text-neutral-200",
					cx: center,
					cy: center,
					r,
					stroke: "currentColor",
					strokeWidth
				}), /* @__PURE__ */ jsx("circle", {
					className: circle(),
					cx: center,
					cy: center,
					r,
					stroke: "currentColor",
					strokeWidth,
					strokeDasharray: c,
					strokeDashoffset: percentage ? (100 - percentage) / 100 * c : c,
					strokeLinecap: "round",
					transform: `rotate(-90 ${center} ${center})`
				})]
			}), size === "lg" && showValueText && /* @__PURE__ */ jsx("span", {
				className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 transform text-body-2 font-semibold text-neutral-700",
				children: valueText
			})]
		}), label && /* @__PURE__ */ jsx(Label, {
			className: labelStyle(),
			children: label
		})] })
	});
}
//#endregion
//#region src/negroni/RadioGroup/RadioGroup.tsx
/**
* Radio is a single option in a RadioGroup.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3851-46074&t=H3GPlm3IPDMwchJY-0)
*/
function Radio$1({ children, className, ...restProps }) {
	return /* @__PURE__ */ jsxs(Radio, {
		className: cx("group relative flex items-center justify-center gap-3", className),
		...restProps,
		children: [/* @__PURE__ */ jsx("div", { className: "pointer-cursor flex size-6 min-w-6 items-center justify-center rounded-full border border-current bg-transparent text-neutral-100 outline-none transition-all duration-200 ease-in-out before:hidden before:size-4 before:animate-fade-in-grow before:rounded-full before:bg-current group-data-[disabled]:pointer-events-none group-data-[disabled]:bg-neutral-100 group-data-[disabled]:group-data-[selected]:bg-neutral-100 group-data-[hovered]:bg-accent1-100 group-data-[disabled]:group-data-[selected]:text-neutral-400 group-data-[disabled]:text-neutral-400 group-data-[hovered]:text-brand-600 group-data-[invalid]:group-data-[disabled]:text-neutral-400 group-data-[invalid]:group-data-[hovered]:text-brand-600 group-data-[invalid]:text-error-500 group-data-[selected]:group-data-[hovered]:text-brand-700 group-data-[selected]:group-data-[invalid]:text-error-500 group-data-[selected]:text-brand-600 group-data-[disabled]:shadow-none group-data-[hovered]:shadow-level-3 group-data-[focus-visible]:outline-2 group-data-[focus-visible]:outline-kbf before:group-data-[selected]:block" }), /* @__PURE__ */ jsx("span", {
			className: "flex-1",
			children
		})]
	});
}
/**
* A RadioGroup is a set of radio buttons that allow the user to select one option from a list of
* mutually exclusive options.
*/
function RadioGroup$1({ label, description, errorMessage, children, orientation = "horizontal", className, isInvalid, ...props }) {
	return /* @__PURE__ */ jsxs(RadioGroup, {
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		className: cx("group flex flex-col gap-2", className),
		...props,
		children: [
			label && /* @__PURE__ */ jsx(Label, {
				className: "text-body-1 group-data-[disabled]:text-neutral-400",
				children: label
			}),
			/* @__PURE__ */ jsx("div", {
				className: cn("flex", orientation === "horizontal" ? "gap-8" : "flex-col gap-4"),
				children
			}),
			description && /* @__PURE__ */ jsx("div", {
				className: "pt-2 text-body-2",
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: "text-footnote text-error",
				children: errorMessage
			})
		]
	});
}
//#endregion
//#region src/negroni/RichTextEditor/utils.ts
function getSelectedNode(selection) {
	if (selection) {
		const { anchor } = selection;
		const { focus } = selection;
		const anchorNode = anchor.getNode();
		const focusNode = focus.getNode();
		if (anchorNode === focusNode) return anchorNode;
		if (selection.isBackward()) return $isAtNodeEnd(focus) ? anchorNode : focusNode;
		return $isAtNodeEnd(anchor) ? focusNode : anchorNode;
	}
	return null;
}
/**
* These are the classes that are added to the generated HTML from the editor.
*/
const EditorTheme = {
	paragraph: "m-0 mb-2",
	list: {
		ol: "list-decimal",
		ul: "list-disc",
		listitem: "mx-8 my-2"
	},
	link: "text-blue-500 no-underline",
	text: {
		bold: "font-semibold",
		italic: "italic",
		underline: "underline"
	}
};
const editorNodes = [
	HeadingNode,
	ListNode,
	ListItemNode,
	QuoteNode,
	CodeNode,
	CodeHighlightNode,
	AutoLinkNode,
	LinkNode
];
/** Custom (non-standard) underline transformer */
const UNDERLINE_UNDERSCORE = {
	format: ["underline"],
	intraword: false,
	tag: "_",
	type: "text-format"
};
/** Custom element transformers */
const CUSTOM_ELEMENT_TRANSFORMERS = [UNORDERED_LIST, ORDERED_LIST];
/** Constrain to allowed text format transformers, including custom underline */
const CUSTOM_TEXT_TRANSFORMERS = [
	BOLD_STAR,
	ITALIC_STAR,
	BOLD_ITALIC_STAR,
	UNDERLINE_UNDERSCORE
];
/** Combine all transformers */
const MDTRANSFORMERS = [
	...CUSTOM_ELEMENT_TRANSFORMERS,
	...CUSTOM_TEXT_TRANSFORMERS,
	...TEXT_MATCH_TRANSFORMERS
];
function removeHtmlAttributes(htmlString, attributeNames) {
	const attributeRegex = new RegExp(`\\s+(${attributeNames.join("|")})=["'][^"']*["']`, "g");
	return htmlString.replace(attributeRegex, "");
}
/**
* Transforms all anchor tags in HTML to open in new tabs with security attributes.
* Adds target="_blank" and rel="noopener noreferrer" to prevent reverse-tabnabbing attacks.
* Preserves and merges any existing rel attribute values.
*/
function addSecureLinkAttributes(htmlString) {
	return htmlString.replace(/<a\b([^>]*)>/gi, (_match, attrPart) => {
		let newAttrs = attrPart;
		newAttrs = newAttrs.replace(/\s*target\s*=\s*["'][^"']*["']/gi, "");
		if (/(\srel\s*=\s*)(["'])([^"']*)["']/i.test(newAttrs)) newAttrs = newAttrs.replace(/(\srel\s*=\s*)(["'])([^"']*)["']/gi, (_relMatch, prefix, quote, value) => {
			const tokens = new Set(value.split(/\s+/).map((t) => t.trim()).filter(Boolean));
			tokens.add("noopener");
			tokens.add("noreferrer");
			return `${prefix}${quote}${Array.from(tokens).join(" ")}${quote}`;
		});
		else newAttrs += " rel=\"noopener noreferrer\"";
		newAttrs += " target=\"_blank\"";
		return `<a${newAttrs}>`;
	});
}
function prepareHtmlString(htmlString, forceOpenInNewTab = false) {
	const strippedHtml = removeHtmlAttributes(htmlString, [
		"class",
		"style",
		"dir"
	]);
	return `<div class="nds-rich-text">${forceOpenInNewTab ? addSecureLinkAttributes(strippedHtml) : strippedHtml}</div>`;
}
function extractTextFromJsonText(node) {
	let textContent = "";
	if (node.type === "text" && node.text) return node.text;
	if (node.children) node.children.forEach((childNode) => {
		textContent += extractTextFromJsonText(childNode);
	});
	return textContent;
}
/**
* Takes a input of html, markdown or JSON editor state (stringified or not) and parses it to HTML.
*
* When `format` is provided, the input is parsed as that format directly, bypassing heuristic detection.
* When `format` is omitted, the input format is auto-detected (for backward compatibility):
*   - Strings starting with '<' are treated as HTML
*   - Non-string values or strings starting with '{' are treated as JSON
*   - All other strings are treated as markdown
*
* Note: if input is HTML, this expects a DOM parser to be available, so this should only be used in
* a browser environment.
*/
const parseInputToHtml = (input, forceOpenInNewTab = false, currentEditor, format) => {
	if (!input) return "";
	const editor = currentEditor ?? createHeadlessEditor({
		nodes: editorNodes,
		onError: () => {}
	});
	const isHtml = format === "html" || !format && typeof input === "string" && input.trimStart().startsWith("<");
	const isJson = format === "json" || !format && (typeof input !== "string" || input.trimStart().startsWith("{") && input.includes("\"root\":"));
	if (isHtml) {
		const dom = new DOMParser().parseFromString(input, "text/html");
		editor.update(() => {
			const nodes = $generateNodesFromDOM(editor, dom);
			$getRoot().select();
			$insertNodes(nodes);
		}, { discrete: true });
	} else if (isJson) editor.setEditorState(editor.parseEditorState(input));
	else editor.update(() => {
		$convertFromMarkdownString(input, MDTRANSFORMERS);
	}, { discrete: true });
	let htmlString = "";
	editor.getEditorState().read(() => {
		htmlString = $generateHtmlFromNodes(editor);
		htmlString = prepareHtmlString(htmlString, forceOpenInNewTab);
	});
	return htmlString;
};
//#endregion
//#region src/negroni/RichTextEditor/components/LinkEditor.tsx
const linkEditorStyles = tv({ slots: {
	linkEditor: "invisible absolute left-[-10000px] top-[-10000px] z-[100] -mt-1.5 w-full max-w-xs rounded-lg bg-white shadow-[0px_5px_10px_rgba(0,0,0,0.3)] transition-opacity duration-[0.5s]",
	linkInput: "link-input relative mx-3 my-2 box-border block flex h-9 w-[calc(100%_-_24px)] items-center rounded-lg border-0 bg-gray-200 px-3 py-2 text-base text-[rgb(5,5,5)]",
	linkEdit: "absolute inset-y-0 right-2 flex cursor-pointer items-center",
	linkInputAnchor: "block cursor-pointer overflow-hidden text-ellipsis whitespace-nowrap pr-5 pt-px text-blue-500 no-underline"
} });
function positionLinkEditorElement(editorDiv, rect, containerRect) {
	if (!rect || !containerRect) {
		editorDiv.style.visibility = "hidden";
		editorDiv.style.top = "-1000px";
		editorDiv.style.left = "-1000px";
	} else {
		const editorRect = editorDiv.getBoundingClientRect();
		editorDiv.style.visibility = "visible";
		editorDiv.style.top = `${rect.top + rect.height - containerRect.top + 8}px`;
		if (rect.left + editorRect.width < containerRect.right) editorDiv.style.left = `${rect.left - containerRect.left - 2}px`;
		else editorDiv.style.left = `${containerRect.right - containerRect.x - editorRect.width}px`;
	}
}
/** @internal */
function LinkEditor({ editor, containerRef, isTextEditorFocused }) {
	const linkEditorRef = useRef(null);
	const inputRef = useRef(null);
	const linkRef = useRef(null);
	const mouseDownRef = useRef(false);
	const [linkUrl, setLinkUrl] = useState("");
	const [tempLinkUrl, setTempLinkUrl] = useState("");
	const [isEditMode, setIsEditMode] = useState(false);
	const [lastSelection, setLastSelection] = useState(null);
	const { linkEditor, linkInput, linkInputAnchor, linkEdit } = linkEditorStyles();
	const handleConfirmUrl = () => {
		let newUrl = "";
		if (tempLinkUrl.startsWith("http")) newUrl = tempLinkUrl;
		else newUrl = `https://${tempLinkUrl}`;
		setLinkUrl(newUrl);
		if (lastSelection !== null) {
			if (tempLinkUrl !== "") editor.dispatchCommand(TOGGLE_LINK_COMMAND, {
				url: newUrl,
				target: "_blank",
				rel: "noopener noreferrer"
			});
			else editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
			setIsEditMode(false);
		}
	};
	const handleCancelUrl = () => {
		if (linkUrl === "") editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
		setTempLinkUrl(linkUrl);
		setIsEditMode(false);
	};
	const updateLinkEditor = useCallback(() => {
		const selection = $getSelection();
		if ($isRangeSelection(selection)) {
			const node = getSelectedNode(selection);
			const parent = node?.getParent();
			let oldUrl = "";
			if ($isLinkNode(parent)) {
				oldUrl = parent.getURL();
				if (oldUrl === "") setIsEditMode(true);
			} else if ($isLinkNode(node)) oldUrl = node.getURL();
			setLinkUrl(oldUrl);
			setTempLinkUrl(oldUrl);
		}
		const linkEditorElem = linkEditorRef.current;
		const nativeSelection = window.getSelection();
		const { activeElement } = document;
		if (linkEditorElem === null) return;
		const rootElement = editor.getRootElement();
		if (selection !== null && rootElement !== null && nativeSelection !== null && rootElement.contains(nativeSelection?.anchorNode)) {
			const domRange = nativeSelection.focusNode?.parentElement;
			let rect;
			if (nativeSelection?.anchorNode === rootElement) {
				let inner = rootElement;
				if (inner.firstElementChild != null) inner = inner.firstElementChild;
				rect = inner.getBoundingClientRect();
			} else rect = domRange?.getBoundingClientRect();
			if (!mouseDownRef.current && isTextEditorFocused) {
				const containerRect = containerRef?.current?.getBoundingClientRect();
				positionLinkEditorElement(linkEditorElem, rect, containerRect);
			}
			setLastSelection(selection);
		} else if (!activeElement?.className.includes("link-input")) {
			positionLinkEditorElement(linkEditorElem, null);
			setLastSelection(null);
			setIsEditMode(false);
			setLinkUrl("");
			setTempLinkUrl("");
		}
	}, [editor]);
	useEffect(() => mergeRegister(editor.registerUpdateListener(({ editorState }) => {
		editorState.read(() => {
			updateLinkEditor();
		});
	}), editor.registerCommand(SELECTION_CHANGE_COMMAND, () => {
		updateLinkEditor();
		return true;
	}, 1)), [editor, updateLinkEditor]);
	useEffect(() => {
		editor.getEditorState().read(() => {
			updateLinkEditor();
		});
	}, [editor, updateLinkEditor]);
	useEffect(() => {
		if (isEditMode) inputRef.current?.focus();
		else if (!isTextEditorFocused) {
			if (linkEditorRef.current) positionLinkEditorElement(linkEditorRef.current, null);
		}
	}, [isEditMode, isTextEditorFocused]);
	return /* @__PURE__ */ jsx("div", {
		ref: linkEditorRef,
		className: linkEditor(),
		role: "presentation",
		onMouseDown: (e) => {
			e.preventDefault();
		},
		children: isEditMode ? /* @__PURE__ */ jsxs("div", {
			className: "relative",
			children: [/* @__PURE__ */ jsx("input", {
				"aria-label": "edit link url",
				ref: inputRef,
				className: linkInput({ className: "pr-12" }),
				value: tempLinkUrl,
				onChange: (event) => {
					setTempLinkUrl(event.target.value);
				},
				onKeyDown: (event) => {
					if (event.key === "Enter") {
						event.preventDefault();
						handleConfirmUrl();
					} else if (event.key === "Escape") {
						event.preventDefault();
						handleCancelUrl();
					}
				}
			}), /* @__PURE__ */ jsxs("div", {
				className: "absolute inset-y-0 right-5 flex cursor-pointer items-center gap-1",
				children: [/* @__PURE__ */ jsx("button", {
					"aria-label": "cancel",
					type: "button",
					className: "flex h-8 w-8 items-center justify-center rounded-lg bg-transparent p-2 text-neutral-800 transition-colors hover:bg-neutral-25 active:bg-neutral-100",
					onClick: () => handleCancelUrl(),
					children: /* @__PURE__ */ jsx(XCircleIcon, { size: "sm" })
				}), /* @__PURE__ */ jsx("button", {
					"aria-label": "confirm",
					type: "button",
					className: "flex h-8 w-8 items-center justify-center rounded-lg bg-transparent p-2 text-neutral-800 transition-colors hover:bg-neutral-25 active:bg-neutral-100",
					onClick: () => handleConfirmUrl(),
					children: /* @__PURE__ */ jsx(CheckCircleIcon, { size: "sm" })
				})]
			})]
		}) : /* @__PURE__ */ jsxs("div", {
			className: linkInput(),
			children: [/* @__PURE__ */ jsx("a", {
				ref: linkRef,
				href: encodeURI(linkUrl),
				target: "_blank",
				className: linkInputAnchor(),
				rel: "noopener noreferrer",
				onKeyDown: (event) => {
					if (event.key === "Escape" || event.key === "Enter") {
						if (linkEditorRef.current) {
							positionLinkEditorElement(linkEditorRef.current, null);
							editor.getRootElement()?.focus();
						}
					}
				},
				children: linkUrl
			}), /* @__PURE__ */ jsx("div", {
				className: linkEdit(),
				children: /* @__PURE__ */ jsx("button", {
					"aria-label": "edit link",
					type: "button",
					className: "flex h-8 w-8 items-center justify-center rounded-lg bg-transparent p-2 text-neutral-800 transition-colors hover:bg-neutral-25 active:bg-neutral-100",
					onClick: () => setIsEditMode(true),
					children: /* @__PURE__ */ jsx(PencilIcon, { size: "sm" })
				})
			})]
		})
	});
}
//#endregion
//#region src/negroni/RichTextEditor/components/RichTextOutputWrapper.tsx
/**
* Wraps HTML generated from the Rich Text Editor and applies styles to display them consistently.
* NOTE: This does not include HTML sanitization.
*/
function RichTextOutputWrapper({ children }) {
	return /* @__PURE__ */ jsx("div", {
		className: cn("[&>*_.nds-rich-text_p]:m-0 [&>*_.nds-rich-text_p]:mb-2", "[&>*_.nds-rich-text>ol]:list-decimal [&>*_.nds-rich-text>ul]:list-disc", "[&>*_.nds-rich-text_li]:mx-8 [&>*_.nds-rich-text_li]:my-2", "[&>*_.nds-rich-text_i]:italic [&>*_.nds-rich-text_strong]:font-semibold", "[&>*_.nds-rich-text_a]:text-blue-500"),
		children
	});
}
//#endregion
//#region src/negroni/RichTextEditor/components/RichTextOutputRenderer.tsx
/**
* Takes the output generated from the Rich Text Editor (JSON, HTML, or markdown), and renders it as HTML.
* Warning: When using this component with server side rendering, you may need to specify it to be rendered on the client.
* E.g. with Remix SSR, this component (or it's parent) should be wrapped with `ClientOnly`.
*/
function RichTextOutputRenderer({ input, richTextJson, richTextOutput, forceOpenInNewTab = false, inputFormat: format }) {
	return /* @__PURE__ */ jsx(RichTextOutputWrapper, { children: /* @__PURE__ */ jsx("div", { dangerouslySetInnerHTML: { __html: useMemo(() => {
		let normalizedInput = "";
		let resolvedFormat = format;
		if (input !== void 0) normalizedInput = input;
		else if (richTextJson !== void 0) {
			normalizedInput = richTextJson;
			resolvedFormat ??= "json";
		} else if (richTextOutput !== void 0) normalizedInput = richTextOutput;
		return parseInputToHtml(normalizedInput, forceOpenInNewTab, void 0, resolvedFormat);
	}, [
		input,
		richTextJson,
		richTextOutput,
		forceOpenInNewTab,
		format
	]) } }) });
}
//#endregion
//#region src/negroni/RichTextEditor/components/RteContext.tsx
const RichTextEditorContext = createContext({});
const useRichTextEditorContext = () => {
	return useContext(RichTextEditorContext);
};
//#endregion
//#region src/negroni/RichTextEditor/components/SendButton.tsx
/** @internal */
function SendButton({ persistOnSend, icon, variant, ariaLabel = "Send", onSend, format = "json", "data-tracking-additionals": trackingAdditionals }) {
	const { isDisabled: ctxDisabled, isFocused, hasContent, hasError, isSendDisabled } = useRichTextEditorContext();
	const [editor] = useLexicalComposerContext();
	const isActive = (isFocused || hasContent) && !hasError && !isSendDisabled;
	const isDisabled = ctxDisabled || !hasContent || hasError || isSendDisabled;
	const onSendClick = () => {
		const editorState = editor.getEditorState();
		const serializedEditorState = editorState.toJSON();
		let output;
		if (format === "json") output = serializedEditorState;
		else editorState.read(() => {
			output = $convertToMarkdownString(MDTRANSFORMERS).trim();
		});
		onSend?.(output);
		if (!persistOnSend) editor.dispatchCommand(CLEAR_EDITOR_COMMAND, void 0);
	};
	if (variant === "lg") return /* @__PURE__ */ jsx(Button$1, {
		icon,
		color: isActive ? "brand" : "neutral",
		onPress: onSendClick,
		className: "mt-5",
		isDisabled,
		"aria-label": ariaLabel,
		size: "lg",
		"data-tracking-additionals": trackingAdditionals,
		children: "Send"
	});
	return /* @__PURE__ */ jsx(Button$1, {
		icon: icon || SendIcon,
		color: isActive ? "brand" : "neutral",
		className: !isActive ? "text-neutral-300" : void 0,
		onPress: onSendClick,
		isDisabled,
		"aria-label": ariaLabel,
		size: "sm",
		"data-tracking-additionals": trackingAdditionals
	});
}
//#endregion
//#region src/negroni/RichTextEditor/components/ToggleButton.tsx
const toggleButtonStyles$1 = tv({
	base: "mx-0.5 rounded p-1 text-neutral-300 outline-none first:ml-0 data-[focus-visible]:bg-neutral-100 data-[hovered]:bg-neutral-100 data-[pressed]:bg-neutral-200",
	variants: {
		isSelected: { true: "bg-neutral-300 text-neutral-800 hover:bg-neutral-400" },
		isActive: { true: "text-secondary" },
		isDisabled: { true: "hover:bg-none" }
	},
	compoundVariants: [{
		isSelected: true,
		isActive: false,
		class: "bg-neutral-100 hover:bg-neutral-200"
	}]
});
/** @internal */
function ToggleButton$2({ isSelected, isActive, isDisabled, onChange, children, ...toggleButtonProps }) {
	return /* @__PURE__ */ jsx(ToggleButton, {
		isSelected,
		isDisabled,
		onChange,
		className: toggleButtonStyles$1({
			isSelected,
			isActive
		}),
		...toggleButtonProps,
		children
	});
}
//#endregion
//#region src/negroni/RichTextEditor/components/Toolbar.tsx
function Divider() {
	return /* @__PURE__ */ jsx("div", { className: "mx-1 w-px bg-neutral-100" });
}
/** @internal */
function Toolbar({ isDisabled, isFocused, textEditorRef }) {
	const [editor] = useLexicalComposerContext();
	const toolbarRef = useRef(null);
	const [blockType, setBlockType] = useState("paragraph");
	const [isLink, setIsLink] = useState(false);
	const [isBold, setIsBold] = useState(false);
	const [isItalic, setIsItalic] = useState(false);
	const [isUnderline, setIsUnderline] = useState(false);
	const formatBulletList = () => {
		if (blockType !== "ul") editor.dispatchCommand(INSERT_UNORDERED_LIST_COMMAND, void 0);
		else editor.dispatchCommand(REMOVE_LIST_COMMAND, void 0);
	};
	const formatNumberedList = () => {
		if (blockType !== "ol") editor.dispatchCommand(INSERT_ORDERED_LIST_COMMAND, void 0);
		else editor.dispatchCommand(REMOVE_LIST_COMMAND, void 0);
	};
	const updateToolbar = useCallback(() => {
		const selection = $getSelection();
		if ($isRangeSelection(selection)) {
			const anchorNode = selection.anchor.getNode();
			const element = anchorNode.getKey() === "root" ? anchorNode : anchorNode.getTopLevelElementOrThrow();
			const elementKey = element.getKey();
			if (editor.getElementByKey(elementKey) !== null) if ($isListNode(element)) {
				const parentList = $getNearestNodeOfType(anchorNode, ListNode);
				setBlockType(parentList ? parentList.getTag() : element.getTag());
			} else setBlockType($isHeadingNode(element) ? element.getTag() : element.getType());
			setIsBold(selection.hasFormat("bold"));
			setIsItalic(selection.hasFormat("italic"));
			setIsUnderline(selection.hasFormat("underline"));
			const node = getSelectedNode(selection);
			const parent = node?.getParent();
			if ($isLinkNode(parent) || $isLinkNode(node)) setIsLink(true);
			else setIsLink(false);
		}
	}, [editor]);
	useEffect(() => mergeRegister(editor.registerUpdateListener(({ editorState }) => {
		editorState.read(() => {
			updateToolbar();
		});
	}), editor.registerCommand(SELECTION_CHANGE_COMMAND, () => {
		updateToolbar();
		return false;
	}, 1)), [editor, updateToolbar]);
	const insertLink = useCallback(() => {
		if (!isLink) editor.dispatchCommand(TOGGLE_LINK_COMMAND, "");
		else editor.dispatchCommand(TOGGLE_LINK_COMMAND, null);
	}, [editor, isLink]);
	return /* @__PURE__ */ jsxs("div", {
		className: "flex align-middle",
		ref: toolbarRef,
		children: [
			/* @__PURE__ */ jsx(ToggleButton$2, {
				"aria-label": "bold",
				isActive: isFocused,
				isDisabled,
				isSelected: isBold,
				onChange: () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "bold"),
				children: /* @__PURE__ */ jsx(BoldIcon, { size: "sm" })
			}),
			/* @__PURE__ */ jsx(ToggleButton$2, {
				"aria-label": "italics",
				isActive: isFocused,
				isDisabled,
				isSelected: isItalic,
				onChange: () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "italic"),
				children: /* @__PURE__ */ jsx(ItalicIcon, { size: "sm" })
			}),
			/* @__PURE__ */ jsx(ToggleButton$2, {
				"aria-label": "underline",
				isActive: isFocused,
				isDisabled,
				isSelected: isUnderline,
				onChange: () => editor.dispatchCommand(FORMAT_TEXT_COMMAND, "underline"),
				children: /* @__PURE__ */ jsx(UnderlineIcon, { size: "sm" })
			}),
			/* @__PURE__ */ jsx(Divider, {}),
			/* @__PURE__ */ jsx(ToggleButton$2, {
				"aria-label": "bulleted list",
				isActive: isFocused,
				isDisabled,
				isSelected: blockType === "ul",
				onChange: formatBulletList,
				children: /* @__PURE__ */ jsx(ListBulletIcon, { size: "sm" })
			}),
			/* @__PURE__ */ jsx(ToggleButton$2, {
				"aria-label": "numbered list",
				isActive: isFocused,
				isDisabled,
				isSelected: blockType === "ol",
				onChange: formatNumberedList,
				children: /* @__PURE__ */ jsx(ListNumbersIcon, { size: "sm" })
			}),
			/* @__PURE__ */ jsx(Divider, {}),
			/* @__PURE__ */ jsx(ToggleButton$2, {
				"aria-label": "insert link",
				isActive: isFocused,
				isDisabled,
				isSelected: isLink,
				onChange: insertLink,
				children: /* @__PURE__ */ jsx(LinkIcon, { size: "sm" })
			}),
			isLink && !isDisabled && /* @__PURE__ */ jsx(LinkEditor, {
				editor,
				isTextEditorFocused: isFocused,
				containerRef: textEditorRef
			})
		]
	});
}
//#endregion
//#region src/negroni/RichTextEditor/plugins/CustomOnChangePlugin.tsx
function CustomOnChangePlugin({ onChange, format = "json", invalidCharsPattern }) {
	const handleChange = (editorState) => {
		let charLength = 0;
		let isOnlyWhiteSpace = true;
		editorState.read(() => {
			const root = $getRoot();
			const serializedEditorState = editorState.toJSON();
			const editorText = extractTextFromJsonText(serializedEditorState.root);
			const containsInvalidChars = invalidCharsPattern ? invalidCharsPattern.test(editorText) : false;
			charLength = root.getAllTextNodes().reduce((acc, node) => {
				if (isOnlyWhiteSpace && node.__text?.trim()?.length) isOnlyWhiteSpace = false;
				return acc + (node.getTextContentSize() || 0);
			}, 0);
			let output;
			if (format === "json") output = serializedEditorState;
			else output = $convertToMarkdownString(MDTRANSFORMERS).trim();
			onChange(output, {
				charLength,
				isOnlyWhiteSpace,
				containsInvalidChars
			});
		});
	};
	return /* @__PURE__ */ jsx(OnChangePlugin, { onChange: handleChange });
}
//#endregion
//#region src/negroni/RichTextEditor/plugins/DisableInputPlugin.tsx
function DisableInputPlugin({ isDisabled }) {
	const [editor] = useLexicalComposerContext();
	useEffect(() => {
		editor.setEditable(!isDisabled);
	}, [editor, isDisabled]);
	return null;
}
//#endregion
//#region src/negroni/RichTextEditor/plugins/InitialValuePlugin.tsx
function InitialValuePlugin({ initialValueString, serializedEditorState, format }) {
	const [editor] = useLexicalComposerContext();
	useEffect(() => {
		return editor.update(() => {
			if (serializedEditorState) {
				const editorState = editor.parseEditorState(serializedEditorState);
				editor.setEditorState(editorState);
			} else if (initialValueString?.length) {
				const input = initialValueString.trim();
				if (!$getRoot().getTextContentSize()) if (format === "html" || !format && input.startsWith("<")) {
					const nodes = $generateNodesFromDOM(editor, new DOMParser().parseFromString(input, "text/html"));
					$getRoot().select();
					$insertNodes(nodes);
				} else $convertFromMarkdownString(input, MDTRANSFORMERS);
			}
		});
	}, [editor]);
	return null;
}
//#endregion
//#region src/negroni/RichTextEditor/plugins/MaxLengthPlugin.tsx
function MaxLengthPlugin({ maxLength }) {
	const [editor] = useLexicalComposerContext();
	const [currentTextLength, setCurrentTextLength] = useState(0);
	useEffect(() => {
		let lastRestoredEditorState = null;
		return editor.registerNodeTransform(RootNode, (rootNode) => {
			const selection = $getSelection();
			if (!$isRangeSelection(selection) || !selection.isCollapsed()) return;
			const prevEditorState = editor.getEditorState();
			const prevTextContentSize = prevEditorState.read(() => rootNode.getTextContentSize());
			const textContentSize = rootNode.getAllTextNodes().reduce((acc, node) => {
				return acc + (node.getTextContentSize() || 0);
			}, 0);
			setCurrentTextLength(textContentSize);
			if (prevTextContentSize !== textContentSize) {
				const delCount = textContentSize - maxLength;
				const { anchor } = selection;
				if (delCount > 0) if (prevTextContentSize === maxLength && lastRestoredEditorState !== prevEditorState) {
					lastRestoredEditorState = prevEditorState;
					$restoreEditorState(editor, prevEditorState);
				} else trimTextContentFromAnchor(editor, anchor, delCount);
			}
		});
	}, [editor, maxLength]);
	return /* @__PURE__ */ jsxs("div", {
		className: "text-neutral-400",
		children: [
			currentTextLength < maxLength ? currentTextLength : maxLength,
			"/",
			maxLength
		]
	});
}
//#endregion
//#region src/negroni/RichTextEditor/plugins/TriggerClearEditorPlugin.tsx
const TriggerClearEditorPlugin = forwardRef(function TriggerClearEditorPlugin({}, ref) {
	const [editor] = useLexicalComposerContext();
	useImperativeHandle(ref, () => ({ clearEditor: () => {
		editor.dispatchCommand(CLEAR_EDITOR_COMMAND, void 0);
	} }));
	return null;
});
//#endregion
//#region src/negroni/RichTextEditor/RichTextEditor.tsx
const richTextEditorStyles = tv({
	slots: {
		container: "group/rte",
		inputContainer: "relative mx-auto flex w-full flex-col overflow-x-visible rounded-lg border border-solid border-neutral-100 bg-white text-black group-data-[focused]/rte:border-neutral-800",
		inner: "relative min-h-[6rem] overflow-y-scroll",
		placeholder: "pointer-events-none absolute left-4 top-3 select-none overflow-hidden text-ellipsis text-neutral-400",
		input: "h-full max-h-screen resize-none rounded-lg border-0 px-4 py-3 text-body-1 outline-none",
		toolbarContainer: "flex items-center justify-between px-4 pb-3"
	},
	variants: {
		inputVariant: {
			lg: {
				inner: "h-[calc(100%_-_2.75rem)]",
				inputContainer: "h-full",
				container: "h-full max-h-[48rem]"
			},
			xl: {
				inner: "h-[calc(100%_-_2.75rem)]",
				inputContainer: "h-full",
				container: "h-full max-h-screen"
			},
			sm: { input: "" }
		},
		sendButtonVariant: {
			lg: { container: "flex flex-col" },
			sm: {}
		},
		error: { true: { inputContainer: "border-error-500 bg-error-25" } },
		isDisabled: { true: { inputContainer: "bg-neutral-50" } }
	}
});
const editorConfig = {
	theme: EditorTheme,
	namespace: "RichTextEditor",
	onError(error) {
		throw error;
	},
	nodes: editorNodes
};
/**
* Rich Text Editor which outputs a JSON object, HTML string, or markdown string which represents the state of the editor, allows for bold, italic, underline, ordered list,
* and unordered list.
* The generated output can be passed to the RichTextOutputRenderer component to convert it to HTML and apply styling. <br/><br/>
* See [Figma designs here](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=20845-5940&mode=design&t=K7C2dlDf9MbKMvG3-0).
*/
const RichTextEditor = forwardRef(function RichTextEditor({ placeHolder = "Type message...", sendButtonVariant = "sm", sendButtonIcon, inputVariant = "sm", initialEditorState, initialValue, isDisabled, id, maxLength, persistOnSend, hasError, errorMessage, errorIcon: ErrorIcon, sendButtonAriaLabel, "data-testid": dataTestId, "data-tracking-additionals": trackingAdditionals, className, onChange, onSend, invalidCharsPattern, disableSendButton = false, customActions, format = "json", inputFormat }, ref) {
	const textEditorRef = useRef(null);
	const [isFocused, setIsFocused] = useState(false);
	const [hasContent, setHasContent] = useState(false);
	const { container, inputContainer, inner, input, placeholder, toolbarContainer } = richTextEditorStyles({
		error: hasError || disableSendButton,
		inputVariant,
		isDisabled,
		sendButtonVariant
	});
	const handleEditorChange = useCallback((serializedEditorState, meta) => {
		onChange?.(serializedEditorState, meta);
		setHasContent(Boolean(meta?.charLength));
	}, [onChange]);
	return /* @__PURE__ */ jsx(LexicalComposer, {
		initialConfig: editorConfig,
		children: /* @__PURE__ */ jsx(RichTextEditorContext.Provider, {
			value: {
				isFocused,
				isDisabled,
				hasContent,
				hasError
			},
			children: /* @__PURE__ */ jsxs("div", {
				onFocus: () => {
					setIsFocused(true);
				},
				onBlur: () => {
					setIsFocused(false);
				},
				className: container(),
				"data-disabled": isDisabled || void 0,
				"data-focused": isFocused || void 0,
				children: [
					/* @__PURE__ */ jsxs("div", {
						id,
						ref: textEditorRef,
						"data-testid": dataTestId,
						className: inputContainer(),
						children: [/* @__PURE__ */ jsxs("div", {
							className: inner(),
							children: [
								/* @__PURE__ */ jsx(RichTextPlugin, {
									contentEditable: /* @__PURE__ */ jsx(ContentEditable, { className: input({ className }) }),
									placeholder: !initialValue && !initialEditorState ? /* @__PURE__ */ jsx("div", {
										className: placeholder(),
										children: placeHolder
									}) : null,
									ErrorBoundary: LexicalErrorBoundary
								}),
								/* @__PURE__ */ jsx(CustomOnChangePlugin, {
									invalidCharsPattern,
									onChange: handleEditorChange,
									format
								}),
								/* @__PURE__ */ jsx(InitialValuePlugin, {
									initialValueString: initialValue,
									serializedEditorState: initialEditorState,
									format: inputFormat
								}),
								/* @__PURE__ */ jsx(ClearEditorPlugin, {}),
								Boolean(Object.keys(ref || {}).length) && /* @__PURE__ */ jsx(TriggerClearEditorPlugin, { ref }),
								/* @__PURE__ */ jsx(DisableInputPlugin, { isDisabled }),
								/* @__PURE__ */ jsx(HistoryPlugin, {}),
								/* @__PURE__ */ jsx(AutoFocusPlugin, {}),
								/* @__PURE__ */ jsx(ListPlugin, {}),
								/* @__PURE__ */ jsx(LinkPlugin, {}),
								/* @__PURE__ */ jsx(MarkdownShortcutPlugin, { transformers: MDTRANSFORMERS })
							]
						}), /* @__PURE__ */ jsxs("div", {
							className: toolbarContainer(),
							children: [/* @__PURE__ */ jsx(Toolbar, {
								isFocused,
								isDisabled,
								textEditorRef
							}), /* @__PURE__ */ jsxs("div", {
								className: "flex items-center gap-3",
								children: [
									Boolean(maxLength) && /* @__PURE__ */ jsx(MaxLengthPlugin, { maxLength: maxLength || 400 }),
									customActions,
									sendButtonVariant === "sm" && Boolean(onSend) && /* @__PURE__ */ jsx(SendButton, {
										variant: "sm",
										onSend,
										persistOnSend,
										ariaLabel: sendButtonAriaLabel,
										format,
										"data-tracking-additionals": trackingAdditionals
									})
								]
							})]
						})]
					}),
					hasError && errorMessage && /* @__PURE__ */ jsxs(Text, {
						slot: "errorMessage",
						className: "mt-1 flex items-center gap-1 text-footnote text-error-500",
						children: [ErrorIcon && /* @__PURE__ */ jsx(ErrorIcon, { size: "xs" }), errorMessage]
					}),
					sendButtonVariant === "lg" && Boolean(onSend) && /* @__PURE__ */ jsx("div", {
						className: "flex justify-end",
						children: /* @__PURE__ */ jsx(SendButton, {
							icon: sendButtonIcon,
							variant: sendButtonVariant,
							persistOnSend,
							onSend,
							ariaLabel: sendButtonAriaLabel,
							format,
							"data-tracking-additionals": trackingAdditionals
						})
					})
				]
			})
		})
	});
});
//#endregion
//#region src/negroni/SelectionCellGroup/useSelectionCellContext.ts
const SelectionCellContext = createContext({ variant: "radio" });
const useSelectionCellContext = () => {
	return useContext(SelectionCellContext);
};
//#endregion
//#region src/negroni/SelectionCellGroup/SelectionCell.tsx
const selectionCellStyles = tv({
	slots: {
		cell: "label group flex h-full grow cursor-pointer select-none items-center gap-4 rounded-lg border border-neutral-100 bg-neutral-0 p-4 outline-none transition-all data-[hovered]:border-brand-500 data-[invalid]:border-error-400 data-[invalid]:data-[hovered]:border-brand-500 data-[invalid]:data-[selected]:border-error-500 data-[selected]:border-brand-500 data-[selected]:data-[hovered]:border-brand-600 data-[invalid]:data-[selected]:bg-error-25 data-[selected]:bg-accent1-50 data-[selected]:data-[invalid]:data-[hovered]:bg-accent1-50 data-[disabled]:text-neutral-400 data-[hovered]:shadow-level-3 data-[selected]:shadow-none data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf data-[focus-visible]:ring-offset-2 [&>div:first-of-type]:!outline-none",
		infotip: "size-6 self-start rounded-lg outline-none data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf data-[focus-visible]:ring-offset-2"
	},
	variants: { toggle: {
		top: { cell: "items-start" },
		center: {
			cell: "items-center",
			infotip: "self-center"
		},
		hidden: { cell: "[&>div:first-of-type]:hidden" }
	} },
	defaultVariants: { toggle: "top" }
});
/**
* SelectionCell component. This should only be used within a SelectionCellGroup.
*/
function SelectionCell(props) {
	const { label, subText, prefixIcon: PrefixIconFromProp, suffixIcon: SuffixIconFromProp, prefixIconProps, suffixIconProps, toggle, tooltip, className } = props;
	const { variant, toggle: ctxToggle } = useSelectionCellContext();
	const { cell, infotip } = selectionCellStyles({ toggle: toggle ?? ctxToggle });
	const renderContent = /* @__PURE__ */ jsxs("div", {
		className: "flex w-full gap-4",
		children: [
			PrefixIconFromProp && /* @__PURE__ */ jsx(PrefixIconFromProp, { ...prefixIconProps }),
			/* @__PURE__ */ jsxs("div", {
				className: "flex flex-1 flex-col",
				children: [typeof label === "string" ? /* @__PURE__ */ jsx("span", {
					className: "text-body-1 font-semibold",
					children: label
				}) : label, /* @__PURE__ */ jsx("span", {
					className: "text-body-2 text-neutral-600",
					children: subText
				})]
			}),
			SuffixIconFromProp && !tooltip && /* @__PURE__ */ jsx(SuffixIconFromProp, {
				...suffixIconProps,
				className: cx("min-w-6", suffixIconProps?.className)
			}),
			tooltip && /* @__PURE__ */ jsxs(Tooltip$1.Trigger, { children: [/* @__PURE__ */ jsx(Button, {
				className: infotip(),
				children: /* @__PURE__ */ jsx(InfoIcon, {})
			}), /* @__PURE__ */ jsx(Tooltip$1, { children: tooltip })] })
		]
	});
	return variant === "radio" ? /* @__PURE__ */ jsx(Radio$1, {
		...props,
		className: cell({ className }),
		children: renderContent
	}) : /* @__PURE__ */ jsx(Checkbox$1, {
		...props,
		className: cell({ className }),
		children: renderContent
	});
}
//#endregion
//#region src/negroni/SelectionCellGroup/SelectionCellGroup.tsx
const selectionCellGroupStyles = tv({
	slots: {
		wrapper: "flex flex-col gap-2",
		errorText: "flex items-center gap-1 pt-2 text-footnote text-error-500"
	},
	variants: { orientation: {
		horizontal: { wrapper: "md:flex-row md:items-stretch" },
		vertical: { wrapper: "" }
	} }
});
/**
* A group of styled cells for selecting one or more options.
*
* This component is a lightweight wrapper around
* [RadioGroup](https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/negroni-forms-radiogroup--docs)
* and [CheckboxGroup](https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/negroni-forms-checkboxgroup--docs)
* for common use cases. The `variant` prop determines whether the group behaves as a radio group or checkbox group
* (and which props are available).
*
* ### Subcomponents:
* * `SelectionCell`: A syled radio/checkbox. This component should only be used within a `SelectionCellGroup` - for more custom and/or complex layouts, use `RadioGroup` or `CheckboxGroup` and their children directly.
*/
function SelectionCellGroup(props) {
	const { errorMessage, isInvalid, children, layoutClassName, orientation, toggle, variant } = props;
	const { wrapper, errorText } = selectionCellGroupStyles();
	const normalizedValidity = isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0;
	const renderErrorMessage = /* @__PURE__ */ jsxs("div", {
		className: errorText(),
		children: [/* @__PURE__ */ jsx(AlertTriangleIcon, {
			size: "sm",
			className: "text-error-500"
		}), /* @__PURE__ */ jsx("div", {
			className: "text-footnote text-error",
			children: errorMessage
		})]
	});
	return /* @__PURE__ */ jsx(SelectionCellContext.Provider, {
		value: {
			variant: variant ?? "radio",
			toggle: toggle ?? "top"
		},
		children: variant === "radio" ? /* @__PURE__ */ jsxs(RadioGroup, {
			...props,
			isInvalid: normalizedValidity,
			"aria-label": props["aria-label"] ?? "Selection Cells",
			children: [/* @__PURE__ */ jsx("div", {
				className: wrapper({
					orientation,
					className: layoutClassName
				}),
				children
			}), errorMessage && renderErrorMessage]
		}) : /* @__PURE__ */ jsxs(CheckboxGroup, {
			...props,
			isInvalid: normalizedValidity,
			children: [/* @__PURE__ */ jsx("div", {
				className: wrapper({
					orientation,
					className: layoutClassName
				}),
				children
			}), errorMessage && renderErrorMessage]
		})
	});
}
//#endregion
//#region src/negroni/SelectionGroup/SelectionGroup.tsx
const { item: itemStyles, list } = tv({
	slots: {
		item: "w-full cursor-pointer border transition-colors",
		list: "flex"
	},
	variants: { variant: {
		chips: {
			item: "rounded-full border-neutral-200 bg-neutral-0 text-content-2 outline-none ring-offset-2 data-[disabled]:cursor-default data-[disabled]:border-neutral-100 data-[hovered]:bg-neutral-50 data-[selected]:bg-neutral-100 data-[disabled]:text-neutral-400 data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf",
			list: "flex-wrap gap-2"
		},
		bar: {
			item: "border-black font-semibold outline-none first:rounded-l-lg last:rounded-r-lg last:!border-r even:border-l-0 even:border-r-0 hover:bg-neutral-100 data-[selected]:bg-neutral-200 data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-2 data-[focus-visible]:outline-kbf",
			list: ""
		}
	} },
	defaultVariants: { variant: "chips" }
})();
function SelectionItem({ children, className, variant = "chips", ...props }) {
	return /* @__PURE__ */ jsx(Tag, {
		textValue: typeof children === "string" ? children : void 0,
		className: itemStyles({
			className,
			variant
		}),
		...props,
		children: ({ allowsRemoving }) => /* @__PURE__ */ jsxs("div", {
			className: cn("flex h-8 w-full items-center justify-center gap-3 rounded-full pl-3 pr-2.5 text-body-2", allowsRemoving && "justify-between"),
			children: [children, allowsRemoving && /* @__PURE__ */ jsx(Button, {
				className: "text-black outline-none",
				slot: "remove",
				children: /* @__PURE__ */ jsx(XCircleIcon, {
					className: "text-content-2 hover:text-content-1",
					size: "sm"
				})
			})]
		})
	});
}
/**
*
* A focusable list of labels, categories, keywords, filters, or other items, with support for keyboard navigation, selection, and removal.
*
* [RAC Tag Group](https://react-spectrum.adobe.com/react-aria/TagGroup.html)
*
* @see {@link https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/experimental-selectiongroup--docs | Storybook} for more detailed usage and examples.
*
* @experimental
*/
function SelectionGroup({ label, description, errorMessage, variant, children, renderEmptyState, items, selectionMode, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick, className, ...props }) {
	return /* @__PURE__ */ jsxs(TagGroup, {
		...props,
		selectionMode,
		className: cx("flex flex-col gap-2", className),
		children: [
			label && /* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsx(TagList, {
				renderEmptyState,
				items,
				className: list({ variant }),
				children: items ? (item) => /* @__PURE__ */ jsx(SelectionItem, {
					className: !selectionMode ? "cursor-default" : void 0,
					variant,
					children: item.name
				}) : children
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: "text-body-2",
				children: description
			}),
			errorMessage && /* @__PURE__ */ jsx(Text, {
				slot: "errorMessage",
				className: "text-body-2 text-error-500",
				children: errorMessage
			})
		]
	});
}
function RemovableSelectionGroupContext({ children, onRemove }) {
	const [isSelected, onChange] = useState(false);
	return /* @__PURE__ */ jsx(ToggleButtonContext.Provider, {
		value: {
			isSelected,
			onChange
		},
		children: /* @__PURE__ */ jsx(TagGroupContext.Provider, {
			value: { onRemove: isSelected ? onRemove : void 0 },
			children
		})
	});
}
//#endregion
//#region src/negroni/Skeleton/Skeleton.tsx
const skeleton = tv({
	base: "flex w-full items-center justify-center bg-[#D5D0C9]",
	variants: {
		variant: {
			text: "my-[calc((1lh_-_1em)_/_2)] h-[1em] rounded-md",
			circular: "rounded-full",
			rectangular: "",
			rounded: "rounded-md",
			media: "rounded-md"
		},
		animate: { true: "animate-skeletonPulse" }
	}
});
const isMediaSkeletonProps = (props) => {
	return props.variant === "media";
};
/**
* A Skeleton is a loading indicator that shows a placeholder for a UI element while the data is loading.
*/
const Skeleton = (props) => {
	const { variant = "text", animate = true, className } = props;
	return /* @__PURE__ */ jsxs("span", {
		className: skeleton({
			variant,
			animate,
			className
		}),
		children: [isMediaSkeletonProps(props) && props.mediaType === "image" && /* @__PURE__ */ jsx(ImageIcon, { className: "text-white" }), isMediaSkeletonProps(props) && props.mediaType === "video" && /* @__PURE__ */ jsx(VideoIcon, { className: "text-white" })]
	});
};
//#endregion
//#region src/negroni/Switch/Switch.tsx
/**
* Switch component
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library-%5BWIP%5D?type=design&node-id=3856-46102&t=qN1D5TNmJAuthwdj-4)
*/
function Switch$1({ label, labelPlacement = "left", className, ...props }) {
	return /* @__PURE__ */ jsxs(Switch, {
		className: cx(`group relative flex items-center gap-2 ${labelPlacement === "left" ? "w-full justify-between" : ""}`, className),
		...props,
		children: [
			labelPlacement === "left" && label,
			/* @__PURE__ */ jsx("div", {
				className: "inline-flex h-6 w-[44px] shrink-0 cursor-pointer rounded-full bg-neutral-100 bg-clip-padding p-0.5 transition-colors duration-200 ease-in-out focus:outline-none data-[focus-visible]:outline-kbf group-data-[hovered]:bg-neutral-400 group-data-[selected]:bg-brand-500 group-data-[selected]:group-data-[disabled]:bg-brand-200 group-data-[selected]:group-data-[hovered]:bg-brand-700 group-data-[pressed]:shadow-level-3 group-data-[focus-visible]:outline group-data-[focus-visible]:outline-offset-2 group-data-[focus-visible]:outline-kbf",
				children: /* @__PURE__ */ jsx("span", { className: "h-5 w-5 translate-x-0 transform rounded-full bg-white shadow-level-1 ring-0 transition duration-200 ease-in-out group-data-[selected]:translate-x-full group-data-[pressed]:scale-x-105 group-data-[disabled]:bg-neutral-400 group-data-[selected]:group-data-[disabled]:bg-white" })
			}),
			labelPlacement === "right" && label
		]
	});
}
//#endregion
//#region src/negroni/Table/Table.tsx
const tableStyles = tv({
	slots: {
		container: "flex h-full w-full flex-col",
		tableBody: "relative",
		cell: "h-14 border-b px-2 text-left outline-0 first:pl-4 last:pr-4 data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf",
		row: "h-14 outline-0 data-[hovered]:cursor-pointer data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf",
		column: "sticky top-0 h-14 cursor-default whitespace-nowrap border-b px-2 py-3 text-left outline-0 first:pl-4 last:pr-4 data-[focus-visible]:outline-2 data-[focus-visible]:outline-offset-[-1px] data-[focus-visible]:outline-kbf",
		columnSortIcon: "ml-1",
		footerContainer: "mt-6 flex w-full flex-row items-center justify-between",
		footerSection: "flex flex-row items-center gap-2",
		footerPageNumbers: "h-6 w-6 rounded-lg outline-none",
		textcolor: ""
	},
	variants: {
		theme: {
			light: {
				cell: "border-neutral-50",
				row: "bg-white data-[hovered]:bg-neutral-25 data-[selected]:bg-neutral-50",
				column: "border-neutral-50 bg-white",
				tableBody: "border-neutral-50 bg-white",
				textcolor: "text-neutral-600"
			},
			dark: {
				cell: "border-accent2-500",
				row: "border-accent2-500 bg-accent2-700 text-neutral-25 data-[hovered]:bg-accent2-600 data-[selected]:bg-accent2-500",
				column: "border-accent2-500 bg-accent2-700",
				tableBody: "border-accent2-500 bg-accent2-700",
				textcolor: "text-neutral-25"
			}
		},
		isCurrentPage: { true: { footerPageNumbers: "bg-neutral-100" } },
		isVirtualized: { true: { cell: "flex items-center" } }
	}
});
function Column$1({ children, theme = "light", headerClassName, ...rest }) {
	const { column, textcolor } = tableStyles({ theme });
	return /* @__PURE__ */ jsx(Column, {
		...rest,
		className: column(),
		children: ({ allowsSorting, sortDirection }) => /* @__PURE__ */ jsxs("span", {
			className: cx(headerClassName, "flex items-center", allowsSorting ? "cursor-pointer" : "pointer-events-none has-[[slot=selection]]:pointer-events-auto"),
			"aria-hidden": "true",
			children: [/* @__PURE__ */ jsx("span", {
				className: textcolor({ className: "text-label font-semibold" }),
				children
			}), allowsSorting && /* @__PURE__ */ jsx(ChevronDownIcon, {
				size: "xs",
				className: cn("ml-1", sortDirection === "ascending" && "rotate-180", !sortDirection && "invisible")
			})]
		})
	});
}
function TableHeader$1({ columns, children, theme }) {
	const { selectionBehavior, selectionMode } = useTableOptions();
	return /* @__PURE__ */ jsxs(TableHeader, { children: [selectionBehavior === "toggle" && selectionMode === "multiple" && /* @__PURE__ */ jsx(Column$1, {
		minWidth: 0,
		width: 52,
		theme,
		children: /* @__PURE__ */ jsx(Checkbox$1, { slot: "selection" })
	}), /* @__PURE__ */ jsx(Collection, {
		items: columns,
		children
	})] });
}
function Cell$1(props) {
	const { cell } = tableStyles();
	const { className = "", theme, isVirtualized } = props;
	const cellClassName = typeof className === "function" ? className({
		isPressed: false,
		isFocused: false,
		isFocusVisible: false,
		isHovered: false,
		isSelected: false,
		defaultClassName: void 0
	}) : className;
	return /* @__PURE__ */ jsx(Cell, {
		...props,
		className: cell({
			className: cellClassName,
			theme,
			isVirtualized
		})
	});
}
function Row$1({ columns, item, id, className, theme = "light", isVirtualized = false }) {
	const { selectionBehavior, selectionMode } = useTableOptions();
	const { row } = tableStyles();
	return /* @__PURE__ */ jsxs(Row, {
		className: row({
			className,
			theme
		}),
		id,
		children: [selectionBehavior === "toggle" && selectionMode === "multiple" && /* @__PURE__ */ jsx(Cell$1, {
			theme,
			isVirtualized,
			children: /* @__PURE__ */ jsx(Checkbox$1, { slot: "selection" })
		}), /* @__PURE__ */ jsx(Collection, {
			items: columns,
			children: (column) => /* @__PURE__ */ jsx(Cell$1, {
				className: column.className,
				theme,
				isVirtualized,
				children: item[column.id]
			})
		})]
	});
}
function TableFooter({ pageSize = 25, onPageSizeChange, children }) {
	const pageSizes = [
		25,
		50,
		100
	];
	const { footerContainer, footerSection } = tableStyles();
	return /* @__PURE__ */ jsxs("div", {
		className: footerContainer(),
		"aria-label": "pagination",
		children: [/* @__PURE__ */ jsxs("div", {
			className: footerSection(),
			children: [
				/* @__PURE__ */ jsx("div", {
					className: "text-body-2 text-neutral-500",
					children: "Showing"
				}),
				pageSizes.map((size) => /* @__PURE__ */ jsx(Button, {
					className: "outline-none",
					onPress: () => {
						if (onPageSizeChange) onPageSizeChange(size);
					},
					children: /* @__PURE__ */ jsx("div", {
						className: cn("text-body-2", size === pageSize ? "text-neutral-900" : "text-brand-600"),
						children: size
					})
				}, size)),
				/* @__PURE__ */ jsx("div", {
					className: "text-body-2 text-neutral-500",
					children: "items"
				})
			]
		}), /* @__PURE__ */ jsx("div", {
			className: footerSection(),
			children
		})]
	});
}
function NumberPagination({ total = 0, currentPage = 1, onPageChange = () => void 0, pageSize = 25 }) {
	const isLastPage = currentPage * pageSize >= total;
	const pageNumbers = getPageNumbers({
		currentPage,
		pageSize,
		total
	});
	const { footerPageNumbers } = tableStyles();
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		/* @__PURE__ */ jsxs("div", {
			className: "text-body-2 text-neutral-500",
			children: [
				(currentPage - 1) * pageSize + 1,
				"-",
				isLastPage ? total : currentPage * pageSize,
				" of ",
				total
			]
		}),
		/* @__PURE__ */ jsx(Button, {
			className: "outline-none",
			isDisabled: currentPage === 1,
			onPress: () => onPageChange(currentPage - 1),
			children: /* @__PURE__ */ jsx(ChevronLeftIcon, { className: "text-neutral-400" })
		}),
		pageNumbers.map((pageNumber, i) => /* @__PURE__ */ jsx(Button, {
			isDisabled: pageNumber === "...",
			className: footerPageNumbers({ isCurrentPage: pageNumber === currentPage }),
			onPress: () => onPageChange(+pageNumber),
			children: /* @__PURE__ */ jsx("div", {
				className: "text-body-2 text-neutral-700",
				children: pageNumber
			})
		}, `${pageNumber}-${i.toString()}`)),
		/* @__PURE__ */ jsx(Button, {
			className: "outline-none",
			isDisabled: isLastPage,
			onPress: () => onPageChange(currentPage + 1),
			children: /* @__PURE__ */ jsx(ChevronRightIcon, { className: "text-neutral-400" })
		})
	] });
}
function CursorPagination({ hasNextPage, hasPreviousPage, onPreviousPage = () => void 0, onNextPage = () => void 0, pageSize, total, currentPage }) {
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [
		!!(pageSize && currentPage && total) && /* @__PURE__ */ jsxs("div", {
			className: "text-body-2 text-neutral-500",
			children: [
				(currentPage - 1) * pageSize + 1,
				"-",
				!hasNextPage ? total : currentPage * pageSize,
				" of ",
				total
			]
		}),
		/* @__PURE__ */ jsx(Button, {
			className: "outline-none",
			isDisabled: !hasPreviousPage,
			onPress: onPreviousPage,
			children: /* @__PURE__ */ jsx(ChevronLeftIcon, { className: "text-neutral-400" })
		}),
		/* @__PURE__ */ jsx(Button, {
			className: "outline-none",
			isDisabled: !hasNextPage,
			onPress: onNextPage,
			children: /* @__PURE__ */ jsx(ChevronRightIcon, { className: "text-neutral-400" })
		})
	] });
}
const TableContent = ({ columns, data, emptyState, rowClassName, isLoading, theme = "light", layoutOptions = {
	headingHeight: 56,
	rowHeight: 56
}, virtualizedHeight, style, "aria-label": ariaLabel, ...props }) => {
	const isVirtualized = virtualizedHeight !== void 0;
	const normalizedStyle = isVirtualized ? {
		height: virtualizedHeight,
		overflow: "auto",
		width: "100%",
		...style
	} : style;
	const content = /* @__PURE__ */ jsxs(Table, {
		...props,
		"aria-label": ariaLabel ?? isVirtualized ? "Virtualized table" : void 0,
		className: cn("w-full", "border-collapse", isLoading && "pointer-events-none opacity-30"),
		style: normalizedStyle,
		children: [/* @__PURE__ */ jsx(TableHeader$1, {
			columns,
			theme,
			children: ({ name, ...columnProps }) => /* @__PURE__ */ jsx(Column$1, {
				...columnProps,
				theme,
				children: name
			})
		}), /* @__PURE__ */ jsx(TableBody, {
			items: data,
			renderEmptyState: () => emptyState,
			children: (item) => /* @__PURE__ */ jsx(Row$1, {
				className: rowClassName,
				columns,
				item,
				theme,
				isVirtualized
			})
		})]
	});
	return isVirtualized ? /* @__PURE__ */ jsx(Virtualizer, {
		layout: TableLayout,
		layoutOptions,
		children: content
	}) : content;
};
/**
* A Table is a collection of data displayed in a grid of uniform rows and columns.
*/
function Table$1({ data, columns, hideTotal = false, hidePagination = false, emptyState, total, currentPage, onPageChange = () => void 0, pageSize, onPageSizeChange, id, className, rowClassName, "data-testind": dataTestId, paginationVariant = "number", hasNextPage, hasPreviousPage, onNextPage, onPreviousPage, isLoading = false, theme = "light", ...props }) {
	const { container, tableBody, textcolor } = tableStyles({ theme });
	const sizeKeys = [
		"width",
		"defaultWidth",
		"minWidth",
		"maxWidth"
	];
	const isResizable = useMemo(() => columns.some((item) => sizeKeys.some((key) => key in item)), [columns]);
	return /* @__PURE__ */ jsxs("div", {
		id,
		className: container({ className }),
		"data-testid": dataTestId,
		children: [
			!hideTotal && /* @__PURE__ */ jsx("div", {
				className: "mb-4",
				children: /* @__PURE__ */ jsxs("div", {
					className: textcolor({ className: "text-body-1" }),
					children: [
						total,
						" ",
						total === 1 ? "item" : "items"
					]
				})
			}),
			/* @__PURE__ */ jsxs("div", {
				className: "relative max-h-full overflow-auto",
				children: [isLoading && /* @__PURE__ */ jsx("div", {
					className: "absolute bottom-0 left-0 right-0 top-0 z-10 grid content-center justify-center",
					children: /* @__PURE__ */ jsx(Spinner, {})
				}), /* @__PURE__ */ jsx("div", {
					className: "h-full overflow-auto rounded-lg",
					children: /* @__PURE__ */ jsx("div", {
						className: tableBody(),
						children: isResizable ? /* @__PURE__ */ jsx(ResizableTableContainer, { children: /* @__PURE__ */ jsx(TableContent, {
							columns,
							isLoading,
							theme,
							data,
							emptyState,
							rowClassName,
							...props
						}) }) : /* @__PURE__ */ jsx(TableContent, {
							columns,
							theme,
							data,
							emptyState,
							isLoading,
							rowClassName,
							...props
						})
					})
				})]
			}),
			!hidePagination && /* @__PURE__ */ jsxs(TableFooter, {
				pageSize,
				onPageSizeChange,
				children: [paginationVariant === "number" && /* @__PURE__ */ jsx(NumberPagination, {
					total,
					currentPage,
					onPageChange,
					pageSize
				}), paginationVariant === "cursor" && /* @__PURE__ */ jsx(CursorPagination, {
					onNextPage,
					onPreviousPage,
					hasNextPage,
					hasPreviousPage,
					currentPage,
					total,
					pageSize
				})]
			})
		]
	});
}
//#endregion
//#region src/negroni/Tabs/Tabs.tsx
/** Styles for individual tabs (as opposed to TabPanels) */
const tabStyles = tv({
	slots: {
		tab: "relative cursor-pointer rounded-tl-lg rounded-tr-lg px-6 py-2 outline-none after:absolute",
		content: "flex w-full items-center justify-center gap-2 overflow-hidden whitespace-nowrap"
	},
	variants: { variant: {
		folder: { tab: "border-b-0 border-l border-r border-t border-neutral-200 bg-surface-4 transition-colors after:inset-1 aria-selected:border-neutral-0 aria-selected:bg-neutral-0 data-[hovered]:bg-neutral-200 data-[focus-visible]:after:block data-[focus-visible]:after:rounded data-[focus-visible]:after:border-2 data-[focus-visible]:after:border-kbf aria-selected:data-[hovered]:bg-neutral-0" },
		underline: { tab: "aria-selected:font-semibold data-[hovered]:after:inset-0 data-[hovered]:after:border-b-[3px] data-[hovered]:after:border-b-neutral-300 motion-safe:transition-all" }
	} },
	defaultVariants: { variant: "folder" }
});
const TabContext = createContext({});
function Title({ children }) {
	return /* @__PURE__ */ jsx("div", {
		className: "mb-1 text-title-2 font-semibold",
		children
	});
}
function Description({ children }) {
	return /* @__PURE__ */ jsx("div", {
		className: "mb-4 text-body-1 text-content-2",
		children
	});
}
function Actions({ type, theme, primary, children }) {
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [primary && /* @__PURE__ */ jsx("span", {
		className: "mr-2",
		children: /* @__PURE__ */ jsx(Button$1, {
			variant: type,
			color: theme,
			className: "font-semibold",
			...primary
		})
	}), children] });
}
function TabBody({ children, id, "data-testid": dataTestId, className }) {
	const { title, description, actions } = getChildrenBySlots(children, {
		title: Title,
		description: Description,
		actions: Actions
	});
	return /* @__PURE__ */ jsxs("div", {
		id,
		"data-testid": dataTestId,
		className: cx("max-w-480", className),
		children: [
			title,
			description,
			actions
		]
	});
}
function TabContent({ id, "data-testid": dataTestId, children, className }) {
	return /* @__PURE__ */ jsx(TabPanel, {
		id,
		"data-testid": dataTestId,
		className: cx("rounded-bl-lg rounded-br-lg rounded-tr-lg outline-none ring-inset data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf", className),
		children
	});
}
function Tab$1({ id, icon: Icon, children, variant: propVariant, "data-testid": dataTestId, className }) {
	const { variant: ctxVariant } = useContext(TabContext);
	const variant = propVariant ?? ctxVariant;
	const { tab: tabStyle, content: contentStyle } = tabStyles({ variant });
	const content = /* @__PURE__ */ jsxs(Fragment$1, { children: [Icon && /* @__PURE__ */ jsx(Icon, {
		size: "sm",
		className: "flex-shrink-0"
	}), children || /* @__PURE__ */ jsx("div", {
		className: "text-body-1",
		children: id
	})] });
	return /* @__PURE__ */ jsxs(Tab, {
		id,
		"data-testid": dataTestId,
		className: tabStyle({ className }),
		"data-variant": variant,
		children: [variant === "underline" && /* @__PURE__ */ jsx("div", {
			className: contentStyle({ className: "invisible font-semibold" }),
			children: content
		}), /* @__PURE__ */ jsx("div", {
			className: contentStyle({ className: variant === "underline" && "absolute left-0 top-0 h-full w-full px-6 py-2" }),
			children: content
		})]
	}, id);
}
/**
* Animated underline and accompanying focus-visible box for variant=underline
* @internal
*/
const TabUnderline = ({ containerRef }) => {
	const selectedKey = useContext(TabListStateContext)?.selectedKey;
	if (!containerRef.current?.querySelector("[data-variant=underline]")) return null;
	const activeTab = containerRef.current?.querySelector(selectedKey ? `[data-key=${selectedKey}]` : "[role=tab]");
	const activeTabDimensions = activeTab ? {
		x: activeTab.offsetLeft,
		w: activeTab.clientWidth,
		h: activeTab.clientHeight
	} : {
		x: 0,
		w: 0,
		h: 0
	};
	return /* @__PURE__ */ jsxs(Fragment$1, { children: [/* @__PURE__ */ jsx("span", {
		className: "invisible absolute h-[3px] rounded border-2 border-kbf ease-out group-has-[[data-focus-visible=true]]/tabs:visible motion-safe:transition-[left,width] motion-safe:duration-300",
		style: {
			top: 4,
			left: activeTabDimensions.x + 4,
			width: activeTabDimensions.w - 8,
			height: activeTabDimensions.h - 8
		}
	}), /* @__PURE__ */ jsx("span", {
		className: "absolute bottom-0 h-[3px] bg-black ease-out motion-safe:transition-all motion-safe:duration-300",
		style: {
			left: activeTabDimensions.x,
			width: activeTabDimensions.w
		}
	})] });
};
/**
*
* Tabs organize content into multiple sections and allow users to navigate between them.
*
*
* Tabs is composed the following sub components.
*
* ```
* <Tab />
* <TabContent />
* <TabBody />
* <TabBody.Title />
* <TabBody.Description />
* <TabBody.Actions />
* ```
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?node-id=21515%3A11920&mode=dev)
*
* [RAC Tabs](https://react-spectrum.adobe.com/react-aria/Tabs.html#tabs)
*
* @see {@link https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/negroni-tabs--docs | Storybook} for more detailed usage and examples
*/
function Tabs$1({ onSelect, defaultSelectedId, selectedId, children, id, "data-testid": dataTestId, className, variant }) {
	const { tabRow, content } = getChildrenBySlots(children, {
		tabRow: Tab$1,
		content: TabContent
	});
	const ctxVal = useMemo(() => ({ variant }), [variant]);
	const tabListRef = useRef(null);
	return /* @__PURE__ */ jsx(TabContext.Provider, {
		value: ctxVal,
		children: /* @__PURE__ */ jsxs(Tabs, {
			defaultSelectedKey: defaultSelectedId,
			selectedKey: selectedId,
			onSelectionChange: (key) => onSelect?.(`${key}`),
			id,
			"data-testid": dataTestId,
			className,
			children: [/* @__PURE__ */ jsxs("div", {
				className: "group/tabs relative overflow-auto scroll-smooth [-ms-overflow-style:none] [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
				children: [/* @__PURE__ */ jsx(TabList, {
					className: "flex",
					ref: tabListRef,
					children: tabRow
				}), /* @__PURE__ */ jsx(TabUnderline, { containerRef: tabListRef })]
			}), content]
		})
	});
}
TabBody.Title = Title;
TabBody.Description = Description;
TabBody.Actions = Actions;
//#endregion
//#region src/negroni/TextArea/TextArea.tsx
const textArea = tv({
	extend: inputStyles,
	slots: {
		container: "group",
		div: "w-full rounded-lg border border-solid border-neutral-100 bg-neutral-0 px-3 py-4 text-body-1 text-neutral-800 transition-[filter,border-color,box-shadow] placeholder:text-neutral-300 focus-within:border-neutral-800 focus-within:outline-none focus-within:drop-shadow-none disabled:border-neutral-300 group-data-[disabled]:bg-neutral-50",
		area: "w-full outline-none focus:outline-none active:outline-none"
	},
	variants: {
		isResizable: {
			true: { area: "" },
			false: { area: "resize-none" }
		},
		error: {
			true: {
				div: "border-error-500 bg-error-25",
				area: "bg-error-25"
			},
			false: { div: "" }
		}
	},
	defaultVariants: { isResizable: false }
});
/**
* A TextArea is a multi-line text input field.
*/
const TextArea$1 = forwardRef((props, ref) => {
	const { label, secondaryLabel, secondaryHref, secondaryClassName, onSecondaryClick, onChange, name, minLength, maxLength, rows, errorMessage, description, isResizable, className, onBlur, isInvalid, value, required, ...restProps } = props;
	const [inputValue, setInputValue] = useState(value?.toString() ?? "");
	const handleInputChange = (e) => {
		const { value: targetValue } = e.target;
		setInputValue(targetValue);
		if (onChange) onChange(e);
	};
	useEffect(() => {
		setInputValue(value || "");
	}, [value]);
	const charCount = maxLength ? inputValue.length : void 0;
	const { container, div, area, errorMessage: errorStyles, description: descriptionStyles } = textArea({ error: Boolean(errorMessage || isInvalid) });
	return /* @__PURE__ */ jsxs(TextField, {
		...restProps,
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		className: container({ className }),
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsxs("div", {
				className: div(),
				children: [/* @__PURE__ */ jsx(TextArea, {
					ref,
					id: name,
					name,
					rows,
					minLength,
					value: inputValue,
					maxLength,
					onChange: (e) => handleInputChange(e),
					onBlur: (e) => onBlur?.(e),
					required,
					className: area({ isResizable })
				}), maxLength && /* @__PURE__ */ jsx("div", {
					className: "flex w-full text-neutral-400",
					children: /* @__PURE__ */ jsxs("div", {
						className: "ml-auto self-end",
						children: [
							charCount,
							"/",
							maxLength
						]
					})
				})]
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: descriptionStyles(),
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: errorStyles(),
				children: errorMessage
			})
		]
	});
});
TextArea$1.displayName = "TextArea";
//#endregion
//#region src/negroni/TimeField/TimeField.tsx
/**
* A time field allows users to enter and edit time values using a keyboard. Each part of a time value is displayed in an individually editable segment.
*
* [Figma](https://www.figma.com/design/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?node-id=20133-231854&t=u6vZA1oUgMiDIl91-11)
*
* [RAC TimeField](https://react-spectrum.adobe.com/react-aria/TimeField.html)
*
* See [Storybook](https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/docs/experimental-timefield--docs) for more detailed usage and examples.
*
*/
function TimeField$1({ description, errorMessage, className, label, isInvalid, secondaryLabel, secondaryClassName, secondaryHref, onSecondaryClick, ...restProps }) {
	return /* @__PURE__ */ jsxs(TimeField, {
		className: cx("flex flex-col gap-1", className),
		isInvalid: isInvalid ?? (typeof errorMessage === "string" && errorMessage.length > 0) ? true : void 0,
		...restProps,
		children: [
			/* @__PURE__ */ jsx(FieldLabels, {
				label,
				secondaryLabel,
				secondaryClassName,
				secondaryHref,
				onSecondaryClick
			}),
			/* @__PURE__ */ jsx(DateInput, {
				className: "relative flex h-12 w-full items-center rounded-md border border-neutral-100 bg-neutral-0 px-3 text-body-1 text-neutral-600 focus-within:border-black focus-within:text-black data-[disabled]:border-neutral-300 data-[invalid]:border-error data-[disabled]:bg-neutral-100 data-[invalid]:bg-error-25 data-[disabled]:text-neutral-300",
				children: (segment) => /* @__PURE__ */ jsx(DateSegment, {
					className: "rounded-md p-1 text-end text-body-1 outline-none data-[type='timeZoneName']:cursor-default data-[focused]:bg-accent1-200 data-[type='timeZoneName']:data-[focused]:bg-neutral-0 data-[type='timeZoneName']:before:mr-4 data-[type='timeZoneName']:before:content-['|']",
					segment
				})
			}),
			description && /* @__PURE__ */ jsx(Text, {
				slot: "description",
				className: "text-footnote",
				children: description
			}),
			/* @__PURE__ */ jsx(FieldError, {
				className: "text-footnote text-error",
				children: errorMessage
			})
		]
	});
}
//#endregion
//#region src/negroni/Toastery/ToastBar.tsx
const styles$1 = tv({
	slots: {
		container: "relative mt-2 flex w-full items-center justify-between rounded-lg border p-4 text-sm shadow-level-3 outline-none",
		icon: "shrink-0"
	},
	variants: { variant: {
		neutral: {
			container: "items-center border-neutral-100 bg-neutral-25 text-neutral-800",
			icon: "text-neutral-800"
		},
		info: {
			container: "border-accent3-200 bg-accent3-100 text-accent3-800",
			icon: "text-accent3-500"
		},
		success: {
			container: "border-success-200 bg-success-50 text-success-800",
			icon: "text-success-500"
		},
		warning: {
			container: "border-accent1-400 bg-accent1-200 text-accent1-900",
			icon: "text-accent1-500"
		},
		error: {
			container: "border-error-200 bg-error-50 text-error-800",
			icon: "text-error-500"
		}
	} },
	defaultVariants: {
		position: "bottom",
		variant: "neutral"
	}
});
const toastIcons = {
	info: InfoIcon,
	success: CheckCircleIcon,
	warning: AlertTriangleIcon,
	error: AlertTriangleIcon
};
function ToastBar(props) {
	const { variant = "neutral", title, description, action } = props.toast.content;
	const { container, icon } = styles$1({ variant });
	const initialY = useReducedMotion() ? 0 : props.position === "top" ? -20 : 20;
	const toastRef = useRef(null);
	const { toastProps, titleProps, descriptionProps, closeButtonProps } = useToast(props, props.state, toastRef);
	const DynamicIcon = variant !== "neutral" && toastIcons[variant];
	const handleActionPress = (e) => {
		action?.onPress?.(e);
		if (action?.closeOnAction) props.state.close(props.toast.key);
	};
	return /* @__PURE__ */ jsx(motion.div, {
		layout: true,
		initial: {
			opacity: 0,
			y: initialY
		},
		animate: {
			opacity: 1,
			y: 0,
			transition: { ease: "easeOut" }
		},
		exit: {
			opacity: 0,
			y: initialY,
			transition: { ease: "easeIn" }
		},
		transition: { duration: .15 },
		children: /* @__PURE__ */ jsx("div", {
			...toastProps,
			ref: toastRef,
			className: container({ className: description && "items-start" }),
			children: /* @__PURE__ */ jsxs("div", {
				className: "flex flex-grow items-start justify-between",
				children: [/* @__PURE__ */ jsxs("div", {
					className: cn(action && "p-1", "flex items-start gap-2"),
					children: [DynamicIcon && /* @__PURE__ */ jsx(DynamicIcon, { className: icon() }), /* @__PURE__ */ jsxs("div", {
						className: "flex flex-col gap-2",
						children: [/* @__PURE__ */ jsx("div", {
							...titleProps,
							className: cn(description && "font-semibold", "w-full text-body-1"),
							children: title
						}), description && /* @__PURE__ */ jsx("div", {
							...descriptionProps,
							className: "text-body-2",
							children: description
						})]
					})]
				}), /* @__PURE__ */ jsxs("div", {
					className: "flex items-center justify-center gap-2",
					children: [action && /* @__PURE__ */ jsx(Button$1, {
						color: "neutral",
						size: "sm",
						onPress: handleActionPress,
						children: action.label
					}), !action?.closeOnAction && /* @__PURE__ */ jsx(Button, {
						...closeButtonProps,
						className: "outline-none data-[focus-visible]:ring-2 data-[focus-visible]:ring-kbf",
						children: /* @__PURE__ */ jsx(XIcon, {})
					})]
				})]
			})
		})
	});
}
//#endregion
//#region src/negroni/Toastery/toastQueue.ts
const toastQueue = new ToastQueue({ maxVisibleToasts: 5 });
//#endregion
//#region src/negroni/Toastery/Toaster.tsx
const styles = tv({
	base: "fixed z-50 flex w-full flex-col-reverse px-4 md:w-[480px] md:px-0",
	variants: { position: {
		"top-right": "top-4 flex-col md:right-4",
		"top-left": "top-4 flex-col md:left-4",
		"top-center": "top-4 transform flex-col md:left-1/2 md:-translate-x-1/2",
		"bottom-right": "bottom-4 md:right-4",
		"bottom-left": "bottom-4 md:left-4",
		"bottom-center": "bottom-4 transform md:left-1/2 md:-translate-x-1/2"
	} },
	defaultVariants: { position: "bottom-right" }
});
function Toaster(props) {
	const state = useToastQueue(toastQueue);
	const ref = useRef(null);
	const { regionProps } = useToastRegion(props, state, ref);
	const [isPortalOpen, setIsPortalOpen] = useState(false);
	const closePortalIfEmpty = () => {
		if (state.visibleToasts.length === 0) setIsPortalOpen(false);
	};
	useEffect(() => {
		if (state.visibleToasts.length > 0) setIsPortalOpen(true);
	}, [state.visibleToasts]);
	const getAnimationPosition = () => props.position?.includes("top") ? "top" : "bottom";
	return /* @__PURE__ */ jsx(Fragment$1, { children: isPortalOpen && createPortal(/* @__PURE__ */ jsx("div", {
		...regionProps,
		ref,
		className: styles({ position: props.position }),
		children: /* @__PURE__ */ jsx(AnimatePresence, {
			onExitComplete: closePortalIfEmpty,
			mode: "sync",
			children: state.visibleToasts.map((t) => /* @__PURE__ */ jsx(ToastBar, {
				toast: t,
				state,
				position: getAnimationPosition()
			}, t.key))
		})
	}), document.body) });
}
//#endregion
//#region src/negroni/Toastery/useToast.ts
const useToast$1 = () => {
	const queue = toastQueue;
	const add = (toast) => {
		return queue.add({ ...toast }, {
			onClose: toast.onClose,
			timeout: toast.autoDismiss === false ? void 0 : 5e3
		});
	};
	const toast = (title, options) => {
		const { variant = "neutral", ...rest } = options || {};
		return add({
			title,
			variant,
			...rest
		});
	};
	toast.success = (title, options) => {
		return toast(title, {
			...options,
			variant: "success"
		});
	};
	toast.info = (title, options) => {
		return toast(title, {
			...options,
			variant: "info"
		});
	};
	toast.warning = (title, options) => {
		return toast(title, {
			...options,
			variant: "warning"
		});
	};
	toast.error = (title, options) => {
		return toast(title, {
			...options,
			variant: "error"
		});
	};
	toast.close = (key) => {
		if (key) queue.close(key);
	};
	return toast;
};
//#endregion
//#region src/negroni/ToggleButton/ToggleButton.tsx
const toggleButtonStyles = tv({
	base: "flex items-center justify-center gap-2 rounded-lg border border-neutral-100 bg-neutral-25 font-base font-semibold outline-none transition-all data-[disabled]:border-none data-[hovered]:border-neutral-200 data-[selected]:border-neutral-200 data-[hovered]:bg-neutral-100 data-[pressed]:bg-neutral-200 data-[selected]:bg-neutral-200 data-[disabled]:text-neutral-400 data-[hovered]:shadow-level-2 data-[focus-visible]:outline data-[focus-visible]:outline-kbf",
	variants: { size: {
		sm: "h-8 px-3",
		md: "h-12 px-5",
		lg: "h-14 px-6"
	} },
	defaultVariants: { size: "sm" }
});
/**
* A toggle button allows a user to toggle a selection on or off, for example switching between two states or modes.
*
* [Figma](https://www.figma.com/file/sQ09lDNJKnMH7ammSgZNMp/Negroni-Library?type=design&node-id=22803-57704&mode=design&t=BLw0o2UDOsYVSbv9-0)
*
* [RAC ToggleButton](https://react-spectrum.adobe.com/react-aria/ToggleButton.html)
*
* @see {@link https://storybook.my-account-rex.dev.aws-01.legalzoom.com/?path=/story/negroni-togglebutton--default | Storybook } for more detailed usage and examples.
*
*/
const ToggleButton$1 = forwardRef(({ children, className, size, leftIcon: LeftIcon, rightIcon: RightIcon, ...props }, ref) => {
	return /* @__PURE__ */ jsxs(ToggleButton, {
		ref,
		className: toggleButtonStyles({
			size,
			className
		}),
		...props,
		children: [
			LeftIcon && /* @__PURE__ */ jsx(LeftIcon, { size: "sm" }),
			children,
			RightIcon && /* @__PURE__ */ jsx(RightIcon, { size: "sm" })
		]
	});
});
ToggleButton$1.displayName = "ToggleButton";
//#endregion
//#region src/negroni/Transition/Transition.tsx
/**
* Component for managing Tailwind-based enter/exit transitions.
* Wrap elements in the `Transition` component to apply these transitions on enter/exit.
*
* See [HeadlessUI Docs](https://headlessui.com/react/transition) for detailed documentation.
*/
function Transition$1({ children, className, ...restProps }) {
	return /* @__PURE__ */ jsx(Transition, {
		className,
		...restProps,
		children
	});
}
//#endregion
export { gridListStyles as $, cx as $t, progressBarStyles as A, getChildrenBySlots as At, Footer as B, avatarStyles as Bt, useRichTextEditorContext as C, selectStyles as Ct, Radio$1 as D, FieldLabels as Dt, extractTextFromJsonText as E, listBoxStyles as Et, NumberInput as F, Link$1 as Ft, Container as G, createOverlayOpenEvent as Gt, HeaderActionButton as H, ActionGroup as Ht, numberInputStyles as I, buttonLinkStyles as It, ListCell as J, buttonStyles as Jt, ContainerContext as K, Button$1 as Kt, NotificationWrapper as L, textLinkStyles as Lt, PanelContainer as M, BulletListStyles as Mt, Panel as N, Breadcrumbs$1 as Nt, RadioGroup$1 as O, Checkbox$1 as Ot, PanelContext as P, Banner as Pt, GridListItem$1 as Q, cn as Qt, Modal$1 as R, AvatarStack as Rt, RichTextEditor as S, Select$1 as St, RichTextOutputWrapper as T, ListBoxItem$1 as Tt, HeaderContext as U, Dropdown as Ut, Header$1 as V, AttentionBox as Vt, Content as W, Popover$1 as Wt, inputStyles as X, PopoverWrapper as Xt, Input$1 as Y, Tooltip$1 as Yt, GridList$1 as Z, popoverAnimationClasses as Zt, RemovableSelectionGroupContext as _, useCarouselContext as _t, useToast$1 as a, badgeStyles as an, BreakpointWidths as at, SelectionCellGroup as b, Card as bt, TextArea$1 as c, Combobox as ct, TabBody as d, ColorSwatchPickerItem$1 as dt, getPageNumbers as en, FileDropZone as et, TabContent as f, ColorPicker$1 as ft, Skeleton as g, CarouselProvider as gt, Switch$1 as h, CarouselContext as ht, toggleButtonStyles as i, Badge as in, DatePicker$1 as it, PhoneInput as j, BulletList as jt, ProgressBar$1 as k, checkboxStyles as kt, textArea as l, comboboxStyles as lt, Table$1 as m, Carousel as mt, Transition$1 as n, Accordion as nn, DateRangePicker$1 as nt, Toaster as o, Logo as on, COLORS as ot, Tabs$1 as p, CheckboxGroup$1 as pt, Growth as q, ButtonContext as qt, ToggleButton$1 as r, AccordionItem as rn, RangeCalendar$1 as rt, TimeField$1 as s, SIZES as st, RouterProvider as t, Spinner as tn, FileSelect as tt, Tab$1 as u, ColorSwatchPicker$1 as ut, SelectionGroup as v, PaginationDots as vt, RichTextOutputRenderer as w, ListBox$1 as wt, SelectionCell as x, Calendar$1 as xt, SelectionItem as y, PageCounter as yt, Sheet as z, Avatar as zt };

//# sourceMappingURL=negroni-Cb3a5kWy.mjs.map